import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const BoxArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 000 4.6v.93a3.5 3.5 0 01-.8-.21l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18zm16 0v4.08a5.48 5.48 0 00-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-6.86l2 2a.5.5 0 11-.7.71L15 13.71v2.79a.5.5 0 01-1 0v-2.8l-1.15 1.15a.5.5 0 11-.7-.7l2-2a.5.5 0 01.35-.15.5.5 0 01.35.14z",
    fill: primaryFill
  }));
};

export const BoxArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowUpFilledIcon({}), 'BoxArrowUpFilled');

const BoxArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 01-.62-1.06 2.5 2.5 0 01-.39-.12l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm8.13 14.5a4.5 4.5 0 100-8.99 4.5 4.5 0 000 9zm.35-6.85l2 2a.5.5 0 11-.7.71L15 13.71v2.79a.5.5 0 01-1 0v-2.8l-1.15 1.15a.5.5 0 11-.7-.7l2-2a.5.5 0 01.35-.15.5.5 0 01.35.14z",
    fill: primaryFill
  }));
};

export const BoxArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowUpRegularIcon({}), 'BoxArrowUpRegular');

const BoxCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 000 4.6v.93a3.5 3.5 0 01-.8-.21l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18zm16 0v4.08a5.48 5.48 0 00-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1-3.7l2.65-2.65a.5.5 0 01.7.7l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64z",
    fill: primaryFill
  }));
};

export const BoxCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxCheckmarkFilledIcon({}), 'BoxCheckmarkFilled');

const BoxCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 01-.62-1.06 2.5 2.5 0 01-.39-.12l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm8.13 14.5a4.5 4.5 0 100-8.99 4.5 4.5 0 000 9zm-1-3.7l2.65-2.64a.5.5 0 01.7.7l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64z",
    fill: primaryFill
  }));
};

export const BoxCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxCheckmarkRegularIcon({}), 'BoxCheckmarkRegular');

const BoxDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.26.1.53.17.8.21v-.94a5.48 5.48 0 010-4.58V8.84L2.04 5.85zM18 6.17v4.08a5.48 5.48 0 00-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33zm1 8.32a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const BoxDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxDismissFilledIcon({}), 'BoxDismissFilled');

const BoxDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 01-.62-1.06 2.51 2.51 0 01-.39-.12l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v3.37c.25-.55.6-1.05 1-1.49V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const BoxDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxDismissRegularIcon({}), 'BoxDismissRegular');

const BoxEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.37-1.49.07-.23V8.84L2.04 5.85zM18 6.17v2.95a2.87 2.87 0 00-2.9.71l-4.6 4.6v-5.6l7.46-2.99c.03.1.04.22.04.33zm-7.02 9.2l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const BoxEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxEditFilledIcon({}), 'BoxEditFilled');

const BoxEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.24-.97a2.53 2.53 0 01-.23-.08l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v7.08c.16-.47.42-.9.77-1.25l.23-.23v-5.6l6.5-2.6V9c.34-.01.68.03 1 .13V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm4.61 10.89l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const BoxEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxEditRegularIcon({}), 'BoxEditRegular');

const BoxMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34A2.5 2.5 0 0114 10.1v4.78c0 .2-.03.4-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zM6.42 7.38a3 3 0 012.16 0l3.46 1.33c.58.22.96.78.96 1.4v4.78a1.5 1.5 0 01-.96 1.4l-3.46 1.33a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33zm4.67 2.91a.5.5 0 00-.64-.28L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.8-1.07a.5.5 0 00.3-.65z",
    fill: primaryFill
  }));
};

export const BoxMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleFilledIcon({}), 'BoxMultipleFilled');

const BoxMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.71A1.5 1.5 0 007 5.11v1.1a4 4 0 011 0v-1.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47v7.78c0 .2-.13.4-.32.47L14 14.39v.5c0 .2-.03.4-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.11a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm2.51 2.92a.5.5 0 00-.64-.3l-2.77 1.07a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 10-.35.93l2.76 1.07c.35.13.73.13 1.08 0l2.76-1.07a.5.5 0 00.3-.64zm-5 5a.5.5 0 00-.64-.3L7.5 11.15l-2.95-1.13a.5.5 0 00-.35.93L7 12.02v2.49a.5.5 0 101 0v-2.49l2.8-1.08a.5.5 0 00.3-.64zM8.58 7.38a3 3 0 00-2.16 0L2.96 8.71a1.5 1.5 0 00-.96 1.4v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 002.16 0l3.46-1.33c.58-.22.96-.78.96-1.4v-4.78a1.5 1.5 0 00-.96-1.4L8.58 7.38zm-1.8.93a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47v4.78c0 .2-.13.4-.32.47l-3.46 1.33a2 2 0 01-1.44 0l-3.46-1.33a.5.5 0 01-.32-.47v-4.78c0-.2.13-.4.32-.47l3.46-1.33z",
    fill: primaryFill
  }));
};

export const BoxMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleRegularIcon({}), 'BoxMultipleRegular');

const BoxMultipleArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 014.24 1.2V5.12a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 00-.6-.2L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.09-.8a5.48 5.48 0 00-.39 5.98l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 100-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowLeftFilledIcon({}), 'BoxMultipleArrowLeftFilled');

const BoxMultipleArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 00-.12-.07L8.22 8.31a2 2 0 00-1.44 0L3.32 9.64a.5.5 0 00-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 001.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zm-1.6 1.3a.5.5 0 01.61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10zm5.65-4.72a.5.5 0 00-.64-.28l-2.77 1.06a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 00-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.34a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 100-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowLeftRegularIcon({}), 'BoxMultipleArrowLeftRegular');

const BoxMultipleArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 014.24 1.2V5.12a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 00-.6-.2L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.09-.8a5.48 5.48 0 00-.39 5.98l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowRightFilledIcon({}), 'BoxMultipleArrowRightFilled');

const BoxMultipleArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 00-.12-.07L8.22 8.31a2 2 0 00-1.44 0L3.32 9.64a.5.5 0 00-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 001.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zm-1.6 1.3a.5.5 0 01.61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10zm5.65-4.72a.5.5 0 00-.64-.28l-2.77 1.06a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 00-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.36a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowRightRegularIcon({}), 'BoxMultipleArrowRightRegular');

const BoxMultipleCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 014.24 1.2V5.12a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 00-.6-.2L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.09-.8a5.48 5.48 0 00-.39 5.98l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const BoxMultipleCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleCheckmarkFilledIcon({}), 'BoxMultipleCheckmarkFilled');

const BoxMultipleCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 00-.12-.07L8.22 8.31a2 2 0 00-1.44 0L3.32 9.64a.5.5 0 00-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 001.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zm-1.6 1.3a.5.5 0 01.61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10zm5.65-4.72a.5.5 0 00-.64-.28l-2.77 1.06a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 00-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.84a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const BoxMultipleCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleCheckmarkRegularIcon({}), 'BoxMultipleCheckmarkRegular');

const BoxMultipleSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.42 2.38a3 3 0 012.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78c0 .07 0 .15-.02.22A4.5 4.5 0 0013.74 9a2.5 2.5 0 00-1.34-1.23L8.94 6.44A4 4 0 007 6.21V5.1c0-.62.38-1.18.96-1.4l3.46-1.33zm4.67 2.44a.5.5 0 00-.64-.29L12.68 5.6a.5.5 0 01-.36 0L9.55 4.53a.5.5 0 00-.35.94l2.76 1.06c.35.13.73.13 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM12.6 9.09a1.5 1.5 0 00-.56-.38L8.58 7.38a3 3 0 00-2.16 0L2.96 8.7A1.5 1.5 0 002 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 002.16 0l1.94-.75a4.49 4.49 0 01-1.02-5.43l-1.5.58v2.49a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10a.5.5 0 01.25-.03c.54-.44 1.2-.75 1.9-.9zm3.7 6.5a3.5 3.5 0 10-.7.7l2.55 2.56a.5.5 0 00.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxMultipleSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleSearchFilledIcon({}), 'BoxMultipleSearchFilled');

const BoxMultipleSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.42 2.38a3 3 0 012.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78c0 .07 0 .15-.02.22a4.48 4.48 0 00-.98-2.44V5.11a.5.5 0 00-.32-.47l-3.46-1.33a2 2 0 00-1.44 0L8.32 4.64a.5.5 0 00-.32.47v1.1a4 4 0 00-1 0V5.1c0-.62.38-1.18.96-1.4l3.46-1.33zm1.18 6.7a1.5 1.5 0 00-.56-.37L8.58 7.38a3 3 0 00-2.16 0L2.96 8.7A1.5 1.5 0 002 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 002.16 0l1.94-.75c-.27-.23-.5-.5-.71-.8l-1.6.62a2 2 0 01-1.43 0l-3.46-1.33a.5.5 0 01-.32-.47V10.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.16 1.22c.38-.2.79-.35 1.22-.44zm-1.9.9a.5.5 0 00-.25.03L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l1.5-.57c.29-.57.7-1.07 1.2-1.46zM15.45 5a.5.5 0 11.35.93L13.04 7a1.5 1.5 0 01-1.08 0L9.2 5.94A.5.5 0 019.55 5l2.77 1.06a.5.5 0 00.36 0l2.77-1.06zm.85 10.59a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 00.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxMultipleSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleSearchRegularIcon({}), 'BoxMultipleSearchRegular');

const BoxSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 7.96l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.26.1.53.17.8.21v-2.17a4.48 4.48 0 010-4.12v-2.6L2.04 5.85zM18 13.42V6.18c0-.11-.01-.22-.04-.33L10.5 8.84v1.3a4.5 4.5 0 017.5 3.28zm-.58-8.44l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM16.3 15.6a3.5 3.5 0 10-.7.7l2.55 2.56a.5.5 0 10.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxSearchFilledIcon({}), 'BoxSearchFilled');

const BoxSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 002.6 0l.1-.04a4.51 4.51 0 01-.98-.7c-.32.1-.67.08-.98-.04l-.3-.12-.07-.03-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v2.6c.25-.5.6-.93 1-1.3v-1.3l6.5-2.6v4.43c.63.77 1 1.76 1 2.83V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm9.93 11.1a3.5 3.5 0 10-.7.7l2.55 2.56a.5.5 0 00.7-.7L16.3 15.6zM16 13.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxSearchRegularIcon({}), 'BoxSearchRegular');

const BoxToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1V13.5c0-.56.19-1.08.5-1.5V8.84L2.04 5.85zM18 6.17v4.87h-.04A2.5 2.5 0 0015.5 9h-2a2.5 2.5 0 00-2.46 2.04c-.19.04-.37.1-.54.17V8.84l7.46-2.99c.03.1.04.22.04.33zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0z",
    fill: primaryFill
  }));
};

export const BoxToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxToolboxFilledIcon({}), 'BoxToolboxFilled');

const BoxToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1v-1.06L3.31 14.3a.5.5 0 01-.31-.47V6.24l6.5 2.6V12c.26-.34.6-.62 1-.8V8.85l6.5-2.6V9.5c.5.37.84.91.96 1.54l.04.01V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm5.63 7.5v-.5c0-.82.67-1.49 1.5-1.49h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm3.5-1h-2a.5.5 0 00-.5.5v.5h3v-.5a.5.5 0 00-.5-.5zM17 16.5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0z",
    fill: primaryFill
  }));
};

export const BoxToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxToolboxRegularIcon({}), 'BoxToolboxRegular');

const BracesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.75 2.5A2.75 2.75 0 004 5.25v3.13c0 .4-.22.76-.57.94a.75.75 0 000 1.36c.35.18.57.54.57.94v3.13a2.75 2.75 0 002.75 2.75.75.75 0 000-1.5c-.69 0-1.25-.56-1.25-1.25v-3.13c0-.6-.21-1.17-.58-1.62.37-.45.58-1.02.58-1.62V5.25C5.5 4.56 6.06 4 6.75 4a.75.75 0 000-1.5zm6.5 0A2.75 2.75 0 0116 5.25v3.13c0 .4.22.76.57.94a.75.75 0 010 1.36c-.35.18-.57.54-.57.94v3.13a2.75 2.75 0 01-2.75 2.75.75.75 0 010-1.5c.69 0 1.25-.56 1.25-1.25v-3.13c0-.6.21-1.17.58-1.62a2.56 2.56 0 01-.58-1.62V5.25c0-.69-.56-1.25-1.25-1.25a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const BracesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesFilledIcon({}), 'BracesFilled');

const BracesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 3A2.5 2.5 0 004 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 000 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 006.5 17a.5.5 0 000-1A1.5 1.5 0 015 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C5 4.67 5.67 4 6.5 4a.5.5 0 000-1zm7 0A2.5 2.5 0 0116 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 010 .9 1.3 1.3 0 00-.72 1.17v2.88a2.5 2.5 0 01-2.5 2.5.5.5 0 010-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0115 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const BracesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesRegularIcon({}), 'BracesRegular');

const BracesVariableFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.75 2.5A2.75 2.75 0 003 5.25v3.13c0 .4-.22.76-.57.94a.75.75 0 000 1.36c.35.18.57.54.57.94v3.13a2.75 2.75 0 002.75 2.75.75.75 0 000-1.5c-.69 0-1.25-.56-1.25-1.25v-3.13c0-.6-.21-1.17-.58-1.62.37-.45.58-1.02.58-1.62V5.25C4.5 4.56 5.06 4 5.75 4a.75.75 0 000-1.5zm8.5 0A2.75 2.75 0 0117 5.25v3.13c0 .4.22.76.57.94a.75.75 0 010 1.36c-.35.18-.57.54-.57.94v3.13a2.75 2.75 0 01-2.75 2.75.75.75 0 010-1.5c.69 0 1.25-.56 1.25-1.25v-3.13c0-.6.21-1.17.58-1.62a2.56 2.56 0 01-.58-1.62V5.25c0-.69-.56-1.25-1.25-1.25a.75.75 0 010-1.5zM8.11 6.06a.75.75 0 10-1.22.88L9.08 10l-2.19 3.06a.75.75 0 001.22.88L10 11.29l1.89 2.65a.75.75 0 001.22-.88L10.92 10l2.19-3.06a.75.75 0 00-1.22-.88L10 8.71 8.11 6.06z",
    fill: primaryFill
  }));
};

export const BracesVariableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesVariableFilledIcon({}), 'BracesVariableFilled');

const BracesVariableRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 000 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 005.5 17a.5.5 0 000-1A1.5 1.5 0 014 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C4 4.67 4.67 4 5.5 4a.5.5 0 000-1zm9 0A2.5 2.5 0 0117 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 010 .9 1.3 1.3 0 00-.72 1.17v2.88a2.5 2.5 0 01-2.5 2.5.5.5 0 010-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0116 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 010-1zM7.9 6.2a.5.5 0 00-.8.6L9.38 10l-2.3 3.2a.5.5 0 00.82.6L10 10.85l2.1 2.93a.5.5 0 00.8-.58L10.62 10l2.3-3.2a.5.5 0 10-.82-.6L10 9.15 7.9 6.21z",
    fill: primaryFill
  }));
};

export const BracesVariableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesVariableRegularIcon({}), 'BracesVariableRegular');

const BrainCircuitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.13 2.8A3.9 3.9 0 018.5 2a.9.9 0 01.54.21c.13.1.24.22.35.35.07.09.11.2.11.32V6.5H8.41a1.5 1.5 0 100 1H9.5v9.42a.5.5 0 01-.18.38c-.47.38-1.08.7-1.82.7-1.19 0-2.07-.6-2.64-1.31a4.06 4.06 0 01-.82-1.76c-.33-.08-.7-.25-1.05-.55A3 3 0 012 12c0-.56.04-1.06.12-1.5h3.13c.64 0 1.16.47 1.24 1.09a1.5 1.5 0 101 0A2.25 2.25 0 005.25 9.5h-2.8a1.9 1.9 0 01.83-.85c-.29-.83-.21-1.8.06-2.57.18-.49.45-.96.84-1.27.25-.2.55-.34.88-.36.14-.68.55-1.25 1.07-1.66zm4.37 11.7h.75c1.24 0 2.25-1 2.25-2.25v-1.84a1.5 1.5 0 10-1 0v1.84c0 .69-.56 1.25-1.25 1.25h-.75V2.88a.5.5 0 01.11-.32c.1-.13.22-.25.35-.35A.9.9 0 0111.5 2c.85 0 1.71.28 2.37.8.52.4.93.97 1.07 1.65.33.02.63.16.88.36.39.31.66.78.84 1.27.27.77.35 1.74.06 2.57l.21.12c.28.19.49.45.64.76.3.6.43 1.44.43 2.47a3 3 0 01-.99 2.38c-.34.3-.72.47-1.05.55-.1.56-.38 1.2-.82 1.76A3.34 3.34 0 0112.5 18c-.74 0-1.35-.32-1.82-.7a.5.5 0 01-.18-.38V14.5zM7 6.5a.5.5 0 100 1 .5.5 0 000-1zm0 6a.5.5 0 100 1 .5.5 0 000-1zm6-3a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const BrainCircuitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrainCircuitFilledIcon({}), 'BrainCircuitFilled');

const BrainCircuitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.13 2.8A3.9 3.9 0 018.5 2a1.76 1.76 0 011.5.78A1.76 1.76 0 0111.5 2c.85 0 1.71.28 2.37.8.52.4.93.97 1.07 1.65.33.02.63.16.88.36.39.31.66.78.84 1.27.27.77.35 1.74.06 2.57l.21.12c.28.19.49.45.64.76.3.6.43 1.44.43 2.47a3 3 0 01-.99 2.38c-.34.3-.72.47-1.05.55-.1.56-.38 1.2-.82 1.76A3.34 3.34 0 0112.5 18c-.94 0-1.69-.52-2.17-1.03a4.25 4.25 0 01-.33-.38c-.1.12-.2.25-.33.38A3.06 3.06 0 017.5 18c-1.19 0-2.07-.6-2.64-1.31a4.06 4.06 0 01-.82-1.76c-.33-.08-.7-.25-1.05-.55A3 3 0 012 12c0-1.03.13-1.87.43-2.47a1.91 1.91 0 01.85-.88c-.29-.83-.21-1.8.06-2.57.18-.49.45-.96.84-1.27.25-.2.55-.34.88-.36.14-.68.55-1.25 1.07-1.66zM9.5 4.5V4.5a1.78 1.78 0 00-.02-.24 2.58 2.58 0 00-.14-.57c-.07-.2-.17-.38-.3-.5A.76.76 0 008.5 3c-.65 0-1.29.22-1.76.58C6.28 3.94 6 4.43 6 5a.5.5 0 01-.66.47c-.19-.06-.35-.02-.53.12-.2.16-.39.45-.53.83-.28.78-.25 1.73.14 2.3A.5.5 0 014.5 9h.75c1.24 0 2.25 1 2.25 2.25v.34a1.5 1.5 0 11-1 0v-.34c0-.69-.56-1.25-1.25-1.25H3.5a.5.5 0 01-.18-.03c-.2.4-.32 1.06-.32 2.03 0 .86.31 1.34.64 1.62.34.3.73.38.86.38.28 0 .5.22.5.5 0 .37.2 1.01.64 1.56.43.54 1.05.94 1.86.94.56 0 1.06-.31 1.45-.72a3.12 3.12 0 00.55-.81V7.5H8.41a1.5 1.5 0 110-1H9.5v-2zm1 10v.97l.01.03.1.2c.1.17.25.38.44.58.39.4.9.72 1.45.72.81 0 1.43-.4 1.86-.94.44-.55.64-1.2.64-1.56 0-.28.22-.5.5-.5.13 0 .52-.08.86-.38.33-.28.64-.76.64-1.62 0-.97-.12-1.63-.32-2.03-.1-.19-.2-.3-.3-.37a.66.66 0 00-.38-.1.5.5 0 01-.42-.78c.39-.57.42-1.52.14-2.3a1.89 1.89 0 00-.53-.83c-.18-.14-.34-.18-.53-.12A.5.5 0 0114 5c0-.57-.28-1.06-.74-1.42A2.91 2.91 0 0011.5 3a.76.76 0 00-.54.19c-.13.11-.23.28-.3.49a2.58 2.58 0 00-.16.81v9.01h.75c.69 0 1.25-.56 1.25-1.25v-1.84a1.5 1.5 0 111 0v1.84c0 1.24-1 2.25-2.25 2.25h-.75zM6.5 7a.5.5 0 101 0 .5.5 0 00-1 0zM13 9.5a.5.5 0 100-1 .5.5 0 000 1zm-6 3a.5.5 0 100 1 .5.5 0 000-1z",
    fill: primaryFill
  }));
};

export const BrainCircuitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrainCircuitRegularIcon({}), 'BrainCircuitRegular');

const BranchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5a3 3 0 01-2.15 2.88A5.76 5.76 0 0012 9.98a3 3 0 11.17 1.01A6.8 6.8 0 017.5 9v3.05a3 3 0 11-1 0V7.96A3 3 0 1110 5z",
    fill: primaryFill
  }));
};

export const BranchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFilledIcon({}), 'BranchFilled');

const BranchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5a3 3 0 01-2.15 2.88A5.76 5.76 0 0012 9.98a3 3 0 11.17 1.01A6.8 6.8 0 017.5 9v3.05a3 3 0 11-1 0V7.96A3 3 0 1110 5zM7 7a2 2 0 100-4 2 2 0 000 4zm10 3a2 2 0 10-4 0 2 2 0 004 0zM7 17a2 2 0 100-4 2 2 0 000 4z",
    fill: primaryFill
  }));
};

export const BranchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchRegularIcon({}), 'BranchRegular');

const BranchCompareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.15 6.85a.5.5 0 00.7-.7L10.71 5h1.79A2.5 2.5 0 0115 7.5V12a3 3 0 101 .17V7.5A3.5 3.5 0 0012.5 4h-1.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM5 8a3 3 0 10-1-.17v4.67A3.5 3.5 0 007.5 16h1.8l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L9.29 15H7.5A2.5 2.5 0 015 12.5V8z",
    fill: primaryFill
  }));
};

export const BranchCompareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompareFilledIcon({}), 'BranchCompareFilled');

const BranchCompareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.15 6.85a.5.5 0 00.7-.7L10.71 5h1.79A2.5 2.5 0 0115 7.5V12a3 3 0 101 .17V7.5A3.5 3.5 0 0012.5 4h-1.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM17 15a2 2 0 11-4 0 2 2 0 014 0zM8 5a3 3 0 01-3 3v4.5A2.5 2.5 0 007.5 15h1.8l-1.15-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L9.29 16H7.5A3.5 3.5 0 014 12.5V7.83A3 3 0 118 5zM7 5a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }));
};

export const BranchCompareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompareRegularIcon({}), 'BranchCompareRegular');

const BranchForkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 5a3 3 0 01-2.5 2.96V10H12c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 111 0v.54A2.5 2.5 0 0112 11H6.5v1.04a3 3 0 11-1 0V7.96A3 3 0 119 5z",
    fill: primaryFill
  }));
};

export const BranchForkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkFilledIcon({}), 'BranchForkFilled');

const BranchForkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 5a3 3 0 10-3.5 2.96v4.08a3 3 0 101 0V11H12a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 009 5zM6 7a2 2 0 110-4 2 2 0 010 4zm0 10a2 2 0 110-4 2 2 0 010 4zM16 5a2 2 0 11-4 0 2 2 0 014 0z",
    fill: primaryFill
  }));
};

export const BranchForkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkRegularIcon({}), 'BranchForkRegular');

const BranchForkHintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a3 3 0 00-.5 5.96v3.79a.5.5 0 001 0V11H12a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 006 2zM4.87 13.4a.5.5 0 10-.58-.8 3.02 3.02 0 00-1.12 1.54.5.5 0 10.96.3 1.99 1.99 0 01.74-1.03zm2.9-.8a.5.5 0 10-.57.8 2.02 2.02 0 01.75 1.04.5.5 0 10.95-.3 2.99 2.99 0 00-1.12-1.55zM4.3 16a.5.5 0 00-.88.5 3 3 0 001.38 1.27.5.5 0 10.42-.91 2 2 0 01-.92-.85zm4.37.5a.5.5 0 00-.87-.5 2 2 0 01-.98.88.5.5 0 10.38.92 3 3 0 001.47-1.3z",
    fill: primaryFill
  }));
};

export const BranchForkHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkHintFilledIcon({}), 'BranchForkHintFilled');

const BranchForkHintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a3 3 0 00-.5 5.96v3.79a.5.5 0 001 0V11H12a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 006 2zm8 5a2 2 0 110-4 2 2 0 010 4zM6 7a2 2 0 110-4 2 2 0 010 4zm-1.13 6.4a.5.5 0 10-.58-.8 3.02 3.02 0 00-1.12 1.54.5.5 0 10.96.3 1.99 1.99 0 01.74-1.03zm2.9-.8a.5.5 0 10-.57.8 2.02 2.02 0 01.75 1.04.5.5 0 10.95-.3 2.99 2.99 0 00-1.12-1.55zM4.3 16a.5.5 0 00-.88.5 3 3 0 001.38 1.27.5.5 0 10.42-.91 2 2 0 01-.92-.85zm4.37.5a.5.5 0 00-.87-.5 2 2 0 01-.98.88.5.5 0 10.38.92 3 3 0 001.47-1.3z",
    fill: primaryFill
  }));
};

export const BranchForkHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkHintRegularIcon({}), 'BranchForkHintRegular');

const BranchForkLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 7.96a3 3 0 10-1 0v4.08a3 3 0 101 0V11H11a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H5.5V7.96zm7 5.04a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BranchForkLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkLinkFilledIcon({}), 'BranchForkLinkFilled');

const BranchForkLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 01.5 5.96V10H11c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 111 0v.54A2.5 2.5 0 0111 11H5.5v1.04a3 3 0 11-1 0V7.96A3 3 0 015 2zM3 5a2 2 0 104 0 2 2 0 00-4 0zm0 10a2 2 0 104 0 2 2 0 00-4 0zm10-8a2 2 0 100-4 2 2 0 000 4zm-.5 6a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BranchForkLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkLinkRegularIcon({}), 'BranchForkLinkRegular');

const BreakoutRoomFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-3.35A3.99 3.99 0 0012 14v-2a4 4 0 00-4-4H6c-1.2 0-2.27.52-3 1.35V6zm3 3a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3H6z",
    fill: primaryFill
  }));
};

export const BreakoutRoomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoomFilledIcon({}), 'BreakoutRoomFilled');

const BreakoutRoomRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-3.35c.32-.29.6-.62.81-1H14a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2.54c-.38.21-.71.49-1 .81V6zm3 3a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3H6zm-2 3c0-1.1.9-2 2-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2z",
    fill: primaryFill
  }));
};

export const BreakoutRoomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoomRegularIcon({}), 'BreakoutRoomRegular');

const BriefcaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6h1.5A2.5 2.5 0 0117 8.5v5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 13.5v-5A2.5 2.5 0 015.5 6H7V3.5zM12 6V4H8v2h4z",
    fill: primaryFill
  }));
};

export const BriefcaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseFilledIcon({}), 'BriefcaseFilled');

const BriefcaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 3a.5.5 0 00-.5.5V6H5.5A2.5 2.5 0 003 8.5v5A2.5 2.5 0 005.5 16h9a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0014.5 6H13V3.5a.5.5 0 00-.5-.5h-5zM12 6H8V4h4v2zM5.5 7h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 13.5v-5C4 7.67 4.67 7 5.5 7z",
    fill: primaryFill
  }));
};

export const BriefcaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseRegularIcon({}), 'BriefcaseRegular');

const BriefcaseMedicalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 3a.5.5 0 00-.5.5V6H5a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V9a3 3 0 00-3-3h-2V3.5a.5.5 0 00-.5-.5h-5zM12 6H8V4h4v2zm-2 3c.28 0 .5.22.5.5v2h2a.5.5 0 010 1h-2v2a.5.5 0 01-1 0v-2h-2a.5.5 0 010-1h2v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const BriefcaseMedicalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedicalFilledIcon({}), 'BriefcaseMedicalFilled');

const BriefcaseMedicalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 9.5a.5.5 0 00-1 0v2h-2a.5.5 0 000 1h2v2a.5.5 0 001 0v-2h2a.5.5 0 000-1h-2v-2zM7 3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6h2a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V9a3 3 0 013-3h2V3.5zm5 .5H8v2h4V4zM5 7a2 2 0 00-2 2v6c0 1.1.9 2 2 2h10a2 2 0 002-2V9a2 2 0 00-2-2H5z",
    fill: primaryFill
  }));
};

export const BriefcaseMedicalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedicalRegularIcon({}), 'BriefcaseMedicalRegular');

const BriefcaseOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.3 6.01A2.5 2.5 0 003 8.5v5A2.5 2.5 0 005.5 16h9c.24 0 .47-.03.7-.1l1.95 1.95a.5.5 0 00.7-.7l-1.73-1.74L2.85 2.15zM17 13.5c0 .4-.1.78-.26 1.12L8.12 6H12V4H8v1.88l-1-1V3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6h1.5A2.5 2.5 0 0117 8.5v5z",
    fill: primaryFill
  }));
};

export const BriefcaseOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOffFilledIcon({}), 'BriefcaseOffFilled');

const BriefcaseOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.3 6.01A2.5 2.5 0 003 8.5v5A2.5 2.5 0 005.5 16h9c.24 0 .47-.03.7-.1l1.95 1.95a.5.5 0 00.7-.7l-1.73-1.74-.72-.71L2.85 2.15zM14.3 15H5.5A1.5 1.5 0 014 13.5v-5C4 7.67 4.67 7 5.5 7h.8l8 8zM16 13.5c0 .12-.01.23-.04.34l.78.78c.17-.34.26-.72.26-1.12v-5A2.5 2.5 0 0014.5 6H13V3.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v1.38l1 1V4h4v2H8.12l1 1h5.38c.83 0 1.5.67 1.5 1.5v5z",
    fill: primaryFill
  }));
};

export const BriefcaseOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOffRegularIcon({}), 'BriefcaseOffRegular');

const BrightnessHighFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM10 6a4 4 0 110 8 4 4 0 010-8zm3 4a3 3 0 00-3-3v6a3 3 0 003-3zm5 0a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm-7.5 6.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM4 10a.5.5 0 01-.5.5H2.46a.5.5 0 010-1H3.5c.28 0 .5.22.5.5zm.85-5.85a.5.5 0 10-.7.7l1 1a.5.5 0 10.7-.7l-1-1zm-.7 11.7c.2.2.5.2.7 0l1-1a.5.5 0 00-.7-.7l-1 1a.5.5 0 000 .7zm11-11.7a.5.5 0 01.7.7l-1 1a.5.5 0 01-.7-.7l1-1zm.7 11.7a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l1 1c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const BrightnessHighFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHighFilledIcon({}), 'BrightnessHighFilled');

const BrightnessHighRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm0 12a4 4 0 100-8 4 4 0 000 8zm0-1a3 3 0 110-6 3 3 0 010 6zm7.5-2.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zM10 16c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm-6.5-5.5a.5.5 0 000-1H2.46a.5.5 0 000 1H3.5zm.65-6.35c.2-.2.5-.2.7 0l1 1a.5.5 0 11-.7.7l-1-1a.5.5 0 010-.7zm.7 11.7a.5.5 0 01-.7-.7l1-1a.5.5 0 01.7.7l-1 1zm11-11.7a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l1-1a.5.5 0 000-.7zm-.7 11.7a.5.5 0 00.7-.7l-1-1a.5.5 0 00-.7.7l1 1z",
    fill: primaryFill
  }));
};

export const BrightnessHighRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHighRegularIcon({}), 'BrightnessHighRegular');

const BrightnessLowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm0 3a4 4 0 100 8 4 4 0 000-8zm0 7V7a3 3 0 110 6zm6.5-2.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zM10 15c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm-5.5-4.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zm.65-5.35c.2-.2.5-.2.7 0l.5.5a.5.5 0 11-.7.7l-.5-.5a.5.5 0 010-.7zm.7 9.7a.5.5 0 01-.7-.7l.5-.5a.5.5 0 01.7.7l-.5.5zm9-9.7a.5.5 0 00-.7 0l-.5.5a.5.5 0 00.7.7l.5-.5a.5.5 0 000-.7zm-.7 9.7a.5.5 0 00.7-.7l-.5-.5a.5.5 0 00-.7.7l.5.5z",
    fill: primaryFill
  }));
};

export const BrightnessLowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLowFilledIcon({}), 'BrightnessLowFilled');

const BrightnessLowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 3.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM10 6a4 4 0 100 8 4 4 0 000-8zm-3 4a3 3 0 116 0 3 3 0 01-6 0zm10 0a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm-6.5 5.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM5 10a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm.85-4.85a.5.5 0 10-.7.7l.5.5a.5.5 0 10.7-.7l-.5-.5zm-.7 9.7c.2.2.5.2.7 0l.5-.5a.5.5 0 00-.7-.7l-.5.5a.5.5 0 000 .7zm9-9.7a.5.5 0 01.7.7l-.5.5a.5.5 0 01-.7-.7l.5-.5zm.7 9.7a.5.5 0 01-.7 0l-.5-.5a.5.5 0 01.7-.7l.5.5c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const BrightnessLowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLowRegularIcon({}), 'BrightnessLowRegular');

const BroadActivityFeedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-13zm0 9c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4zm9 0c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4z",
    fill: primaryFill
  }));
};

export const BroadActivityFeedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeedFilledIcon({}), 'BroadActivityFeedFilled');

const BroadActivityFeedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 8.5v-4zM3.5 4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-13zM2 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 15.5v-2zm1.5-.5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-4zm9-1c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4zm-.5 1.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const BroadActivityFeedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeedRegularIcon({}), 'BroadActivityFeedRegular');

const BroomFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.91 2.18c.2.2.2.51 0 .7L13.3 7.5a5.6 5.6 0 00-.7-.7l4.6-4.62c.2-.2.51-.2.71 0zm-5.66 5.66a4.5 4.5 0 00-6.36 0l-.42.42 6.36 6.36.42-.42a4.5 4.5 0 000-6.36zm-10.5 2.75l2.9-1.74 6.5 6.5a.5.5 0 00.1.08L9.5 18.35a.5.5 0 01-.78.1l-7.07-7.08a.5.5 0 01.1-.78z",
    fill: primaryFill
  }));
};

export const BroomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroomFilledIcon({}), 'BroomFilled');

const BroomRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.91 2.18c.2.2.2.51 0 .7l-5.32 5.33a4.5 4.5 0 01-.34 6l-.66.66-2.09 3.48a.5.5 0 01-.78.1l-7.07-7.08a.5.5 0 01.1-.78L5.22 8.5l.66-.66a4.5 4.5 0 015.99-.34l5.32-5.32c.2-.2.51-.2.71 0zM6.24 8.9l4.95 4.95.36-.35A3.5 3.5 0 106.6 8.55l-.36.35zm-.78.63L2.8 11.12l6.16 6.17 1.6-2.66-5.11-5.1z",
    fill: primaryFill
  }));
};

export const BroomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroomRegularIcon({}), 'BroomRegular');

const BugFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0V3c0 .4.12.77.32 1.08A3 3 0 006 7h-.5A1.5 1.5 0 014 5.5v-2a.5.5 0 00-1 0v2A2.5 2.5 0 005.5 8H6v1.5H2.5a.5.5 0 000 1H6V12h-.5A2.5 2.5 0 003 14.5v2a.5.5 0 001 0v-2c0-.83.67-1.5 1.5-1.5H6a4 4 0 008 0h.5c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2a2.5 2.5 0 00-2.5-2.5H14v-1.5h3.5a.5.5 0 000-1H14V8h.5A2.5 2.5 0 0017 5.5v-2a.5.5 0 00-1 0v2c0 .83-.67 1.5-1.5 1.5H14a3 3 0 00-2.32-2.92A2 2 0 0012 3v-.5a.5.5 0 00-1 0V3a1 1 0 11-2 0v-.5z",
    fill: primaryFill
  }));
};

export const BugFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BugFilledIcon({}), 'BugFilled');

const BugRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0V3c0 .4.12.77.32 1.08A3 3 0 006 7h-.5A1.5 1.5 0 014 5.5v-2a.5.5 0 00-1 0v2A2.5 2.5 0 005.5 8H6v1.5H2.5a.5.5 0 000 1H6V12h-.5A2.5 2.5 0 003 14.5v2a.5.5 0 001 0v-2c0-.83.67-1.5 1.5-1.5H6a4 4 0 008 0h.5c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2a2.5 2.5 0 00-2.5-2.5H14v-1.5h3.5a.5.5 0 000-1H14V8h.5A2.5 2.5 0 0017 5.5v-2a.5.5 0 00-1 0v2c0 .83-.67 1.5-1.5 1.5H14a3 3 0 00-2.32-2.92A2 2 0 0012 3v-.5a.5.5 0 00-1 0V3a1 1 0 11-2 0v-.5zM13 7v6a3 3 0 11-6 0V7c0-1.1.9-2 2-2h2a2 2 0 012 2z",
    fill: primaryFill
  }));
};

export const BugRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BugRegularIcon({}), 'BugRegular');

const BuildingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v8a.5.5 0 01-.5.5H13v-3.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V18H4.5a.5.5 0 01-.5-.5v-14zm2.75 3a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-6.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM9.75 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5zM12 15v3h-1.5v-3H12zm-2.5 0H8v3h1.5v-3z",
    fill: primaryFill
  }));
};

export const BuildingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFilledIcon({}), 'BuildingFilled');

const BuildingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.75 6.5a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.75 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5zM4.5 18a.5.5 0 01-.5-.5v-14C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v8a.5.5 0 01-.5.5h-11zM5 3.5V17h2v-2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V17h2V9.5a.5.5 0 00-.5-.5h-2a.5.5 0 01-.5-.5v-5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5zM12 15h-1.5v2H12v-2zm-2.5 0H8v2h1.5v-2z",
    fill: primaryFill
  }));
};

export const BuildingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRegularIcon({}), 'BuildingRegular');

const BuildingBankFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.23 2.18a1.33 1.33 0 011.54 0l5.85 4.15A.92.92 0 0116.1 8H3.9a.92.92 0 01-.52-1.67l5.85-4.15zm.77 3.7a.83.83 0 100-1.67.83.83 0 000 1.66zM4.5 9v4h2V9h-2zM3 16.17c0-1.2.97-2.17 2.17-2.17h9.66c1.2 0 2.17.97 2.17 2.17v.33a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-.33zM15.5 9v4h-2V9h2zm-3 0v4h-2V9h2zm-3 0v4h-2V9h2z",
    fill: primaryFill
  }));
};

export const BuildingBankFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankFilledIcon({}), 'BuildingBankFilled');

const BuildingBankRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.87a.83.83 0 100-1.66.83.83 0 000 1.66zm6 7.47V8h.1a.92.92 0 00.52-1.67l-5.85-4.15a1.33 1.33 0 00-1.54 0L3.38 6.33A.92.92 0 003.9 8H4v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-1.33c0-.77-.4-1.45-1-1.83zM9.8 3a.33.33 0 01.4 0l5.63 4H4.17L9.8 3zM15 8v5h-2V8h2zM5 13V8h2v5H5zm.17 1h9.66c.65 0 1.17.52 1.17 1.17V16H4v-.83c0-.65.52-1.17 1.17-1.17zm4.33-1H8V8h1.5v5zm1 0V8H12v5h-1.5z",
    fill: primaryFill
  }));
};

export const BuildingBankRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankRegularIcon({}), 'BuildingBankRegular');

const BuildingBankLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.23 2.18a1.33 1.33 0 011.54 0l5.85 4.15A.92.92 0 0116.1 8H3.9a.92.92 0 01-.52-1.67l5.85-4.15zm.77 3.7a.83.83 0 100-1.67.83.83 0 000 1.66zM4.5 9v4h2V9h-2zM3 16.17c0-1.2.97-2.17 2.17-2.17h3.17a3.49 3.49 0 000 3H3.5a.5.5 0 01-.5-.5v-.33zM9.05 13c.14-.14.29-.26.45-.37V9h-2v4h1.55zm2.45-1h1V9h-2v3.14c.32-.09.65-.14 1-.14zm2 0h2V9h-2v3zm-2 1a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 100 1h.5a1.5 1.5 0 010 3H15a.5.5 0 100 1h.5a2.5 2.5 0 000-5H15zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLinkFilledIcon({}), 'BuildingBankLinkFilled');

const BuildingBankLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.87a.83.83 0 100-1.66.83.83 0 000 1.66zM3.5 17h4.84a3.48 3.48 0 01-.3-1H4v-.83c0-.65.52-1.17 1.17-1.17h3.17c.17-.38.42-.71.71-1H8V8h1.5v4.63c.3-.21.64-.38 1-.49V8H12v4h1V8h2v4h.5c.17 0 .34.01.5.03V8h.1a.92.92 0 00.52-1.67l-5.85-4.15a1.33 1.33 0 00-1.54 0L3.38 6.33A.92.92 0 003.9 8H4v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5zM9.8 3a.33.33 0 01.4 0l5.63 4H4.17L9.8 3zM5 13V8h2v5H5zm6.5 0a2.5 2.5 0 000 5h.5a.5.5 0 100-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 100-1h-.5zm3.5 0a.5.5 0 100 1h.5a1.5 1.5 0 110 3H15a.5.5 0 100 1h.5a2.5 2.5 0 000-5H15zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLinkRegularIcon({}), 'BuildingBankLinkRegular');

const BuildingBankToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.23 2.18a1.33 1.33 0 011.54 0l5.85 4.15A.92.92 0 0115.1 8H2.9a.92.92 0 01-.52-1.67l5.85-4.15zM9 5.88A.83.83 0 109 4.2a.83.83 0 000 1.66zM3.5 9v4h2V9h-2zm.67 5C2.97 14 2 14.97 2 16.17v.33c0 .28.22.5.5.5H9v-3H4.17zm7.33-4V9h-2v3c.37-.5.91-.84 1.54-.96.07-.38.23-.74.46-1.04zm-3 3V9h-2v4h2zm3.5-1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0V16z",
    fill: primaryFill
  }));
};

export const BuildingBankToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankToolboxFilledIcon({}), 'BuildingBankToolboxFilled');

const BuildingBankToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 5.87a.83.83 0 100-1.66.83.83 0 000 1.66zM2.5 17H9v-1H3v-.83c0-.65.52-1.17 1.17-1.17H9v-.5c0-.56.19-1.08.5-1.5V8H11v3.05h.04A2.5 2.5 0 0112 9.5V8h2v1h1V8h.1a.92.92 0 00.52-1.67L9.77 2.18a1.33 1.33 0 00-1.54 0L2.38 6.33A.92.92 0 002.9 8H3v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5zM8.8 3a.33.33 0 01.4 0l5.63 4H3.17L8.8 3zM4 13V8h2v5H4zm4.5 0H7V8h1.5v5zm3.5-1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 10-1 0v.5h-3v-.5a.5.5 0 10-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0V16z",
    fill: primaryFill
  }));
};

export const BuildingBankToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankToolboxRegularIcon({}), 'BuildingBankToolboxRegular');

const BuildingFactoryFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.94 3.4c.05-.79.7-1.4 1.5-1.4h1.12c.8 0 1.45.61 1.5 1.4l.87 13a1.5 1.5 0 01-1.5 1.6H3.57a1.5 1.5 0 01-1.5-1.6l.87-13zM8.44 18c.34-.46.53-1.04.49-1.67L8.4 8.51l3.76-3.38a.5.5 0 01.84.37v3.38l4.16-3.75a.5.5 0 01.84.37v11c0 .83-.67 1.5-1.5 1.5H8.43zM16 17v-4.2a.8.8 0 00-.8-.8h-3.4a.8.8 0 00-.8.8V17h5z",
    fill: primaryFill
  }));
};

export const BuildingFactoryFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactoryFilledIcon({}), 'BuildingFactoryFilled');

const BuildingFactoryRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.44 2a1.5 1.5 0 00-1.5 1.4l-.87 13a1.5 1.5 0 001.5 1.6h2.86a1.5 1.5 0 001.5-1.6l-.87-13A1.5 1.5 0 005.56 2H4.44zm-.5 1.47a.5.5 0 01.5-.47h1.12c.27 0 .49.2.5.47l.87 13a.5.5 0 01-.5.53H3.57a.5.5 0 01-.5-.53l.87-13zM16.5 18H8.43c.22-.3.38-.63.45-1H10v-4a1 1 0 011-1h4a1 1 0 011 1v4h.5a.5.5 0 00.5-.5V6.62l-4.17 3.75A.5.5 0 0112 10V6.62L8.49 9.78 8.4 8.51l3.76-3.38a.5.5 0 01.84.37v3.38l4.16-3.75a.5.5 0 01.84.37v11c0 .83-.67 1.5-1.5 1.5zM11 17h4v-4h-4v4z",
    fill: primaryFill
  }));
};

export const BuildingFactoryRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactoryRegularIcon({}), 'BuildingFactoryRegular');

const BuildingGovernmentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 2a.5.5 0 00-.5.5v2.6A5 5 0 005 10v1H4a2 2 0 00-2 2v4a1 1 0 001 1h4.5a.5.5 0 00.5-.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2c0 .28.22.5.5.5H17a1 1 0 001-1v-4a2 2 0 00-2-2h-1v-1a5 5 0 00-5-5V4h2.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-3zM6 13.5v2a.5.5 0 01-1 0v-2a.5.5 0 011 0zm8.5-.5c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5zM9 9.5v2a.5.5 0 01-1 0v-2a.5.5 0 011 0zm2.5-.5c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingGovernmentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernmentFilledIcon({}), 'BuildingGovernmentFilled');

const BuildingGovernmentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5H10v1a5 5 0 015 5v1h1a2 2 0 012 2v4a1 1 0 01-1 1H3a1 1 0 01-1-1v-4c0-1.1.9-2 2-2h1v-1a5 5 0 014-4.9V2.5zm7 9.5h-1.5a.5.5 0 01-.5-.5V10a4 4 0 00-8 0v1.5a.5.5 0 01-.5.5H4a1 1 0 00-1 1v4h5v-2a1 1 0 011-1h2a1 1 0 011 1v2h5v-4a1 1 0 00-1-1zM6 13.5a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zm9 0a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zM8.5 9a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm3.5.5a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zM9 17h2v-2H9v2z",
    fill: primaryFill
  }));
};

export const BuildingGovernmentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernmentRegularIcon({}), 'BuildingGovernmentRegular');

const BuildingHomeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 2C2.56 2 2 2.56 2 3.25v10.5c0 .69.56 1.25 1.25 1.25H7.5v-1.74c0-.68.3-1.33.82-1.78l3.47-2.96c.35-.3.78-.47 1.21-.52v-.75C13 6.56 12.44 6 11.75 6h-1.5a.25.25 0 01-.25-.25v-2.5C10 2.56 9.44 2 8.75 2h-5.5zm1.5 3.5a.75.75 0 110-1.5.75.75 0 010 1.5zM5.5 7A.75.75 0 114 7a.75.75 0 011.5 0zm-.75 3a.75.75 0 110-1.5.75.75 0 010 1.5zM8 4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3a.75.75 0 110-1.5.75.75 0 010 1.5zM8 9.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm6.06.03c-.47-.4-1.15-.4-1.62 0l-3.47 2.96c-.3.26-.47.63-.47 1.02v4.61C8.5 18.5 9 19 9.63 19h1.74c.63 0 1.13-.5 1.13-1.13v-1.75c0-.06.06-.12.13-.12h1.24c.07 0 .13.06.13.13v1.74c0 .63.5 1.13 1.13 1.13h1.74c.63 0 1.13-.5 1.13-1.13v-4.61c0-.4-.17-.76-.47-1.02l-3.47-2.96zm-.97.77c.1-.08.23-.08.32 0L16.88 13c.08.07.12.16.12.26v4.61c0 .07-.06.13-.13.13h-1.75a.12.12 0 01-.12-.13v-1.75c0-.62-.5-1.12-1.13-1.12h-1.24c-.63 0-1.13.5-1.13 1.13v1.74c0 .07-.06.13-.13.13H9.63a.12.12 0 01-.13-.13v-4.61c0-.1.04-.2.12-.26l3.47-2.95z",
    fill: primaryFill
  }));
};

export const BuildingHomeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHomeFilledIcon({}), 'BuildingHomeFilled');

const BuildingHomeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 3a.25.25 0 00-.25.25v10.5c0 .14.11.25.25.25H7.5v1H3.25C2.56 15 2 14.44 2 13.75V3.25C2 2.56 2.56 2 3.25 2h5.5C9.44 2 10 2.56 10 3.25v2.5c0 .14.11.25.25.25h1.5c.69 0 1.25.56 1.25 1.25V8c-.35.04-.7.16-1 .37V7.25a.25.25 0 00-.25-.25h-1.5C9.56 7 9 6.44 9 5.75v-2.5A.25.25 0 008.75 3h-5.5zm10.81 6.28c-.47-.4-1.15-.4-1.62 0l-3.47 2.96c-.3.26-.47.63-.47 1.02v4.61C8.5 18.5 9 19 9.63 19h1.74c.63 0 1.13-.5 1.13-1.13v-1.75c0-.06.06-.12.13-.12h1.24c.07 0 .13.06.13.13v1.74c0 .63.5 1.13 1.13 1.13h1.74c.63 0 1.13-.5 1.13-1.13v-4.61c0-.4-.17-.76-.47-1.02l-3.47-2.96zm-.97.77c.1-.08.23-.08.32 0L16.88 13c.08.07.12.16.12.26v4.61c0 .07-.06.13-.13.13h-1.75a.12.12 0 01-.12-.13v-1.75c0-.62-.5-1.12-1.13-1.12h-1.24c-.63 0-1.13.5-1.13 1.13v1.74c0 .07-.06.13-.13.13H9.63a.12.12 0 01-.13-.13v-4.61c0-.1.04-.2.12-.26l3.47-2.95zM5.5 4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 1.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.25 5.5a.75.75 0 100-1.5.75.75 0 000 1.5zM8 7a.75.75 0 11-1.5 0A.75.75 0 018 7zm-.75 3a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const BuildingHomeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHomeRegularIcon({}), 'BuildingHomeRegular');

const BuildingLighthouseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.25 2.07a.5.5 0 00-.5 0L5.57 3.88A1.13 1.13 0 006 6v2.2a2 2 0 00-1.15 1.59l-.79 7.11a1 1 0 001 1.11h7.88a1 1 0 001-1.11l-.8-7.11A2 2 0 0012 8.18v-.17V6a1.13 1.13 0 00.43-2.12L9.25 2.07zM11 8H7V6h4v2zm-5.48 4.88l6.76-1.8.22 1.9-7.2 1.92.22-2.02zM16.5 7h-2a.5.5 0 110-1h2a.5.5 0 010 1zm-.65-3.15a.5.5 0 10-.7-.7l-1 1a.5.5 0 00.7.7l1-1zm0 6a.5.5 0 000-.7l-1-1a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0z",
    fill: primaryFill
  }));
};

export const BuildingLighthouseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingLighthouseFilledIcon({}), 'BuildingLighthouseFilled');

const BuildingLighthouseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.75 2.07a.5.5 0 01.5 0l3.18 1.81A1.13 1.13 0 0112 6v2.2a2 2 0 011.15 1.59l.79 7.11a1 1 0 01-1 1.11H5.06a1 1 0 01-1-1.11l.8-7.11A2 2 0 016 8.18V6a1.13 1.13 0 01-.43-2.1l3.18-1.82zm.25 1L6.07 4.76a.13.13 0 00.06.25h5.74a.13.13 0 00.06-.25L9 3.08zM11.16 9H6.84a1 1 0 00-1 .89l-.2 1.92 6.53-1.74-.02-.18a1 1 0 00-.99-.89zM11 8V6H7v2h4zm-5.7 6.9l7.2-1.92-.22-1.9-6.76 1.8-.23 2.02zm-.13 1.07L5.06 17h7.88l-.33-3.01-7.44 1.98zM14.5 7h2a.5.5 0 000-1h-2a.5.5 0 100 1zm1.35-3.85c.2.2.2.5 0 .7l-1 1a.5.5 0 11-.7-.7l1-1c.2-.2.5-.2.7 0zm0 6a.5.5 0 11-.7.7l-1-1a.5.5 0 01.7-.7l1 1z",
    fill: primaryFill
  }));
};

export const BuildingLighthouseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingLighthouseRegularIcon({}), 'BuildingLighthouseRegular');

const BuildingMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v13a1 1 0 001 1h7.5a.5.5 0 00.5-.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2c0 .28.22.5.5.5H17a1 1 0 001-1V7a2 2 0 00-2-2h-4V4a2 2 0 00-2-2H4zm7 3h-1a2 2 0 00-2 2v10H3V4a1 1 0 011-1h6a1 1 0 011 1v1zM5.25 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zM6 5.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 9.75a.75.75 0 100-1.5.75.75 0 000 1.5zM6 11.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm5.25-2.25a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.75-2.25a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const BuildingMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingMultipleFilledIcon({}), 'BuildingMultipleFilled');

const BuildingMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h6a2 2 0 012 2v1h4a2 2 0 012 2v10a1 1 0 01-1 1H3a1 1 0 01-1-1V4zm10 13h2v-2h-2v2zm3 0h2V7a1 1 0 00-1-1h-6a1 1 0 00-1 1v10h2v-2a1 1 0 011-1h2a1 1 0 011 1v2zM11 4a1 1 0 00-1-1H4a1 1 0 00-1 1v13h5V7c0-1.1.9-2 2-2h1V4zm1 4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-6.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zM6 5.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm5.25 6.75a.75.75 0 100-1.5.75.75 0 000 1.5zM6 14.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-2.25a.75.75 0 100-1.5.75.75 0 000 1.5zM15.5 8.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const BuildingMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingMultipleRegularIcon({}), 'BuildingMultipleRegular');

const BuildingRetailFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 10V8h8v2H6zm6 4v-1h2v1h-2zm6-9.5c0 .65-.42 1.2-1 1.41V16.5a.5.5 0 01-.5.5H10v-4.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V17H3.5a.5.5 0 01-.5-.5V5.91A1.5 1.5 0 013.5 3h13c.83 0 1.5.67 1.5 1.5zm-15 0c0 .28.22.5.5.5h13a.5.5 0 000-1h-13a.5.5 0 00-.5.5zM5.5 7a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-9zm6 5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-3zM6 17h3v-4H6v4z",
    fill: primaryFill
  }));
};

export const BuildingRetailFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailFilledIcon({}), 'BuildingRetailFilled');

const BuildingRetailRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 7a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-9zm.5 3V8h8v2H6zm5.5 2a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-3zm.5 2v-1h2v1h-2zM2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 01.5 2.91V16.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V5.91c-.58-.2-1-.76-1-1.41zM3.5 4a.5.5 0 000 1h13a.5.5 0 000-1h-13zM4 6v10h1v-3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V16h6V6H4zm2 10h3v-3H6v3z",
    fill: primaryFill
  }));
};

export const BuildingRetailRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailRegularIcon({}), 'BuildingRetailRegular');

const BuildingRetailMoneyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 10V8h8v2H6zm11-4.09A1.5 1.5 0 0016.5 3h-13A1.5 1.5 0 003 5.91V16.5c0 .28.22.5.5.5H5v-4.5c0-.28.22-.5.5-.5h4c.2 0 .38.12.46.3.3-.2.66-.3 1.04-.3h6V5.91zM3.5 4h13a.5.5 0 010 1h-13a.5.5 0 010-1zM5 7.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-3zM9 13v4H6v-4h3zm8.5 0c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6zm0 5c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5h1zm.5-3.5a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoneyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoneyFilledIcon({}), 'BuildingRetailMoneyFilled');

const BuildingRetailMoneyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 01.5 2.91V12h-1V6H4v10h1v-3.5c0-.28.22-.5.5-.5h4c.2 0 .38.12.46.3A2 2 0 009 14v-1H6v3h3v1H3.5a.5.5 0 01-.5-.5V5.91c-.58-.2-1-.76-1-1.41zM3.5 4a.5.5 0 000 1h13a.5.5 0 000-1h-13zm2 3a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-9zm.5 3V8h8v2H6zm13 4.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zM17.5 18c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5h1zm.5-3.5a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoneyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoneyRegularIcon({}), 'BuildingRetailMoneyRegular');

const BuildingRetailMoreFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.3a1 1 0 01.7-.3h10.6a1 1 0 01.7.3l2.64 2.63c.76.77.22 2.07-.85 2.07H2.2a1.21 1.21 0 01-.85-2.07L4 3.3zM17 9H3v6c0 1.1.9 2 2 2h10a2 2 0 002-2V9zM7 13a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoreFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoreFilledIcon({}), 'BuildingRetailMoreFilled');

const BuildingRetailMoreRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 13a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zM4 3.3a1 1 0 01.7-.3h10.6a1 1 0 01.7.3l2.64 2.63c.76.77.22 2.07-.85 2.07H17v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8h-.79a1.21 1.21 0 01-.85-2.07L4 3.3zM16 15V8H4v7a1 1 0 001 1h10a1 1 0 001-1zm1.79-8c.18 0 .28-.23.14-.36L15.3 4H4.71L2.07 6.64A.21.21 0 002.2 7H17.8z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoreRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoreRegularIcon({}), 'BuildingRetailMoreRegular');

const BuildingRetailShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.5c0 .65-.42 1.2-1 1.41v3.36c-.34-.24-.63-.5-.85-.73A1.6 1.6 0 0015 8.06V7.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h4.58a1.5 1.5 0 00-.08.5V13v-.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V17H3.5a.5.5 0 01-.5-.5V5.91A1.5 1.5 0 013.5 3h13c.83 0 1.5.67 1.5 1.5zm-15 0c0 .28.22.5.5.5h13a.5.5 0 000-1h-13a.5.5 0 00-.5.5zM14 8v.4l-.15.14A4.71 4.71 0 0111.22 10H6V8h8zm-5 5H6v4h3v-4zm9.5-2.04a5.69 5.69 0 01-3.06-1.72.62.62 0 00-.88 0 5.7 5.7 0 01-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 00.26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54z",
    fill: primaryFill
  }));
};

export const BuildingRetailShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailShieldFilledIcon({}), 'BuildingRetailShieldFilled');

const BuildingRetailShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 3A1.5 1.5 0 003 5.91V16.5c0 .28.22.5.5.5H10v-4.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V16H4V6h12v2.4l.15.14c.22.23.51.49.85.73V5.9A1.5 1.5 0 0016.5 3h-13zM3 4.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zM9 16H6v-3h3v3zm6-7.94V7.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h4.58a1.6 1.6 0 011.14-1H6V8h8v.4c.29-.22.64-.34 1-.34zm3.5 2.9a5.69 5.69 0 01-3.06-1.72.62.62 0 00-.88 0 5.7 5.7 0 01-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 00.26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54z",
    fill: primaryFill
  }));
};

export const BuildingRetailShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailShieldRegularIcon({}), 'BuildingRetailShieldRegular');

const BuildingRetailToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.91A1.5 1.5 0 0016.5 3h-13A1.5 1.5 0 003 5.91V16.5c0 .28.22.5.5.5H5v-4.5c0-.28.22-.5.5-.5h4c.37-.5.91-.84 1.54-.96l.01-.04H5.5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5V9h.5c.56 0 1.08.19 1.5.5V5.91zM3.5 4h13a.5.5 0 010 1h-13a.5.5 0 010-1zM9 13v4H6v-4h3zm4.5-4h.5V8H6v2h5.5c.46-.6 1.18-1 2-1zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailToolboxFilledIcon({}), 'BuildingRetailToolboxFilled');

const BuildingRetailToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 01.5 2.91V9.5c-.3-.22-.63-.38-1-.45V6H4v10h1v-3.5c0-.28.22-.5.5-.5h4c-.31.42-.5.94-.5 1.5V13H6v3h3v1H3.5a.5.5 0 01-.5-.5V5.91c-.58-.2-1-.76-1-1.41zM3.5 4a.5.5 0 000 1h13a.5.5 0 000-1h-13zM15 7.5V9h-1V8H6v2h5.5c-.22.3-.38.63-.45 1H5.5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailToolboxRegularIcon({}), 'BuildingRetailToolboxRegular');

const BuildingShopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 12h2v2h-2v-2zM5 2h10a.5.5 0 01.38.18l2.5 3c.12.14.12.21.12.3V7a3 3 0 01-1 2.24v8.26a.5.5 0 01-.5.5H10v-6.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V18H3.5a.5.5 0 01-.5-.5V9.24A3 3 0 012 7V5.5a.5.5 0 01.12-.32l2.5-3A.5.5 0 015 2zM3 6v1a2 2 0 104 0V6H3zm5 0v1a2 2 0 104 0V6H8zm5 0v1a2 2 0 104 0V6h-4zM5.23 3L3.57 5h3.57l.67-2H5.23zm6.58 2l-.67-2H8.86l-.67 2h3.62zm1.05 0h3.57l-1.66-2h-2.58l.67 2zM11 11.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5zM9 18v-6H6v6h3z",
    fill: primaryFill
  }));
};

export const BuildingShopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShopFilledIcon({}), 'BuildingShopFilled');

const BuildingShopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 11.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5zm1 2.5v-2h2v2h-2zM5 2a.5.5 0 00-.38.18l-2.5 3A.5.5 0 002 5.5V7a3 3 0 001 2.24v8.26c0 .28.22.5.5.5h13a.5.5 0 00.5-.5V9.24A3 3 0 0018 7V5.5v-.02c0-.09 0-.16-.12-.3l-2.5-3A.5.5 0 0015 2H5zm0 7a2 2 0 01-2-2V6h4v1a2 2 0 01-2 2zm5 0a2 2 0 01-2-2V6h4v1a2 2 0 01-2 2zm5 0a2 2 0 01-2-2V6h4v1a2 2 0 01-2 2zM5 17H4V9.83a3 3 0 003.5-1.17 3 3 0 005 0A3 3 0 0016 9.83V17h-6v-5.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V17zM7.14 5H3.57l1.66-2h2.58l-.67 2zm4.67 0H8.19l.67-2h2.28l.67 2zm1.05 0l-.67-2h2.58l1.66 2h-3.57zM6 17v-5h3v5H6z",
    fill: primaryFill
  }));
};

export const BuildingShopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShopRegularIcon({}), 'BuildingShopRegular');

const BuildingSkyscraperFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5V3H7v-.5zM5.46 4a.5.5 0 00-.46.5V5h6v-.5a.5.5 0 00-.46-.5H5.46zm8.29 11a.75.75 0 100-1.5.75.75 0 000 1.5zm.75-3.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5 6h6v.02c.6.34 1 .99 1 1.73V8h.5a4.5 4.5 0 014.5 4.5v4a.5.5 0 01-.5.5H9v-2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V17H4.5a.5.5 0 01-.5-.5V7.75a2 2 0 011-1.73V6zm7 10h4v-3.5A3.5 3.5 0 0012.5 9H12v7zM7.5 8.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zM7.5 11.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraperFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraperFilledIcon({}), 'BuildingSkyscraperFilled');

const BuildingSkyscraperRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 8.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zM7.5 11.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zm5.25 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zM7 2a.5.5 0 00-.5.5V4h-.94a.5.5 0 00-.5.5v1.74A2 2 0 004 8v8.5c0 .27.22.5.5.5h12a.5.5 0 00.5-.5v-4A4.5 4.5 0 0012.5 8H12a2 2 0 00-.94-1.7V4.5a.5.5 0 00-.5-.5H9.5V2.5A.5.5 0 009 2H7zm3 4H6.06V5h4v1H10zm1 10h-1v-2a1 1 0 00-1-1H7a1 1 0 00-1 1v2H5V8a1 1 0 011-1h4a1 1 0 011 1v8zm-4 0v-2h2v2H7zm9 0h-4V9h.5a3.5 3.5 0 013.5 3.5V16zM8.5 4h-1V3h1v1z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraperRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraperRegularIcon({}), 'BuildingSkyscraperRegular');

const CalculatorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 2h-7A2.5 2.5 0 004 4.5v11A2.5 2.5 0 006.5 18h7a2.5 2.5 0 002.5-2.5v-11A2.5 2.5 0 0013.5 2zm-6 2h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 6.5v-1C6 4.67 6.67 4 7.5 4zm.5 7a1 1 0 11-2 0 1 1 0 012 0zm0 3a1 1 0 11-2 0 1 1 0 012 0zm5-2a1 1 0 110-2 1 1 0 010 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm-4-2a1 1 0 110-2 1 1 0 010 2zm1 2a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const CalculatorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorFilledIcon({}), 'CalculatorFilled');

const CalculatorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 11a1 1 0 11-2 0 1 1 0 012 0zm0 3a1 1 0 11-2 0 1 1 0 012 0zm5-2a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm-4-2a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zM7.5 4C6.67 4 6 4.67 6 5.5v1C6 7.33 6.67 8 7.5 8h5c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-5zM7 5.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1zm9 10a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 014 15.5v-11A2.5 2.5 0 016.5 2h7A2.5 2.5 0 0116 4.5v11zm-1-11c0-.83-.67-1.5-1.5-1.5h-7C5.67 3 5 3.67 5 4.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-11z",
    fill: primaryFill
  }));
};

export const CalculatorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorRegularIcon({}), 'CalculatorRegular');

const CalculatorArrowClockwiseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 2h-7A2.5 2.5 0 004 4.5v11A2.5 2.5 0 006.5 18h3.77a5.48 5.48 0 01-.64-6.07 1 1 0 111.17-1.52A5.48 5.48 0 0116 9.19V4.5A2.5 2.5 0 0013.5 2zm-6 2h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 6.5v-1C6 4.67 6.67 4 7.5 4zm.5 7a1 1 0 11-2 0 1 1 0 012 0zm0 3a1 1 0 11-2 0 1 1 0 012 0zm9.5-1.52a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v.76a4.5 4.5 0 102 3.74.5.5 0 10-1 0 3.5 3.5 0 11-1.7-3h-.8a.5.5 0 100 1h2z",
    fill: primaryFill
  }));
};

export const CalculatorArrowClockwiseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorArrowClockwiseFilledIcon({}), 'CalculatorArrowClockwiseFilled');

const CalculatorArrowClockwiseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 12a1 1 0 100-2 1 1 0 000 2zm0 3a1 1 0 100-2 1 1 0 000 2zm2.63-3.07c.3-.58.7-1.1 1.17-1.52a1 1 0 10-1.17 1.52zM6.5 17h3.11c.18.36.4.7.66 1H6.5A2.5 2.5 0 014 15.5v-11A2.5 2.5 0 016.5 2h7A2.5 2.5 0 0116 4.5v4.69c-.32-.1-.66-.16-1-.19V4.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 3 5 3.67 5 4.5v11c0 .83.67 1.5 1.5 1.5zM6 5.5C6 4.67 6.67 4 7.5 4h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 6.5v-1zM7.5 5a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-5zm10 7.48a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v.76a4.5 4.5 0 102 3.74.5.5 0 10-1 0 3.5 3.5 0 11-1.7-3h-.8a.5.5 0 100 1h2z",
    fill: primaryFill
  }));
};

export const CalculatorArrowClockwiseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorArrowClockwiseRegularIcon({}), 'CalculatorArrowClockwiseRegular');

const CalculatorMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2A2.5 2.5 0 003 4.5v9A2.5 2.5 0 005.5 16h7a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0012.5 2h-7zM5 5a1 1 0 011-1h6a1 1 0 011 1v2a1 1 0 01-1 1H6a1 1 0 01-1-1V5zm0 5a1 1 0 112 0 1 1 0 01-2 0zm4-1a1 1 0 110 2 1 1 0 010-2zm0 2.75a1 1 0 110 2 1 1 0 010-2zM11 10a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 110 2 1 1 0 010-2zm-6 0a1 1 0 110 2 1 1 0 010-2zM7.5 18a2.5 2.5 0 01-2-1h7a3.5 3.5 0 003.5-3.5v-9c.6.46 1 1.18 1 2v7a4.5 4.5 0 01-4.5 4.5h-5z",
    fill: primaryFill
  }));
};

export const CalculatorMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorMultipleFilledIcon({}), 'CalculatorMultipleFilled');

const CalculatorMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1H6zm0 1h6v2H6V5zm2 5a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 100 2 1 1 0 000-2zM11 10a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 100 2 1 1 0 000-2zM5 10a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 100 2 1 1 0 000-2zM5.5 2A2.5 2.5 0 003 4.5v9A2.5 2.5 0 005.5 16h7a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0012.5 2h-7zM4 4.5C4 3.67 4.67 3 5.5 3h7c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 014 13.5v-9zM7.5 18a2.5 2.5 0 01-2-1h7a3.5 3.5 0 003.5-3.5v-9c.6.46 1 1.18 1 2v7a4.5 4.5 0 01-4.5 4.5h-5z",
    fill: primaryFill
  }));
};

export const CalculatorMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorMultipleRegularIcon({}), 'CalculatorMultipleRegular');

const Calendar3DayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm-8 3a.5.5 0 00-.5.41v7.18a.5.5 0 001 0V6.41A.5.5 0 006.5 6zM10 6a.5.5 0 00-.5.41v7.18a.5.5 0 001 0V6.41A.5.5 0 0010 6zm3.5 0a.5.5 0 00-.5.41v7.18a.5.5 0 001 0V6.41a.5.5 0 00-.5-.41z",
    fill: primaryFill
  }));
};

export const Calendar3DayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3DayFilledIcon({}), 'Calendar3DayFilled');

const Calendar3DayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zm-8 2a.5.5 0 01.5.41v7.09a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5zM10 6a.5.5 0 01.5.41v7.09a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5zm3.5 0a.5.5 0 01.5.41v7.09a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const Calendar3DayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3DayRegularIcon({}), 'Calendar3DayRegular');

const CalendarAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CalendarAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAddFilledIcon({}), 'CalendarAddFilled');

const CalendarAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CalendarAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAddRegularIcon({}), 'CalendarAddRegular');

const CalendarAgendaFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9zm-3-8a.5.5 0 00-.41-.5H6.41a.5.5 0 000 1h7.18a.5.5 0 00.41-.5zm0 3.5a.5.5 0 00-.41-.5H6.41a.5.5 0 000 1h7.18A.5.5 0 0014 10zm0 3.5a.5.5 0 00-.41-.5H6.41a.5.5 0 000 1h7.18a.5.5 0 00.41-.5z",
    fill: primaryFill
  }));
};

export const CalendarAgendaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgendaFilledIcon({}), 'CalendarAgendaFilled');

const CalendarAgendaRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9zm-1 0v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zm-2-8a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09c.28 0 .5.22.5.5zm0 3.5a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09c.28 0 .5.22.5.5zm0 3.5a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const CalendarAgendaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgendaRegularIcon({}), 'CalendarAgendaRegular');

const CalendarArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6V7zm2 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const CalendarArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowDownFilledIcon({}), 'CalendarArrowDownFilled');

const CalendarArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const CalendarArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowDownRegularIcon({}), 'CalendarArrowDownRegular');

const CalendarArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zm2 4.9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CalendarArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRightFilledIcon({}), 'CalendarArrowRightFilled');

const CalendarArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CalendarArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRightRegularIcon({}), 'CalendarArrowRightRegular');

const CalendarAssistantFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm0 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1.1-7.17a.5.5 0 01.48-.33h1.18a.5.5 0 01.47.66l-.28.84H16a.5.5 0 01.42.77l-2.25 3.5a.5.5 0 01-.9-.4l.5-1.87H13a.5.5 0 01-.47-.67l.88-2.5z",
    fill: primaryFill
  }));
};

export const CalendarAssistantFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistantFilledIcon({}), 'CalendarAssistantFilled');

const CalendarAssistantRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 15h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 13h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18z",
    fill: primaryFill
  }));
};

export const CalendarAssistantRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistantRegularIcon({}), 'CalendarAssistantRegular');

const CalendarCancelFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5.7l1.15 1.15a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14z",
    fill: primaryFill
  }));
};

export const CalendarCancelFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancelFilledIcon({}), 'CalendarCancelFilled');

const CalendarCancelRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5.7l1.15 1.15a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14z",
    fill: primaryFill
  }));
};

export const CalendarCancelRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancelRegularIcon({}), 'CalendarCancelRegular');

const CalendarChatFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h3.92l.07-.23a5.48 5.48 0 01.8-5.81 1 1 0 11.67-.67A5.48 5.48 0 0117 9.6V7zm-9 3a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 110-2 1 1 0 010 2zm3.56 2.68A4.5 4.5 0 0114.5 10a4.5 4.5 0 11-2.18 8.44l-1.8.54a.4.4 0 01-.5-.5l.54-1.8zM16.5 13h-4a.5.5 0 000 1h4a.5.5 0 100-1zm-4 2a.5.5 0 000 1h2a.5.5 0 100-1h-2z",
    fill: primaryFill
  }));
};

export const CalendarChatFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarChatFilledIcon({}), 'CalendarChatFilled');

const CalendarChatRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 11a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm2-2a1 1 0 00.3-.04c.2-.24.42-.46.66-.67A1 1 0 1010 11zm-4.5 5h3.7c.08.27.18.52.29.77l-.07.23H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5zm0-12C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5h-9zm5.06 12.68l-.54 1.8c-.1.3.2.6.5.5l1.8-.54a4.5 4.5 0 10-1.76-1.75zM12.5 16a.5.5 0 010-1h2a.5.5 0 110 1h-2zm0-3h4a.5.5 0 110 1h-4a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const CalendarChatRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarChatRegularIcon({}), 'CalendarChatRegular');

const CalendarCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmarkFilledIcon({}), 'CalendarCheckmarkFilled');

const CalendarCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmarkRegularIcon({}), 'CalendarCheckmarkRegular');

const CalendarClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.5-6.5a.5.5 0 011 0V14h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const CalendarClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClockFilledIcon({}), 'CalendarClockFilled');

const CalendarClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zm9 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.5-6.5a.5.5 0 011 0V14h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const CalendarClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClockRegularIcon({}), 'CalendarClockRegular');

const CalendarDayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm-1.78 6H7.28c-.44 0-.6.05-.77.13a.9.9 0 00-.38.38c-.07.14-.12.29-.13.62v2.59c0 .44.05.6.13.77.1.16.22.29.38.38.14.07.29.12.62.13H12.72c.44 0 .6-.05.77-.13a.9.9 0 00.38-.38c.07-.14.12-.29.13-.62v-2.59c0-.44-.05-.6-.13-.77a.9.9 0 00-.38-.38 1.24 1.24 0 00-.62-.13h-.15zm.2 1h.07V13H7.01v-2.98h5.9zm.58-4H6.41a.5.5 0 000 1h7.18a.5.5 0 000-1h-.09z",
    fill: primaryFill
  }));
};

export const CalendarDayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDayFilledIcon({}), 'CalendarDayFilled');

const CalendarDayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zm-1.78 5c.44 0 .6.05.77.13.16.1.29.22.38.38.08.16.13.33.13.77v2.44c0 .44-.05.6-.13.77a.9.9 0 01-.38.38c-.16.08-.33.13-.77.13H7.28c-.44 0-.6-.05-.77-.13a.9.9 0 01-.38-.38c-.08-.16-.13-.33-.13-.77v-2.44c0-.44.05-.6.13-.77a.9.9 0 01.38-.38c.16-.08.33-.13.77-.13h5.44zm.2 1H7V13h5.98v-2.98h-.08zm.58-4a.5.5 0 01.09 1H6.5a.5.5 0 01-.09-1h7.09z",
    fill: primaryFill
  }));
};

export const CalendarDayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDayRegularIcon({}), 'CalendarDayRegular');

const CalendarEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2c-.7.03-1.37.31-1.9.84l-4.83 4.83c-.4.4-.7.92-.84 1.48l-.21.85H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-3.52 12.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const CalendarEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEditFilledIcon({}), 'CalendarEditFilled');

const CalendarEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5V9c-.34.02-.68.1-1 .23V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.97l-.04.15-.21.85H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-3.52 11.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const CalendarEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEditRegularIcon({}), 'CalendarEditRegular');

const CalendarEmptyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v7.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9z",
    fill: primaryFill
  }));
};

export const CalendarEmptyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmptyFilledIcon({}), 'CalendarEmptyFilled');

const CalendarEmptyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM16 7H4v7.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7zm-1.5-3h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const CalendarEmptyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmptyRegularIcon({}), 'CalendarEmptyRegular');

const CalendarErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6V7zm2 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const CalendarErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarErrorFilledIcon({}), 'CalendarErrorFilled');

const CalendarErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const CalendarErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarErrorRegularIcon({}), 'CalendarErrorRegular');

const CalendarInfoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-.63 9.5a.62.62 0 111.25 0 .62.62 0 01-1.24 0zm1.13 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const CalendarInfoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarInfoFilledIcon({}), 'CalendarInfoFilled');

const CalendarInfoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-.63 8.5a.62.62 0 111.25 0 .62.62 0 01-1.24 0zm1.13 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const CalendarInfoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarInfoRegularIcon({}), 'CalendarInfoRegular');

const CalendarLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5V7zm-9 3a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 110-2 1 1 0 010 2zm4-4a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 110-2 1 1 0 010 2zm4-4a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const CalendarLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtrFilledIcon({}), 'CalendarLtrFilled');

const CalendarLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 11a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm2-2a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm2-2a1 1 0 100-2 1 1 0 000 2zm4-5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9zM4 7h12v7.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5V7zm1.5-3h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4z",
    fill: primaryFill
  }));
};

export const CalendarLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtrRegularIcon({}), 'CalendarLtrRegular');

const CalendarMailFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5V5h12v-.5A2.5 2.5 0 0011.5 2h-7zM14 6H2v5.5A2.5 2.5 0 004.5 14H5v-3a3 3 0 013-3h6V6zm-7.93 4.48A2 2 0 018 9h8a2 2 0 011.93 1.48L12 13.96l-5.93-3.48zm6.31 4.42L18 11.6V16a2 2 0 01-2 2H8a2 2 0 01-2-2v-4.4l5.62 3.3c.23.14.53.14.76 0z",
    fill: primaryFill
  }));
};

export const CalendarMailFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMailFilledIcon({}), 'CalendarMailFilled');

const CalendarMailRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V8h-1V6H3v5.5c0 .83.67 1.5 1.5 1.5H5v1h-.5A2.5 2.5 0 012 11.5v-7zm11 0c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h10v-.5zM8 9a2 2 0 00-2 2v5c0 1.1.9 2 2 2h8a2 2 0 002-2v-5a2 2 0 00-2-2H8zm-1 2a1 1 0 011-1h8a1 1 0 011 1v.02l-5 2.94-5-2.94V11zm0 1.18l4.62 2.72c.23.14.53.14.76 0L17 12.18V16a1 1 0 01-1 1H8a1 1 0 01-1-1v-3.82z",
    fill: primaryFill
  }));
};

export const CalendarMailRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMailRegularIcon({}), 'CalendarMailRegular');

const CalendarMentionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v3.42A4.98 4.98 0 0010 15c0 .71.15 1.39.42 2H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm.5 9a3 3 0 101.28 5.71.5.5 0 11.44.9A4 4 0 1119 15v.51a1.5 1.5 0 01-2.65.97A2 2 0 0113 15a2 2 0 013.17-1.62.5.5 0 01.83.37v1.75a.5.5 0 101 0V15a3 3 0 00-3-3zm-1 3a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const CalendarMentionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMentionFilledIcon({}), 'CalendarMentionFilled');

const CalendarMentionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.92a4.96 4.96 0 00-1-.32V7H4v7.5c0 .83.67 1.5 1.5 1.5h4.6c.07.35.18.68.32 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm.5 8a3 3 0 101.28 5.71.5.5 0 11.44.9A4 4 0 1119 15v.51a1.5 1.5 0 01-2.65.97A2 2 0 0113 15a2 2 0 013.17-1.62.5.5 0 01.83.37v1.75a.5.5 0 101 0V15a3 3 0 00-3-3zm-1 3a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const CalendarMentionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMentionRegularIcon({}), 'CalendarMentionRegular');

const CalendarMonthFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM7 11a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zM7 7a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }));
};

export const CalendarMonthFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonthFilledIcon({}), 'CalendarMonthFilled');

const CalendarMonthRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zM7 11a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zM7 7a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const CalendarMonthRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonthRegularIcon({}), 'CalendarMonthRegular');

const CalendarMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 13.5V6H2v7.5A2.5 2.5 0 004.5 16h9a2.5 2.5 0 002.5-2.5zm0-9A2.5 2.5 0 0013.5 2h-9A2.5 2.5 0 002 4.5V5h14v-.5zM5 17c.46.6 1.18 1 2 1h6.5a4.5 4.5 0 004.5-4.5v-7c0-.82-.4-1.54-1-2v9a3.5 3.5 0 01-3.5 3.5H5z",
    fill: primaryFill
  }));
};

export const CalendarMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultipleFilledIcon({}), 'CalendarMultipleFilled');

const CalendarMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 4.5A2.5 2.5 0 0013.5 2h-9A2.5 2.5 0 002 4.5v9A2.5 2.5 0 004.5 16h9a2.5 2.5 0 002.5-2.5v-9zM3 6h12v7.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 013 13.5V6zm1.5-3h9c.83 0 1.5.67 1.5 1.5V5H3v-.5C3 3.67 3.67 3 4.5 3zM5 17c.46.6 1.18 1 2 1h6.5a4.5 4.5 0 004.5-4.5v-7c0-.82-.4-1.54-1-2v9a3.5 3.5 0 01-3.5 3.5H5z",
    fill: primaryFill
  }));
};

export const CalendarMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultipleRegularIcon({}), 'CalendarMultipleRegular');

const CalendarPatternFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.75 3h8.5A2.75 2.75 0 0117 5.75v8.5A2.75 2.75 0 0114.25 17h-8.5A2.75 2.75 0 013 14.25v-8.5A2.75 2.75 0 015.75 3zM4.5 5.75V7h11V5.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25zM14.7 8l-4 4h2.6l2.2-2.2V8h-.8zm-1.4 0h-2.6l-4 4h2.6l4-4zm-8 4l4-4H6.7l-2.2 2.2V12h.8zm-.8-3.2l.8-.8h-.8v.8zM14.7 12h.8v-.8l-.8.8z",
    fill: primaryFill
  }));
};

export const CalendarPatternFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPatternFilledIcon({}), 'CalendarPatternFilled');

const CalendarPatternRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3zM4 5.5V7h12V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5zM14.7 8l-4 4h2.6L16 9.3V8h-1.3zm-1.4 0h-2.6l-4 4h2.6l4-4zm-8 4l4-4H6.7L4 10.7V12h1.3zM4 9.3L5.3 8H4v1.3zM14.7 12H16v-1.3L14.7 12z",
    fill: primaryFill
  }));
};

export const CalendarPatternRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPatternRegularIcon({}), 'CalendarPatternRegular');

const CalendarPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.4a3 3 0 00-3.73 4.6 2.5 2.5 0 00-2.23 3H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm3 9a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CalendarPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPersonFilledIcon({}), 'CalendarPersonFilled');

const CalendarPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v3.9c-.3-.17-.64-.3-1-.36V7H4v7.5c0 .83.67 1.5 1.5 1.5h5.55a2.51 2.51 0 00-.01 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm3 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CalendarPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPersonRegularIcon({}), 'CalendarPersonRegular');

const CalendarPhoneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v1.05a2.51 2.51 0 00-.5-.05h-3a2.5 2.5 0 00-2.5 2.5v6c0 .17.02.34.05.5H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-.75 6c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75v-5.5C18 9.78 17.22 9 16.25 9h-2.5zm.25 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarPhoneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPhoneFilledIcon({}), 'CalendarPhoneFilled');

const CalendarPhoneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v2.55a2.51 2.51 0 00-.5-.05H16V7H4v7.5c0 .83.67 1.5 1.5 1.5H11v.5c0 .17.02.34.05.5H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-.75 5c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75v-5.5C18 9.78 17.22 9 16.25 9h-2.5zm.25 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarPhoneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPhoneRegularIcon({}), 'CalendarPhoneRegular');

const CalendarQuestionMarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.62-2a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm-1.23-3.54c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMarkFilledIcon({}), 'CalendarQuestionMarkFilled');

const CalendarQuestionMarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm0 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.62-2a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm-1.23-3.54c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMarkRegularIcon({}), 'CalendarQuestionMarkRegular');

const CalendarReplyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm0 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const CalendarReplyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReplyFilledIcon({}), 'CalendarReplyFilled');

const CalendarReplyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm0 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const CalendarReplyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReplyRegularIcon({}), 'CalendarReplyRegular');

const CalendarRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM3 7h14v7.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5V7zm9 3a1 1 0 102 0 1 1 0 00-2 0zm1 4a1 1 0 100-2 1 1 0 000 2zm-4-4a1 1 0 102 0 1 1 0 00-2 0zm1 4a1 1 0 100-2 1 1 0 000 2zm-4-4a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const CalendarRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtlFilledIcon({}), 'CalendarRtlFilled');

const CalendarRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 11a1 1 0 110-2 1 1 0 010 2zm-1 2a1 1 0 102 0 1 1 0 00-2 0zm-2-2a1 1 0 110-2 1 1 0 010 2zm-1 2a1 1 0 102 0 1 1 0 00-2 0zm-2-2a1 1 0 110-2 1 1 0 010 2zM3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM16 7H4v7.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7zm-1.5-3h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const CalendarRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtlRegularIcon({}), 'CalendarRtlRegular');

const CalendarSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5V7H3v2.47a4.5 4.5 0 016.06 5.97L10.62 17h3.88a2.5 2.5 0 002.5-2.5zm0-9A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zM7.1 16.3a3.5 3.5 0 11.7-.7l2.55 2.55a.5.5 0 01-.7.7L7.1 16.3zm.4-2.8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const CalendarSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSearchFilledIcon({}), 'CalendarSearchFilled');

const CalendarSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v3.76c.32-.12.65-.2 1-.23V7h12v7.5c0 .83-.67 1.5-1.5 1.5H9.12l1 1h4.38a2.5 2.5 0 002.5-2.5v-9zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zm1.1 12.3a3.5 3.5 0 11.7-.7l2.55 2.55a.5.5 0 01-.7.7L6.6 16.3zm.4-2.8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const CalendarSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSearchRegularIcon({}), 'CalendarSearchRegular');

const CalendarSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-2.43 8.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const CalendarSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSettingsFilledIcon({}), 'CalendarSettingsFilled');

const CalendarSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-2.43 7.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const CalendarSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSettingsRegularIcon({}), 'CalendarSettingsRegular');

const CalendarStarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zm2 4.9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const CalendarStarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStarFilledIcon({}), 'CalendarStarFilled');

const CalendarStarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const CalendarStarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStarRegularIcon({}), 'CalendarStarRegular');

const CalendarSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CalendarSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSyncFilledIcon({}), 'CalendarSyncFilled');

const CalendarSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CalendarSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSyncRegularIcon({}), 'CalendarSyncRegular');

const CalendarTodayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 10a1 1 0 100-2 1 1 0 000 2zm7 4.5V7H3v7.5A2.5 2.5 0 005.5 17h3v-1.75a1.5 1.5 0 01-.98-2.64h.01l1.5-1.25a1.5 1.5 0 011.94 0l1.5 1.25a1.5 1.5 0 01-.97 2.64V17h3a2.5 2.5 0 002.5-2.5zM12 9a2 2 0 11-4 0 2 2 0 014 0zm5-3.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm-5.82 8.63a.5.5 0 00.64-.76l-1.5-1.25a.5.5 0 00-.64 0l-1.5 1.25a.5.5 0 10.64.76l.68-.56v3.93a.5.5 0 101 0v-3.93l.68.56z",
    fill: primaryFill
  }));
};

export const CalendarTodayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTodayFilledIcon({}), 'CalendarTodayFilled');

const CalendarTodayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-3v-1h3c.83 0 1.5-.67 1.5-1.5V7H4v7.5c0 .83.67 1.5 1.5 1.5h3v1h-3A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM11 9a1 1 0 11-2 0 1 1 0 012 0zm.88 5.07a.5.5 0 01-.7.06l-.68-.56v3.93a.5.5 0 11-1 0v-3.93l-.68.56a.5.5 0 01-.64-.76l1.5-1.25a.5.5 0 01.64 0l1.5 1.25c.21.17.24.49.06.7z",
    fill: primaryFill
  }));
};

export const CalendarTodayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTodayRegularIcon({}), 'CalendarTodayRegular');

const CalendarToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17H9v-3.5a2.5 2.5 0 012.04-2.46A2.5 2.5 0 0113.5 9h2c.56 0 1.08.19 1.5.5V7zm-9 3a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 110-2 1 1 0 010 2zm4-4a1 1 0 11-2 0 1 1 0 012 0zm1 2v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const CalendarToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarToolboxFilledIcon({}), 'CalendarToolboxFilled');

const CalendarToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 11a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm1 3H5.5A1.5 1.5 0 014 14.5V7h12v2.05c.37.07.7.23 1 .45v-4A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17H9v-1zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zm4.5 7a1 1 0 100-2 1 1 0 000 2zm2 1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const CalendarToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarToolboxRegularIcon({}), 'CalendarToolboxRegular');

const CalendarWeekNumbersFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9zM7 6.5v1a.5.5 0 01-1 0v-1a.5.5 0 011 0zM6.5 9c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm.5 3.5v1a.5.5 0 01-1 0v-1a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const CalendarWeekNumbersFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarWeekNumbersFilledIcon({}), 'CalendarWeekNumbersFilled');

const CalendarWeekNumbersRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5v-9zm3 1a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM6.5 9c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm.5 3.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }));
};

export const CalendarWeekNumbersRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarWeekNumbersRegularIcon({}), 'CalendarWeekNumbersRegular');

const CalendarWeekStartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm-8 3a.5.5 0 00-.5.41v7.18a.5.5 0 001 0V6.41A.5.5 0 006.5 6z",
    fill: primaryFill
  }));
};

export const CalendarWeekStartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarWeekStartFilledIcon({}), 'CalendarWeekStartFilled');

const CalendarWeekStartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zm-8 2a.5.5 0 01.5.41v7.09a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarWeekStartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarWeekStartRegularIcon({}), 'CalendarWeekStartRegular');

const CalendarWorkWeekFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 9V7h6v2H7zm10-3.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9zM6.5 6h7c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarWorkWeekFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarWorkWeekFilledIcon({}), 'CalendarWorkWeekFilled');

const CalendarWorkWeekRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 6a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-7zM7 9V7h6v2H7zm10-3.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9zM5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5v-9C4 4.67 4.67 4 5.5 4z",
    fill: primaryFill
  }));
};

export const CalendarWorkWeekRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarWorkWeekRegularIcon({}), 'CalendarWorkWeekRegular');

const CallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.99 2.07A2 2 0 019.3 3l.08.15.66 1.47a2.5 2.5 0 01-.44 2.72l-.13.13-1.05.98c-.19.17-.04.86.64 2.04.6 1.06 1.1 1.56 1.35 1.58h.1l2.05-.64a1.5 1.5 0 011.56.45l.1.11 1.35 1.88a2 2 0 01-.13 2.5l-.12.12-.54.52a3.5 3.5 0 01-3.72.7c-1.93-.78-3.69-2.56-5.29-5.33S3.52 7.2 3.82 5.14a3.5 3.5 0 012.26-2.8l.19-.06.72-.21z",
    fill: primaryFill
  }));
};

export const CallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallFilledIcon({}), 'CallFilled');

const CallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.99 2.07l-.72.21a3.5 3.5 0 00-2.45 2.86c-.3 2.06.36 4.48 1.96 7.25 1.6 2.77 3.36 4.55 5.3 5.33a3.5 3.5 0 003.7-.7l.55-.52a2 2 0 00.25-2.62L14.22 12a1.5 1.5 0 00-1.65-.56l-2.05.63-.06.01c-.22.04-.74-.45-1.4-1.58-.67-1.18-.82-1.87-.63-2.04l1.05-.98a2.5 2.5 0 00.57-2.85l-.66-1.47a2 2 0 00-2.4-1.1zm1.49 1.5l.66 1.47a1.5 1.5 0 01-.35 1.71l-1.04.98c-.67.63-.45 1.71.45 3.27.85 1.47 1.62 2.19 2.45 2.06l.12-.02 2.09-.64a.5.5 0 01.55.19l1.36 1.88a1 1 0 01-.13 1.3l-.54.52a2.5 2.5 0 01-2.65.5c-1.7-.68-3.3-2.3-4.8-4.9-1.5-2.59-2.1-4.8-1.84-6.61a2.5 2.5 0 011.75-2.04l.72-.22a1 1 0 011.2.55z",
    fill: primaryFill
  }));
};

export const CallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallRegularIcon({}), 'CallRegular');

const CallAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.55 2.44a4.1 4.1 0 012.99-.32c.5.12.94.45 1.2.9l.9 1.57a2.5 2.5 0 01-.84 3.36l-.79.5c-.32.2-.44.52-.37.77.27.9.86 1.9 1.52 2.58.19.2.54.25.9.05l.43-.26a2.5 2.5 0 013.44.94l.8 1.44c.27.47.31 1.03.12 1.53a3.9 3.9 0 01-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 01-2.03-7.06 2.87 2.87 0 011.51-2.5zM15 2.5a.5.5 0 00-1 0V5h-2.5a.5.5 0 000 1H14v2.5a.5.5 0 001 0V6h2.5a.5.5 0 000-1H15V2.5z",
    fill: primaryFill
  }));
};

export const CallAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallAddFilledIcon({}), 'CallAddFilled');

const CallAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.55 2.44a4.1 4.1 0 012.99-.32c.5.12.94.45 1.2.9l.97 1.7a2.5 2.5 0 01-.67 3.24l-.6.45c-.28.22-.4.52-.34.77.18.82.59 1.57 1.15 2.13.17.16.47.22.8.1l.66-.26a2.5 2.5 0 013.07 1.11l.95 1.7c.27.48.31 1.04.12 1.54a3.9 3.9 0 01-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 01-2.03-7.06 2.87 2.87 0 011.51-2.5zm.49.87c-.59.33-.98.89-1 1.66-.04 1.61.33 3.85 1.9 6.53a15.3 15.3 0 004.62 5.15 1.9 1.9 0 001.91.16 2.91 2.91 0 001.45-1.65.84.84 0 00-.06-.7l-.95-1.7a1.5 1.5 0 00-1.85-.68l-.66.26c-.58.22-1.33.2-1.85-.32A5.32 5.32 0 016.13 9.4c-.17-.72.2-1.4.71-1.78l.6-.46c.6-.45.78-1.29.4-1.94l-.97-1.7a.93.93 0 00-.58-.43 3.1 3.1 0 00-2.25.22zM15 2.5a.5.5 0 00-1 0V5h-2.5a.5.5 0 000 1H14v2.5a.5.5 0 001 0V6h2.5a.5.5 0 000-1H15V2.5z",
    fill: primaryFill
  }));
};

export const CallAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallAddRegularIcon({}), 'CallAddRegular');

const CallCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.8-1.44a2.5 2.5 0 00-3.44-.94l-.44.26c-.35.2-.7.15-.9-.05a6.83 6.83 0 01-1.5-2.58c-.08-.25.04-.56.36-.77l.8-.5a2.5 2.5 0 00.82-3.36l-.9-1.56c-.25-.46-.69-.79-1.2-.91zm11.31.03c.2.2.2.5 0 .7l-5 5a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64 4.65-4.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const CallCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallCheckmarkFilledIcon({}), 'CallCheckmarkFilled');

const CallCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.95-1.7a2.5 2.5 0 00-3.07-1.12l-.67.25c-.32.13-.62.07-.79-.1A4.32 4.32 0 017.1 9.19c-.06-.25.06-.55.34-.77l.6-.45a2.5 2.5 0 00.67-3.24l-.97-1.7c-.26-.45-.7-.78-1.2-.9zm-3.5 2.85c.02-.77.41-1.33 1-1.66a3.1 3.1 0 012.25-.22c.24.06.45.22.58.43l.97 1.7c.38.65.2 1.49-.4 1.94l-.6.46c-.52.39-.88 1.06-.71 1.78.22.99.7 1.92 1.42 2.62.52.51 1.27.54 1.85.32l.66-.26a1.5 1.5 0 011.85.67l.95 1.7c.12.22.14.47.06.7a2.91 2.91 0 01-1.45 1.66 1.9 1.9 0 01-1.9-.16 15.3 15.3 0 01-4.64-5.15 12.28 12.28 0 01-1.89-6.53zm14.81-2.82c.2.2.2.5 0 .7l-5 5a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64 4.65-4.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const CallCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallCheckmarkRegularIcon({}), 'CallCheckmarkRegular');

const CallConnectingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.55 2.44a4.1 4.1 0 012.99-.32c.5.12.94.45 1.2.9l.9 1.57a2.5 2.5 0 01-.84 3.36l-.79.5c-.32.2-.44.52-.37.77.27.9.86 1.9 1.52 2.58.19.2.54.25.9.05l.43-.26a2.5 2.5 0 013.44.94l.8 1.44c.27.47.31 1.03.12 1.53a3.9 3.9 0 01-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 01-2.03-7.06 2.87 2.87 0 011.51-2.5zm9.2-.38a.5.5 0 10-.5.88l.4.21a8.5 8.5 0 014.32 6.58l.03.32a.5.5 0 101-.1l-.03-.32a9.5 9.5 0 00-4.84-7.35l-.39-.22zm-1.18 2.68a.5.5 0 01.69-.17l.12.07a6.5 6.5 0 013.07 4.51l.04.27a.5.5 0 11-.98.16l-.05-.27a5.5 5.5 0 00-2.6-3.8l-.12-.08a.5.5 0 01-.17-.69z",
    fill: primaryFill
  }));
};

export const CallConnectingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallConnectingFilledIcon({}), 'CallConnectingFilled');

const CallConnectingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.95-1.7a2.5 2.5 0 00-3.07-1.12l-.67.25c-.32.13-.62.07-.79-.1A4.32 4.32 0 017.1 9.19c-.06-.25.06-.55.34-.77l.6-.45a2.5 2.5 0 00.67-3.24l-.97-1.7c-.26-.45-.7-.78-1.2-.9zm-3.5 2.85c.02-.77.41-1.33 1-1.66a3.1 3.1 0 012.25-.22c.24.06.45.22.58.43l.97 1.7c.38.65.2 1.49-.4 1.94l-.6.46c-.52.39-.88 1.06-.71 1.78.22.99.7 1.92 1.42 2.62.52.51 1.27.54 1.85.32l.66-.26a1.5 1.5 0 011.85.67l.95 1.7c.12.22.14.47.06.7a2.91 2.91 0 01-1.45 1.66 1.9 1.9 0 01-1.9-.16 15.3 15.3 0 01-4.64-5.15 12.28 12.28 0 01-1.89-6.53zm9.7-2.9a.5.5 0 10-.48.87l.38.21a8.5 8.5 0 014.33 6.58l.03.32a.5.5 0 101-.1l-.03-.32a9.5 9.5 0 00-4.84-7.35l-.39-.22zm-1.17 2.67a.5.5 0 01.69-.17l.12.08a6.5 6.5 0 013.07 4.5l.04.27a.5.5 0 11-.98.16l-.05-.27a5.5 5.5 0 00-2.6-3.8l-.12-.08a.5.5 0 01-.17-.69z",
    fill: primaryFill
  }));
};

export const CallConnectingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallConnectingRegularIcon({}), 'CallConnectingRegular');

const CallDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.8-1.44a2.5 2.5 0 00-3.44-.94l-.44.26c-.35.2-.7.15-.9-.05a6.83 6.83 0 01-1.5-2.58c-.08-.25.04-.56.36-.77l.8-.5a2.5 2.5 0 00.82-3.36l-.9-1.56c-.25-.46-.69-.79-1.2-.91zm11.31.03c.2.2.2.5 0 .7L15.21 5.5l2.64 2.65a.5.5 0 01-.7.7L14.5 6.21l-2.65 2.64a.5.5 0 01-.7-.7l2.64-2.65-2.64-2.65a.5.5 0 01.7-.7l2.65 2.64 2.65-2.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const CallDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallDismissFilledIcon({}), 'CallDismissFilled');

const CallDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.95-1.7a2.5 2.5 0 00-3.07-1.12l-.67.25c-.32.13-.62.07-.79-.1A4.32 4.32 0 017.1 9.19c-.06-.25.06-.55.34-.77l.6-.45a2.5 2.5 0 00.67-3.24l-.97-1.7c-.26-.45-.7-.78-1.2-.9zm-3.5 2.85c.02-.77.41-1.33 1-1.66a3.1 3.1 0 012.25-.22c.24.06.45.22.58.43l.97 1.7c.38.65.2 1.49-.4 1.94l-.6.46c-.52.39-.88 1.06-.71 1.78.22.99.7 1.92 1.42 2.62.52.51 1.27.54 1.85.32l.66-.26a1.5 1.5 0 011.85.67l.95 1.7c.12.22.14.47.06.7a2.91 2.91 0 01-1.45 1.66 1.9 1.9 0 01-1.9-.16 15.3 15.3 0 01-4.64-5.15 12.28 12.28 0 01-1.89-6.53zm14.81-2.82c.2.2.2.5 0 .7L15.21 5.5l2.64 2.65a.5.5 0 01-.7.7L14.5 6.21l-2.65 2.64a.5.5 0 01-.7-.7l2.64-2.65-2.64-2.65a.5.5 0 01.7-.7l2.65 2.64 2.65-2.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const CallDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallDismissRegularIcon({}), 'CallDismissRegular');

const CallEndFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.96 10.94l-.16.83c-.15.78-.87 1.3-1.7 1.22l-1.63-.16c-.72-.07-1.25-.59-1.47-1.33-.3-1-.5-1.75-.5-1.75a6.63 6.63 0 00-5 0s-.2.75-.5 1.75c-.2.67-.5 1.26-1.2 1.33l-1.63.16c-.81.08-1.6-.43-1.82-1.2l-.25-.84c-.25-.82-.03-1.7.58-2.28C4.1 7.3 6.67 6.51 9.99 6.5c3.33 0 5.6.78 7.16 2.16.66.58.97 1.46.8 2.28z",
    fill: primaryFill
  }));
};

export const CallEndFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallEndFilledIcon({}), 'CallEndFilled');

const CallEndRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6c3.33 0 5.59 1.28 7.15 2.66.66.58.97 1.46.8 2.28l-.15.83c-.15.78-.87 1.3-1.7 1.22l-1.63-.16c-.72-.07-1.25-.59-1.47-1.33-.3-1-.5-1.75-.5-1.75a6.63 6.63 0 00-5 0s-.2.75-.5 1.75c-.2.67-.5 1.26-1.2 1.33l-1.63.16c-.81.08-1.6-.43-1.82-1.2l-.25-.84c-.25-.82-.03-1.7.58-2.28C4.1 7.3 6.68 6 10 6zm3.48 3.53l.02.1a46.1 46.1 0 00.46 1.58c.13.45.39.6.6.62l1.64.16c.35.04.57-.17.62-.4l.16-.84c.09-.46-.08-.98-.49-1.34A9.37 9.37 0 0010 7C6.93 7 4.6 8.2 3.37 9.39c-.33.32-.46.8-.31 1.28l.24.83c.1.3.43.53.77.5l1.63-.17.05-.01.05-.05c.07-.09.15-.26.24-.55a115.65 115.65 0 00.46-1.6l.03-.1c.1-.37.45-.62.62-.7a7.62 7.62 0 015.73 0c.15.07.48.29.59.68v.03z",
    fill: primaryFill
  }));
};

export const CallEndRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallEndRegularIcon({}), 'CallEndRegular');

const CallExclamationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.8 7.77l.16-.83c.16-.82-.15-1.7-.8-2.28-1.57-1.38-3.84-2.16-7.17-2.16-3.32 0-5.89.79-7.31 2.17-.6.59-.83 1.46-.58 2.28l.25.83A1.74 1.74 0 004.17 9l1.63-.16c.7-.07 1-.66 1.2-1.33.3-1 .5-1.75.5-1.75a6.63 6.63 0 015 0s.2.75.5 1.75c.22.74.75 1.26 1.47 1.33l1.63.16c.83.08 1.55-.44 1.7-1.22zm-3.3 5.73a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM10 11a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const CallExclamationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallExclamationFilledIcon({}), 'CallExclamationFilled');

const CallExclamationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c3.33 0 5.59 1.28 7.15 2.66.66.58.97 1.46.8 2.28l-.15.83c-.15.78-.87 1.3-1.7 1.22l-1.63-.16c-.72-.07-1.25-.59-1.47-1.33-.3-1-.5-1.75-.5-1.75a6.63 6.63 0 00-5 0S7.3 6.5 7 7.5c-.2.67-.5 1.26-1.2 1.33l-1.63.16c-.81.08-1.6-.43-1.82-1.2l-.25-.84c-.25-.82-.03-1.7.58-2.28C4.1 3.3 6.68 2 10 2zm3.48 3.53l.02.1a46.1 46.1 0 00.46 1.58c.13.45.39.6.6.62L16.2 8c.35.04.57-.17.62-.4l.16-.84c.09-.46-.08-.98-.49-1.34A9.37 9.37 0 0010 3C6.93 3 4.6 4.2 3.37 5.39c-.33.32-.46.8-.31 1.28l.24.83c.1.3.43.53.77.5l1.63-.17.05-.01.05-.05c.07-.09.15-.26.24-.55a115.6 115.6 0 00.46-1.6l.03-.1c.1-.37.45-.62.62-.7a7.62 7.62 0 015.73 0c.15.07.48.29.59.68v.03zm1.02 7.97a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM10 11a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const CallExclamationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallExclamationRegularIcon({}), 'CallExclamationRegular');

const CallForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.29 2.2l-.85-.16a2.53 2.53 0 00-2.32.81C4.7 4.42 4 6.87 4 10.2c0 3.32.72 5.7 2.13 7.12.6.6 1.5.83 2.34.58l.84-.25c.8-.23 1.33-1 1.24-1.82l-.17-1.63a1.53 1.53 0 00-1.26-1.36l-1.8-.32a6.36 6.36 0 01-.16-4.98l1.93-.5c.7-.19 1.21-.8 1.28-1.5l.17-1.65a1.54 1.54 0 00-1.25-1.7zm5.06 3.45a.5.5 0 00-.7.7L16.29 9H10.5a.5.5 0 000 1h5.8l-2.65 2.65a.5.5 0 00.7.7l3.5-3.5a.5.5 0 000-.7l-3.5-3.5z",
    fill: primaryFill
  }));
};

export const CallForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallForwardFilledIcon({}), 'CallForwardFilled');

const CallForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.93 2.08l-.18-.04c-1-.17-2.02.18-2.71.94C4.67 4.5 4 6.85 4 10c0 3.15.67 5.5 2.03 7.01a2.97 2.97 0 002.9.9l.65-.15a2.2 2.2 0 001.67-2.36L11.1 14a2.2 2.2 0 00-1.69-1.92l-1.4-.32-.03-.02-.04-.07a1.63 1.63 0 01-.1-.24c-.09-.32-.14-.8-.14-1.43 0-.85.1-1.42.25-1.68a.2.2 0 01.13-.09l1.33-.3A2.2 2.2 0 0011.11 6l.14-1.4a2.2 2.2 0 00-1.68-2.37l-.64-.15zM5.19 10c0-2.88.59-4.95 1.73-6.21.4-.45 1-.66 1.6-.57l.13.03.65.15a1 1 0 01.76 1.08l-.14 1.4a1 1 0 01-.76.87l-1.34.31a1.4 1.4 0 00-.88.64c-.3.49-.42 1.25-.42 2.3 0 1.6.29 2.58 1.08 2.88l.11.03 1.45.34a1 1 0 01.76.87l.14 1.4a1 1 0 01-.75 1.07l-.65.16c-.64.15-1.3-.05-1.74-.54-1.14-1.27-1.73-3.33-1.73-6.2zm9.16-4.35a.5.5 0 00-.7.7L16.29 9H10.5a.5.5 0 000 1h5.8l-2.65 2.65a.5.5 0 00.7.7l3.5-3.5a.5.5 0 000-.7l-3.5-3.5z",
    fill: primaryFill
  }));
};

export const CallForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallForwardRegularIcon({}), 'CallForwardRegular');

const CallInboundFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.8-1.44a2.5 2.5 0 00-3.44-.94l-.44.26c-.35.2-.7.15-.9-.05a6.83 6.83 0 01-1.5-2.58c-.08-.25.04-.56.36-.77l.8-.5a2.5 2.5 0 00.82-3.36l-.9-1.56c-.25-.46-.69-.79-1.2-.91zm11.31.03c.2.2.2.5 0 .7L12.71 8h3.79a.5.5 0 010 1h-5a.5.5 0 01-.5-.5v-5a.5.5 0 111 0v3.8l5.15-5.15c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const CallInboundFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallInboundFilledIcon({}), 'CallInboundFilled');

const CallInboundRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.95-1.7a2.5 2.5 0 00-3.07-1.12l-.67.25c-.32.13-.62.07-.79-.1A4.32 4.32 0 017.1 9.19c-.06-.25.06-.55.34-.77l.6-.45a2.5 2.5 0 00.67-3.24l-.97-1.7c-.26-.45-.7-.78-1.2-.9zm-3.5 2.85c.02-.77.41-1.33 1-1.66a3.1 3.1 0 012.25-.22c.24.06.45.22.58.43l.97 1.7c.38.65.2 1.49-.4 1.94l-.6.46c-.52.39-.88 1.06-.71 1.78.22.99.7 1.92 1.42 2.62.52.51 1.27.54 1.85.32l.66-.26a1.5 1.5 0 011.85.67l.95 1.7c.12.22.14.47.06.7a2.91 2.91 0 01-1.45 1.66 1.9 1.9 0 01-1.9-.16 15.3 15.3 0 01-4.64-5.15 12.28 12.28 0 01-1.89-6.53zm14.81-2.12a.5.5 0 10-.7-.7L12 7.29V3.5a.5.5 0 00-1 0v5c0 .29.22.5.5.5h5a.5.5 0 000-1h-3.8l5.15-5.14z",
    fill: primaryFill
  }));
};

export const CallInboundRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallInboundRegularIcon({}), 'CallInboundRegular');

const CallMissedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.8 7.77l.16-.83c.16-.82-.15-1.7-.8-2.28-1.57-1.38-3.84-2.16-7.17-2.16-3.32 0-5.89.79-7.31 2.17-.6.59-.83 1.46-.58 2.28l.25.83A1.74 1.74 0 004.17 9l1.63-.16c.7-.07 1-.66 1.2-1.33.3-1 .5-1.75.5-1.75a6.63 6.63 0 015 0s.2.75.5 1.75c.22.74.75 1.26 1.47 1.33l1.63.16c.83.08 1.55-.44 1.7-1.22zM9.5 11.5c.28 0 .5.22.5.5v1.5h1a.5.5 0 110 1H9.5A.5.5 0 019 14v-2c0-.28.22-.5.5-.5zm-4 2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM10 10a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
    fill: primaryFill
  }));
};

export const CallMissedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallMissedFilledIcon({}), 'CallMissedFilled');

const CallMissedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c3.33 0 5.59 1.28 7.15 2.66.66.58.97 1.46.8 2.28l-.15.83c-.15.78-.87 1.3-1.7 1.22l-1.63-.16c-.72-.07-1.25-.59-1.47-1.33-.3-1-.5-1.75-.5-1.75a6.63 6.63 0 00-5 0S7.3 6.5 7 7.5c-.2.67-.5 1.26-1.2 1.33l-1.63.16c-.81.08-1.6-.43-1.82-1.2l-.25-.84c-.25-.82-.03-1.7.58-2.28C4.1 3.3 6.68 2 10 2zm3.48 3.53l.02.1a46.1 46.1 0 00.46 1.58c.13.45.39.6.6.62L16.2 8c.35.04.57-.17.62-.4l.16-.84c.09-.46-.08-.98-.49-1.34A9.37 9.37 0 0010 3C6.93 3 4.6 4.2 3.37 5.39c-.33.32-.46.8-.31 1.28l.24.83c.1.3.43.53.77.5l1.63-.17.05-.01.05-.05c.07-.09.15-.26.24-.55a115.6 115.6 0 00.46-1.6l.03-.1c.1-.37.45-.62.62-.7a7.62 7.62 0 015.73 0c.15.07.48.29.59.68v.03zM10 12a.5.5 0 00-1 0v2c0 .28.22.5.5.5H11a.5.5 0 100-1h-1V12zm-4.5 1.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM10 10a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
    fill: primaryFill
  }));
};

export const CallMissedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallMissedRegularIcon({}), 'CallMissedRegular');

const CallOutboundFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.8-1.44a2.5 2.5 0 00-3.44-.94l-.44.26c-.35.2-.7.15-.9-.05a6.83 6.83 0 01-1.5-2.58c-.08-.25.04-.56.36-.77l.8-.5a2.5 2.5 0 00.82-3.36l-.9-1.56c-.25-.46-.69-.79-1.2-.91zm4.6 6.73a.5.5 0 010-.7L16.3 3H12.5a.5.5 0 110-1h5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0V3.7l-5.15 5.15a.5.5 0 01-.7 0z",
    fill: primaryFill
  }));
};

export const CallOutboundFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallOutboundFilledIcon({}), 'CallOutboundFilled');

const CallOutboundRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.95-1.7a2.5 2.5 0 00-3.07-1.12l-.67.25c-.32.13-.62.07-.79-.1A4.32 4.32 0 017.1 9.19c-.06-.25.06-.55.34-.77l.6-.45a2.5 2.5 0 00.67-3.24l-.97-1.7c-.26-.45-.7-.78-1.2-.9zm-3.5 2.85c.02-.77.41-1.33 1-1.66a3.1 3.1 0 012.25-.22c.24.06.45.22.58.43l.97 1.7c.38.65.2 1.49-.4 1.94l-.6.46c-.52.39-.88 1.06-.71 1.78.22.99.7 1.92 1.42 2.62.52.51 1.27.54 1.85.32l.66-.26a1.5 1.5 0 011.85.67l.95 1.7c.12.22.14.47.06.7a2.91 2.91 0 01-1.45 1.66 1.9 1.9 0 01-1.9-.16 15.3 15.3 0 01-4.64-5.15 12.28 12.28 0 01-1.89-6.53zm8.1 3.18a.5.5 0 10.71.7L17 3.71V7.5a.5.5 0 101 0v-5a.5.5 0 00-.5-.5h-5a.5.5 0 100 1h3.8l-5.15 5.15z",
    fill: primaryFill
  }));
};

export const CallOutboundRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallOutboundRegularIcon({}), 'CallOutboundRegular');

const CallParkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.55 2.44a4.1 4.1 0 012.99-.32c.5.12.94.45 1.2.9l.9 1.57a2.5 2.5 0 01-.84 3.36l-.79.5c-.32.2-.44.52-.37.77.27.9.86 1.9 1.52 2.58.19.2.54.25.9.05l.43-.26a2.5 2.5 0 013.44.94l.8 1.44c.27.47.31 1.03.12 1.53a3.9 3.9 0 01-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 01-2.03-7.06 2.87 2.87 0 011.51-2.5zM12.5 2a.5.5 0 00-.5.5v7a.5.5 0 101 0V7h1.5a2.5 2.5 0 000-5h-2zm2 4H13V3h1.5a1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const CallParkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallParkFilledIcon({}), 'CallParkFilled');

const CallParkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.95-1.7a2.5 2.5 0 00-3.07-1.12l-.67.25c-.32.13-.62.07-.79-.1A4.32 4.32 0 017.1 9.19c-.06-.25.06-.55.34-.77l.6-.45a2.5 2.5 0 00.67-3.24l-.97-1.7c-.26-.45-.7-.78-1.2-.9zm-3.5 2.85c.02-.77.41-1.33 1-1.66a3.1 3.1 0 012.25-.22c.24.06.45.22.58.43l.97 1.7c.38.65.2 1.49-.4 1.94l-.6.46c-.52.39-.88 1.06-.71 1.78.22.99.7 1.92 1.42 2.62.52.51 1.27.54 1.85.32l.66-.26a1.5 1.5 0 011.85.67l.95 1.7c.12.22.14.47.06.7a2.91 2.91 0 01-1.45 1.66 1.9 1.9 0 01-1.9-.16 15.3 15.3 0 01-4.64-5.15 12.28 12.28 0 01-1.89-6.53zM12.5 2a.5.5 0 00-.5.5v7a.5.5 0 101 0V7h1.5a2.5 2.5 0 000-5h-2zm2 4H13V3h1.5a1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const CallParkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallParkRegularIcon({}), 'CallParkRegular');

const CallPauseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.55 2.44a4.1 4.1 0 012.99-.32c.5.12.94.45 1.2.9l.9 1.57a2.5 2.5 0 01-.84 3.36l-.79.5c-.32.2-.44.52-.37.77.27.9.86 1.9 1.52 2.58.19.2.54.25.9.05l.43-.26a2.5 2.5 0 013.44.94l.8 1.44c.27.47.31 1.03.12 1.53a3.9 3.9 0 01-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 01-2.03-7.06 2.87 2.87 0 011.51-2.5zM13 2.5a.5.5 0 00-1 0v6a.5.5 0 001 0v-6zm3 0a.5.5 0 00-1 0v6a.5.5 0 001 0v-6z",
    fill: primaryFill
  }));
};

export const CallPauseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallPauseFilledIcon({}), 'CallPauseFilled');

const CallPauseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.55 2.44a4.1 4.1 0 012.99-.32c.5.12.94.45 1.2.9l.97 1.7a2.5 2.5 0 01-.67 3.24l-.6.45c-.28.22-.4.52-.34.77.18.82.59 1.57 1.15 2.13.17.16.47.22.8.1l.66-.26a2.5 2.5 0 013.07 1.11l.95 1.7c.27.48.31 1.04.12 1.54a3.9 3.9 0 01-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 01-2.03-7.06 2.87 2.87 0 011.51-2.5zm.49.87c-.59.33-.98.89-1 1.66-.04 1.61.33 3.85 1.9 6.53a15.3 15.3 0 004.62 5.15 1.9 1.9 0 001.91.16 2.91 2.91 0 001.45-1.65.84.84 0 00-.06-.7l-.95-1.7a1.5 1.5 0 00-1.85-.68l-.66.26c-.58.22-1.33.2-1.85-.32A5.32 5.32 0 016.13 9.4c-.17-.72.2-1.4.71-1.78l.6-.46c.6-.45.78-1.29.4-1.94l-.97-1.7a.93.93 0 00-.58-.43 3.1 3.1 0 00-2.25.22zM13 2.5a.5.5 0 00-1 0v6a.5.5 0 001 0v-6zm3 0a.5.5 0 00-1 0v6a.5.5 0 001 0v-6z",
    fill: primaryFill
  }));
};

export const CallPauseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallPauseRegularIcon({}), 'CallPauseRegular');

const CallProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.96 6.94l-.16.83c-.15.78-.87 1.3-1.7 1.22l-1.63-.16c-.72-.07-1.25-.59-1.47-1.33-.3-1-.5-1.75-.5-1.75a6.63 6.63 0 00-5 0S7.3 6.5 7 7.5c-.2.67-.5 1.26-1.2 1.33l-1.63.16c-.81.08-1.6-.43-1.82-1.2l-.25-.84c-.25-.82-.03-1.7.58-2.28C4.1 3.3 6.67 2.51 9.99 2.5c3.33 0 5.6.78 7.16 2.16.66.58.97 1.46.8 2.28zM6.82 16.68a4.5 4.5 0 106.36-6.36 4.5 4.5 0 00-6.36 6.36zm5.65-.7a3.5 3.5 0 01-4.57.32l4.9-4.9a3.5 3.5 0 01-.33 4.57zm-.37-5.28l-4.9 4.9a3.5 3.5 0 014.9-4.9z",
    fill: primaryFill
  }));
};

export const CallProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallProhibitedFilledIcon({}), 'CallProhibitedFilled');

const CallProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.15 4.66A10.37 10.37 0 0010 2C6.67 2 4.1 3.29 2.68 4.67c-.6.59-.83 1.46-.58 2.28l.25.83A1.74 1.74 0 004.17 9l1.63-.16c.7-.07 1-.66 1.2-1.33.3-1 .5-1.75.5-1.75a6.63 6.63 0 015 0s.2.75.5 1.75c.22.74.75 1.26 1.47 1.33l1.63.16c.83.08 1.55-.44 1.7-1.22l.16-.83c.16-.82-.15-1.7-.8-2.28zm-3.65.96l-.02-.1-.01-.02c-.1-.4-.44-.61-.6-.68a7.62 7.62 0 00-5.73-.01c-.16.09-.51.34-.61.7l-.03.1a90.96 90.96 0 01-.46 1.6c-.09.3-.17.47-.24.56a.2.2 0 01-.05.05l-.05.01L4.07 8a.74.74 0 01-.77-.5l-.24-.83c-.15-.48-.02-.96.31-1.28A9.62 9.62 0 0110 3a9.37 9.37 0 016.5 2.4c.4.37.57.89.48 1.35l-.16.83c-.05.24-.27.45-.62.41l-1.64-.16c-.21-.02-.47-.17-.6-.62a59.02 59.02 0 01-.46-1.59zM6.82 16.68a4.5 4.5 0 106.36-6.36 4.5 4.5 0 00-6.36 6.36zm5.65-.7a3.5 3.5 0 01-4.57.32l4.9-4.9a3.5 3.5 0 01-.33 4.57zm-.37-5.28l-4.9 4.9a3.5 3.5 0 014.9-4.9z",
    fill: primaryFill
  }));
};

export const CallProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallProhibitedRegularIcon({}), 'CallProhibitedRegular');

const CallTransferFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.55 2.44a4.1 4.1 0 012.99-.32c.5.12.94.45 1.2.9l.97 1.7a2.5 2.5 0 01-.67 3.24l-.6.45c-.28.22-.4.52-.34.77.18.82.59 1.57 1.15 2.13.17.16.47.22.8.1l.66-.26a2.5 2.5 0 013.07 1.11l.95 1.7c.27.48.31 1.04.12 1.54a3.9 3.9 0 01-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 01-2.03-7.06 2.87 2.87 0 011.51-2.5zM12 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm.5-.5a.5.5 0 100-1 .5.5 0 000 1zM14 6.5a.5.5 0 11-1 0 .5.5 0 011 0zm3 1a.5.5 0 001 0v-5a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h3.8l-2.15 2.15a.5.5 0 00.7.7L17 3.71V7.5z",
    fill: primaryFill
  }));
};

export const CallTransferFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallTransferFilledIcon({}), 'CallTransferFilled');

const CallTransferRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.54 2.12a4.1 4.1 0 00-2.99.32 2.87 2.87 0 00-1.5 2.5c-.06 1.8.36 4.22 2.02 7.06A16.28 16.28 0 009 17.48c.94.63 1.99.65 2.88.24a3.9 3.9 0 001.96-2.22c.2-.5.15-1.06-.12-1.53l-.95-1.7a2.5 2.5 0 00-3.07-1.12l-.67.25c-.32.13-.62.07-.79-.1A4.32 4.32 0 017.1 9.19c-.06-.25.06-.55.34-.77l.6-.45a2.5 2.5 0 00.67-3.24l-.97-1.7c-.26-.45-.7-.78-1.2-.9zm-3.5 2.85c.02-.77.41-1.33 1-1.66a3.1 3.1 0 012.25-.22c.24.06.45.22.58.43l.97 1.7c.38.65.2 1.49-.4 1.94l-.6.46c-.52.39-.88 1.06-.71 1.78.22.99.7 1.92 1.42 2.62.52.51 1.27.54 1.85.32l.66-.26a1.5 1.5 0 011.85.67l.95 1.7c.12.22.14.47.06.7a2.91 2.91 0 01-1.45 1.66 1.9 1.9 0 01-1.9-.16 15.3 15.3 0 01-4.64-5.15 12.28 12.28 0 01-1.89-6.53zM12 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm1-1a.5.5 0 11-1 0 .5.5 0 011 0zm1-1a.5.5 0 11-1 0 .5.5 0 011 0zM17.5 8a.5.5 0 01-.5-.5V3.7l-2.15 2.15a.5.5 0 11-.7-.7L16.29 3H12.5a.5.5 0 110-1h5c.28 0 .5.22.5.5v5a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};

export const CallTransferRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CallTransferRegularIcon({}), 'CallTransferRegular');

const CalligraphyPenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2.5a.5.5 0 00-1 0v2C5 5.33 5.67 6 6.5 6h.2L5.24 9.08a2.5 2.5 0 00.1 2.33l3.47 5.91c.16.27.4.48.69.59v-7.04a1 1 0 111 0v7.03c.28-.11.52-.31.67-.58l3.47-5.9a2.5 2.5 0 00.1-2.34L13.28 6h.22c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 00-1 0v2a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const CalligraphyPenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenFilledIcon({}), 'CalligraphyPenFilled');

const CalligraphyPenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2.5a.5.5 0 00-1 0v2C5 5.33 5.67 6 6.5 6h.21L5.25 9.08a2.5 2.5 0 00.1 2.33l3.47 5.91a1.37 1.37 0 002.36 0l3.47-5.9a2.5 2.5 0 00.1-2.34L13.29 6h.21c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 00-1 0v2a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-2zM12.18 6l1.67 3.5c.2.46.18.98-.07 1.4l-3.28 5.61v-5.64a1 1 0 10-1 0v5.64l-3.28-5.6a1.5 1.5 0 01-.07-1.4L7.82 6h4.36z",
    fill: primaryFill
  }));
};

export const CalligraphyPenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenRegularIcon({}), 'CalligraphyPenRegular');

const CalligraphyPenCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L13.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.5 11l.33-.01a2.5 2.5 0 01-.2.42l-3.46 5.91c-.15.27-.4.47-.67.58v-7.03a1 1 0 00.46-1.16c.95.8 2.19 1.29 3.54 1.29z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9 5.5c0 1.35.49 2.59 1.3 3.54a1 1 0 00-.8 1.83v7.04a1.37 1.37 0 01-.7-.59l-3.46-5.9a2.5 2.5 0 01-.1-2.34L6.7 6h-.2A1.5 1.5 0 015 4.5v-2a.5.5 0 011 0v2c0 .28.22.5.5.5h2.52L9 5.5z",
    fill: primaryFill
  }));
};

export const CalligraphyPenCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenCheckmarkFilledIcon({}), 'CalligraphyPenCheckmarkFilled');

const CalligraphyPenCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2.35-5.65l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 2.65-2.64a.5.5 0 01.7.7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.85 10.99a5.64 5.64 0 01-1.09-.04l-3.26 5.56v-5.64a1 1 0 10-1 0v5.64l-3.28-5.6a1.5 1.5 0 01-.07-1.4L7.82 6h1.2a5.57 5.57 0 010-1H6.5a.5.5 0 01-.5-.5v-2a.5.5 0 00-1 0v2C5 5.33 5.67 6 6.5 6h.21L5.25 9.08a2.5 2.5 0 00.1 2.33l3.47 5.91a1.37 1.37 0 002.36 0l3.47-5.9c.08-.14.14-.28.2-.43z",
    fill: primaryFill
  }));
};

export const CalligraphyPenCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenCheckmarkRegularIcon({}), 'CalligraphyPenCheckmarkRegular');

const CalligraphyPenErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.25zm0 2.87l.35-.01a2.5 2.5 0 01-.2.42l-3.47 5.91c-.15.27-.4.48-.68.59v-7.04a1 1 0 00.46-1.16c.95.8 2.19 1.29 3.54 1.29zM9 5.5c0 1.35.49 2.59 1.3 3.54a1 1 0 00-.8 1.83v7.04a1.37 1.37 0 01-.68-.59l-3.47-5.9a2.5 2.5 0 01-.1-2.34l1.23-2.6A1.75 1.75 0 015 4.75v-2a.75.75 0 011.5 0v2c0 .14.11.25.25.25h2.27L9 5.5z",
    fill: primaryFill
  }));
};

export const CalligraphyPenErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenErrorFilledIcon({}), 'CalligraphyPenErrorFilled');

const CalligraphyPenErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM14 3.5a.5.5 0 011 0v2a.5.5 0 01-1 0v-2zm1.13 4a.62.62 0 11-1.25 0 .62.62 0 011.24 0zm-.28 3.49a5.64 5.64 0 01-1.09-.04l-3.26 5.56v-5.64a1 1 0 10-1 0v5.64l-3.28-5.6a1.5 1.5 0 01-.07-1.4L7.82 6h1.2a5.57 5.57 0 010-1H6.5a.5.5 0 01-.5-.5v-2a.5.5 0 00-1 0v2C5 5.33 5.67 6 6.5 6h.21L5.25 9.08a2.5 2.5 0 00.1 2.33l3.47 5.91a1.37 1.37 0 002.36 0l3.47-5.9c.08-.14.14-.28.2-.43z",
    fill: primaryFill
  }));
};

export const CalligraphyPenErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenErrorRegularIcon({}), 'CalligraphyPenErrorRegular');

const CalligraphyPenQuestionMarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm.62 7a.62.62 0 10-1.24 0 .62.62 0 001.24 0zm1.23-3.55c0-1.1-.82-1.95-1.85-1.95-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.5 11l.33-.01a2.5 2.5 0 01-.2.42l-3.46 5.91c-.15.27-.4.47-.67.58v-7.03a1 1 0 00.46-1.16c.95.8 2.19 1.29 3.54 1.29z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9 5.5c0 1.35.49 2.59 1.3 3.54a1 1 0 00-.8 1.83v7.04a1.37 1.37 0 01-.7-.59l-3.46-5.9a2.5 2.5 0 01-.1-2.34L6.7 6h-.2A1.5 1.5 0 015 4.5v-2a.5.5 0 011 0v2c0 .28.22.5.5.5h2.52L9 5.5z",
    fill: primaryFill
  }));
};

export const CalligraphyPenQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenQuestionMarkFilledIcon({}), 'CalligraphyPenQuestionMarkFilled');

const CalligraphyPenQuestionMarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.5 1.88a.62.62 0 110 1.25.62.62 0 010-1.25zm0-4.88c1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0c-.01-1.13.8-1.95 1.85-1.95z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.85 10.99a5.64 5.64 0 01-1.09-.04l-3.26 5.56v-5.64a1 1 0 10-1 0v5.64l-3.28-5.6a1.5 1.5 0 01-.07-1.4L7.82 6h1.2a5.57 5.57 0 010-1H6.5a.5.5 0 01-.5-.5v-2a.5.5 0 00-1 0v2C5 5.33 5.67 6 6.5 6h.21L5.25 9.08a2.5 2.5 0 00.1 2.33l3.47 5.91a1.37 1.37 0 002.36 0l3.47-5.9c.08-.14.14-.28.2-.43z",
    fill: primaryFill
  }));
};

export const CalligraphyPenQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalligraphyPenQuestionMarkRegularIcon({}), 'CalligraphyPenQuestionMarkRegular');

const CameraFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 10a3 3 0 116 0 3 3 0 01-6 0zm-.22-7.17c.26-.51.78-.83 1.34-.83h3.77c.57 0 1.09.32 1.34.83L13.81 4h1.7A2.5 2.5 0 0118 6.5v8a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h1.68l.6-1.17zM10 6a4 4 0 100 8 4 4 0 000-8z",
    fill: primaryFill
  }));
};

export const CameraFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraFilledIcon({}), 'CameraFilled');

const CameraRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6a4 4 0 100 8 4 4 0 000-8zm-3 4a3 3 0 116 0 3 3 0 01-6 0zm1.12-8a1.5 1.5 0 00-1.34.83L6.2 4H4.5A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5v-8A2.5 2.5 0 0015.5 4h-1.69l-.58-1.17A1.5 1.5 0 0011.89 2H8.12zm-.44 1.28A.5.5 0 018.12 3h3.77c.19 0 .36.1.45.28l.72 1.44a.5.5 0 00.45.28h2c.82 0 1.5.67 1.5 1.5v8c0 .83-.68 1.5-1.5 1.5h-11A1.5 1.5 0 013 14.5v-8C3 5.67 3.67 5 4.5 5h2a.5.5 0 00.44-.28l.73-1.44z",
    fill: primaryFill
  }));
};

export const CameraRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraRegularIcon({}), 'CameraRegular');

const CameraAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.78 2.83c.26-.51.78-.83 1.34-.83h3.77c.57 0 1.09.32 1.34.83L13.81 4h1.7A2.5 2.5 0 0118 6.5v3.76a5.48 5.48 0 00-4.13-1.23 4 4 0 10-4.85 4.85A5.56 5.56 0 009.6 17H4.5A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h1.7l.58-1.17zM10 7a3 3 0 012.9 2.24 5.51 5.51 0 00-3.66 3.66A3 3 0 0110 7zm9 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 100 1H14v1.5a.5.5 0 101 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CameraAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraAddFilledIcon({}), 'CameraAddFilled');

const CameraAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.12 2a1.5 1.5 0 00-1.34.83L6.2 4H4.5A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-8C3 5.67 3.68 5 4.5 5h2a.5.5 0 00.45-.28l.73-1.44A.5.5 0 018.12 3h3.77c.19 0 .36.1.45.28l.72 1.44a.5.5 0 00.45.28h2c.82 0 1.5.67 1.5 1.5v3.1c.35.19.69.4 1 .66V6.5A2.5 2.5 0 0015.5 4h-1.7l-.58-1.17A1.5 1.5 0 0011.89 2H8.12zM10 6a4 4 0 013.88 3.03c-.33.04-.66.11-.98.2a3 3 0 10-3.66 3.67c-.1.32-.17.65-.2.98A4 4 0 0110 6zm9 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 100 1H14v1.5a.5.5 0 101 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CameraAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraAddRegularIcon({}), 'CameraAddRegular');

const CameraDomeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 010 3h-13A1.5 1.5 0 012 4.5zM10 9a3 3 0 100 6 3 3 0 000-6zm-2 3a2 2 0 114 0 2 2 0 01-4 0zM3 7h14v4a7 7 0 11-14 0V7zm7 1a4 4 0 100 8 4 4 0 000-8z",
    fill: primaryFill
  }));
};

export const CameraDomeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraDomeFilledIcon({}), 'CameraDomeFilled');

const CameraDomeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 12a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8zm-3 4a3 3 0 116 0 3 3 0 01-6 0zM2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v1c0 .65-.42 1.2-1 1.41V11a7 7 0 11-14 0V6.91c-.58-.2-1-.76-1-1.41v-1zM4 7v4a6 6 0 1012 0V7H4zm-.5-3a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13z",
    fill: primaryFill
  }));
};

export const CameraDomeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraDomeRegularIcon({}), 'CameraDomeRegular');

const CameraEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.12 2a1.5 1.5 0 00-1.34.83L6.2 4H4.5A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17H8l.06-.35.37-1.5c.12-.46.34-.9.64-1.26a4 4 0 114.82-4.83l.21-.22A2.87 2.87 0 0118 8.7V6.5A2.5 2.5 0 0015.5 4h-1.69l-.58-1.16A1.5 1.5 0 0011.89 2H8.12zM13 9.94A3 3 0 109.94 13L13 9.94zm1.8-.4l-4.82 4.84a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const CameraEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraEditFilledIcon({}), 'CameraEditFilled');

const CameraEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.78 2.83c.26-.51.78-.83 1.34-.83h3.77c.57 0 1.08.32 1.34.83L13.8 4h1.7A2.5 2.5 0 0118 6.5v2.2c-.3-.26-.65-.45-1-.56V6.5c0-.83-.68-1.5-1.5-1.5h-2a.5.5 0 01-.45-.28l-.73-1.44A.5.5 0 0011.9 3H8.12a.5.5 0 00-.44.28l-.73 1.44A.5.5 0 016.5 5h-2C3.68 5 3 5.67 3 6.5v8c0 .83.68 1.5 1.5 1.5h3.72l-.16.65L8 17H4.5A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h1.7l.58-1.17zm7.1 6.23a4 4 0 10-4.8 4.83c.05-.08.12-.15.2-.22l.66-.67A3 3 0 1113 9.94l.89-.88zm.93.49l-4.83 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const CameraEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraEditRegularIcon({}), 'CameraEditRegular');

const CameraOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.2L2.15 2.86a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-.95-.95c-.22.07-.46.1-.7.1h-11A2.5 2.5 0 012 14.5v-8c0-1.02.62-1.9 1.5-2.3zm8.95 8.96l-.71-.71a3 3 0 01-4.18-4.18l-.72-.72a4 4 0 005.61 5.61zM9.22 7.1l3.68 3.68A3 3 0 009.22 7.1zM14 10c0 .55-.11 1.08-.32 1.56l4.06 4.06c.17-.34.26-.72.26-1.12v-8A2.5 2.5 0 0015.5 4h-1.69l-.58-1.17A1.5 1.5 0 0011.89 2H8.12a1.5 1.5 0 00-1.34.83L6.2 4h-.07l2.32 2.32A3.99 3.99 0 0114 10z",
    fill: primaryFill
  }));
};

export const CameraOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraOffFilledIcon({}), 'CameraOffFilled');

const CameraOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.2L2.15 2.86a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-.95-.95c-.22.07-.46.1-.7.1h-11A2.5 2.5 0 012 14.5v-8c0-1.02.62-1.9 1.5-2.3zM15.3 16l-2.85-2.84a4 4 0 01-5.61-5.61L4.31 5c-.74.1-1.3.73-1.3 1.49v8c0 .83.67 1.5 1.5 1.5h10.78zm-3.56-3.55L7.55 8.26a3 3 0 004.18 4.18zm-3.3-6.13l.78.78a3 3 0 013.68 3.68l.78.78A3.99 3.99 0 0010 6c-.55 0-1.08.11-1.56.32zM17 14.5c0 .12 0 .23-.03.34l.77.78c.17-.34.26-.72.26-1.12v-8A2.5 2.5 0 0015.5 4h-1.69l-.58-1.17A1.5 1.5 0 0011.89 2H8.12a1.5 1.5 0 00-1.34.83L6.2 4h-.07l.79.79a.5.5 0 00.04-.07l.73-1.44A.5.5 0 018.12 3h3.77c.19 0 .36.1.45.28l.72 1.44a.5.5 0 00.45.28h2c.82 0 1.5.67 1.5 1.5v8z",
    fill: primaryFill
  }));
};

export const CameraOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraOffRegularIcon({}), 'CameraOffRegular');

const CameraSwitchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.15 2.15c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L15.29 5H4a1 1 0 00-1 1v6.5a.5.5 0 01-1 0V6c0-1.1.9-2 2-2h11.3l-1.15-1.15a.5.5 0 010-.7zM17 14a1 1 0 01-1 1H4.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L4.71 16H16a2 2 0 002-2V7.5a.5.5 0 00-1 0V14zm-4-4a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const CameraSwitchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraSwitchFilledIcon({}), 'CameraSwitchFilled');

const CameraSwitchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.85 2.15a.5.5 0 00-.7.7L15.29 4H4a2 2 0 00-2 2v6.5a.5.5 0 001 0V6a1 1 0 011-1h11.3l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2zM16 15a1 1 0 001-1V7.5a.5.5 0 011 0V14a2 2 0 01-2 2H4.7l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L4.71 15H16zm-3-5a3 3 0 11-6 0 3 3 0 016 0zm-1 0a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }));
};

export const CameraSwitchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CameraSwitchRegularIcon({}), 'CameraSwitchRegular');

const CaretDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.8 7a1 1 0 00-.78 1.63l3.81 4.72c.6.74 1.74.74 2.34 0l3.81-4.72A1 1 0 0014.2 7H5.8z",
    fill: primaryFill
  }));
};

export const CaretDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretDownFilledIcon({}), 'CaretDownFilled');

const CaretDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.02 8.63A1 1 0 015.8 7h8.4a1 1 0 01.78 1.63l-3.81 4.72a1.5 1.5 0 01-2.34 0L5.02 8.63zM14.2 8H5.8l3.81 4.72c.2.25.58.25.78 0L14.2 8z",
    fill: primaryFill
  }));
};

export const CaretDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretDownRegularIcon({}), 'CaretDownRegular');

const CaretDownRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 5.96a1 1 0 00-1.7-.71l-8.05 8.04a1 1 0 00.7 1.71h7.55c.83 0 1.5-.67 1.5-1.5V5.96z",
    fill: primaryFill
  }));
};

export const CaretDownRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretDownRightFilledIcon({}), 'CaretDownRightFilled');

const CaretDownRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.3 5.25a1 1 0 011.7.7v7.55c0 .83-.67 1.5-1.5 1.5H5.96a1 1 0 01-.71-1.7l8.04-8.05zm.7.7L5.96 14h7.54a.5.5 0 00.5-.5V5.96z",
    fill: primaryFill
  }));
};

export const CaretDownRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretDownRightRegularIcon({}), 'CaretDownRightRegular');

const CaretLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 14.2a1 1 0 01-1.63.78l-4.72-3.81a1.5 1.5 0 010-2.34l4.72-3.81A1 1 0 0113 5.8v8.4z",
    fill: primaryFill
  }));
};

export const CaretLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretLeftFilledIcon({}), 'CaretLeftFilled');

const CaretLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.37 14.98A1 1 0 0013 14.2V5.8a1 1 0 00-1.63-.78L6.65 8.83a1.5 1.5 0 000 2.34l4.72 3.81zM12 5.8v8.4L7.28 10.4a.5.5 0 010-.78L12 5.8z",
    fill: primaryFill
  }));
};

export const CaretLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretLeftRegularIcon({}), 'CaretLeftRegular');

const CaretRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 14.2a1 1 0 001.63.78l4.72-3.81a1.5 1.5 0 000-2.34L8.63 5.02A1 1 0 007 5.8v8.4z",
    fill: primaryFill
  }));
};

export const CaretRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretRightFilledIcon({}), 'CaretRightFilled');

const CaretRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.63 14.98A1 1 0 017 14.2V5.8a1 1 0 011.63-.78l4.72 3.81c.74.6.74 1.74 0 2.34l-4.72 3.81zM8 5.8v8.4l4.72-3.81a.5.5 0 000-.78L8 5.8z",
    fill: primaryFill
  }));
};

export const CaretRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretRightRegularIcon({}), 'CaretRightRegular');

const CaretUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.8 13.9a1 1 0 01-.78-1.62l3.81-4.72a1.5 1.5 0 012.34 0l3.81 4.72a1 1 0 01-.78 1.63H5.8z",
    fill: primaryFill
  }));
};

export const CaretUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretUpFilledIcon({}), 'CaretUpFilled');

const CaretUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.02 12.28a1 1 0 00.78 1.63h8.4a1 1 0 00.78-1.63l-3.81-4.72a1.5 1.5 0 00-2.34 0l-3.81 4.72zm9.18.63H5.8L9.6 8.19a.5.5 0 01.78 0l3.81 4.72z",
    fill: primaryFill
  }));
};

export const CaretUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CaretUpRegularIcon({}), 'CaretUpRegular');

const CartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5h.44c.72 0 1.14.47 1.38.94.17.32.29.72.39 1.06H16a1 1 0 01.96 1.27l-1.5 5.28A2 2 0 0113.55 13H8.46a2 2 0 01-1.93-1.47L5.9 9.17l-.01-.03-1.03-3.5-.1-.33a5.2 5.2 0 00-.32-.91c-.16-.31-.3-.4-.5-.4H3.5a.5.5 0 01-.5-.5zM8.5 17a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: primaryFill
  }));
};

export const CartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CartFilledIcon({}), 'CartFilled');

const CartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5h.44c.72 0 1.14.47 1.38.94.17.32.29.72.39 1.06H16a1 1 0 01.96 1.27l-1.5 5.28A2 2 0 0113.55 13H8.46a2 2 0 01-1.93-1.47L5.9 9.17l-.01-.03-1.03-3.5-.1-.33a5.2 5.2 0 00-.32-.91c-.16-.31-.3-.4-.5-.4H3.5a.5.5 0 01-.5-.5zm3.84 5.37l.66 2.4a1 1 0 00.96.73h5.08a1 1 0 00.96-.73L16 6H6l.84 2.87zM10 15.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zm6 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const CartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CartRegularIcon({}), 'CartRegular');

const CastFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-13zM4 8c0-.28.22-.5.5-.5a6 6 0 016 6 .5.5 0 01-1 0 5 5 0 00-5-5A.5.5 0 014 8zm.5 2A3.5 3.5 0 018 13.5a.5.5 0 11-1 0A2.5 2.5 0 004.5 11a.5.5 0 010-1zm.25 4a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const CastFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CastFilledIcon({}), 'CastFilled');

const CastRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 14.5v-9zM3.5 5a.5.5 0 00-.5.5v9c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-13zm2 8.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM4 10.5c0-.28.22-.5.5-.5A3.5 3.5 0 018 13.5a.5.5 0 11-1 0A2.5 2.5 0 004.5 11a.5.5 0 01-.5-.5zM4 8c0-.28.22-.5.5-.5a6 6 0 016 6 .5.5 0 01-1 0 5 5 0 00-5-5A.5.5 0 014 8z",
    fill: primaryFill
  }));
};

export const CastRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CastRegularIcon({}), 'CastRegular');

const Cellular3GFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.03 3c-.32 0-.74.14-1.16.6a.5.5 0 11-.74-.66A2.57 2.57 0 014.03 2c.64 0 1.2.28 1.57.7A1.5 1.5 0 015.28 5c.27.2.47.42.6.69.26.59.08 1.2-.28 1.61-.36.42-.93.7-1.56.7-.65 0-1.33-.29-1.91-.94a.5.5 0 01.74-.66c.42.46.84.6 1.17.6.34 0 .63-.15.8-.35.17-.2.2-.4.12-.55-.07-.17-.33-.44-1.07-.61a.5.5 0 010-.98c.74-.17 1-.44 1.07-.61.07-.15.05-.35-.12-.55-.17-.2-.46-.35-.8-.35zm.72 10c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.11v-2.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.11v-4.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v6.5a.75.75 0 01-1.5.11V9.75c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v8.5a.75.75 0 01-1.5.11V7.75c0-.41.34-.75.75-.75zm3-2c.37 0 .68.27.74.63l.01.1-.01 10.52a.74.74 0 01-1.48.12l-.01-.1.01-10.52c0-.41.33-.75.74-.75zm-7.5-2h.25s.13 0 .28.06c.17.07.36.18.48.42a.5.5 0 00.89-.46C10.62 2 9.53 2 9.5 2h-.25C8.01 2 7 3 7 4.25v1.5a2.25 2.25 0 004.5 0v-.5a.5.5 0 00-.5-.5H9.5a.5.5 0 100 1h1a1.25 1.25 0 01-2.5 0v-1.5C8 3.56 8.56 3 9.25 3z",
    fill: primaryFill
  }));
};

export const Cellular3GFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Cellular3GFilledIcon({}), 'Cellular3GFilled');

const Cellular3GRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.03 3c-.32 0-.74.14-1.16.6a.5.5 0 11-.74-.66A2.57 2.57 0 014.03 2c.64 0 1.2.28 1.57.7A1.5 1.5 0 015.28 5c.27.2.47.42.6.69.26.59.08 1.2-.28 1.61-.36.42-.93.7-1.56.7-.65 0-1.33-.29-1.91-.94a.5.5 0 01.74-.66c.42.46.84.6 1.17.6.34 0 .63-.15.8-.35.17-.2.2-.4.12-.55-.07-.17-.33-.44-1.07-.61a.5.5 0 010-.98c.74-.17 1-.44 1.07-.61.07-.15.05-.35-.12-.55-.17-.2-.46-.35-.8-.35zM16.5 5a.5.5 0 01.5.41v11.1a.5.5 0 01-.99.08V5.5c0-.28.22-.5.5-.5zm-9 6a.5.5 0 01.5.41v5.09a.5.5 0 01-.99.09V11.5c0-.28.22-.5.5-.5zm-3 2a.5.5 0 01.5.41v3.09a.5.5 0 01-1 .09V13.5c0-.28.22-.5.5-.5zm6-4a.5.5 0 01.5.4v7.1a.5.5 0 01-1 .09V9.5c0-.28.22-.5.5-.5zm3-2a.5.5 0 01.5.41v9.09a.5.5 0 01-1 .09V7.5c0-.27.22-.5.5-.5zM9.25 3h.25s.13 0 .28.06c.17.07.36.18.48.42a.5.5 0 00.89-.46C10.62 2 9.53 2 9.5 2h-.25C8.01 2 7 3 7 4.25v1.5a2.25 2.25 0 004.5 0v-.5a.5.5 0 00-.5-.5H9.5a.5.5 0 100 1h1a1.25 1.25 0 01-2.5 0v-1.5C8 3.56 8.56 3 9.25 3z",
    fill: primaryFill
  }));
};

export const Cellular3GRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Cellular3GRegularIcon({}), 'Cellular3GRegular');

const Cellular4GFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3h-.25C8.56 3 8 3.56 8 4.25v1.5a1.25 1.25 0 002.5 0h-1a.5.5 0 110-1H11c.28 0 .5.22.5.5v.5a2.25 2.25 0 11-4.5 0v-1.5C7 3.01 8 2 9.25 2h.25c.03 0 1.12 0 1.65 1.02a.5.5 0 11-.89.46.86.86 0 00-.48-.42C9.63 3.01 9.51 3 9.5 3zM4.75 13c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.11v-2.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.11v-4.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v6.5a.75.75 0 01-1.5.11V9.75c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v8.5a.75.75 0 01-1.5.11V7.75c0-.41.34-.75.75-.75zm3-2c.37 0 .68.27.74.63l.01.1-.01 10.52a.74.74 0 01-1.48.12l-.01-.1.01-10.52c0-.41.33-.75.74-.75zM4.95 2.7a.7.7 0 00-1.26-.4L1.13 5.9A.7.7 0 001.7 7h2.26v.5a.5.5 0 101 0V7h.54a.5.5 0 000-1h-.54V2.7zm-1 .94V6H2.29l1.68-2.36z",
    fill: primaryFill
  }));
};

export const Cellular4GFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Cellular4GFilledIcon({}), 'Cellular4GFilled');

const Cellular4GRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3h-.25C8.56 3 8 3.56 8 4.25v1.5a1.25 1.25 0 002.5 0h-1a.5.5 0 110-1H11c.28 0 .5.22.5.5v.5a2.25 2.25 0 11-4.5 0v-1.5C7 3.01 8 2 9.25 2h.25c.03 0 1.12 0 1.65 1.02a.5.5 0 11-.89.46.86.86 0 00-.48-.42C9.63 3.01 9.51 3 9.5 3zm7 2a.5.5 0 01.5.41v11.1a.5.5 0 01-.99.08V5.5c0-.28.22-.5.5-.5zm-9 6a.5.5 0 01.5.41v5.09a.5.5 0 01-.99.09V11.5c0-.28.22-.5.5-.5zm-3 2a.5.5 0 01.5.41v3.09a.5.5 0 01-1 .09V13.5c0-.28.22-.5.5-.5zm6-4a.5.5 0 01.5.4v7.1a.5.5 0 01-1 .09V9.5c0-.28.22-.5.5-.5zm3-2a.5.5 0 01.5.41v9.09a.5.5 0 01-1 .09V7.5c0-.27.22-.5.5-.5zM4.96 2.7a.7.7 0 00-1.27-.4L1.13 5.9A.7.7 0 001.7 7h2.26v.5a.5.5 0 101 0V7h.54a.5.5 0 000-1h-.54V2.7zm-1 .94V6H2.28l1.68-2.36z",
    fill: primaryFill
  }));
};

export const Cellular4GRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Cellular4GRegularIcon({}), 'Cellular4GRegular');

const Cellular5GFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3h-.25C8.56 3 8 3.56 8 4.25v1.5a1.25 1.25 0 002.5 0h-1a.5.5 0 010-1H11c.28 0 .5.22.5.5v.5a2.25 2.25 0 01-4.5 0v-1.5C7 3.01 8 2 9.25 2h.25c.03 0 1.12 0 1.65 1.02a.5.5 0 11-.89.46.86.86 0 00-.48-.42C9.63 3.01 9.51 3 9.5 3zM4.75 13c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.11v-2.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.11v-4.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v6.5a.75.75 0 01-1.5.11V9.75c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v8.5a.75.75 0 01-1.5.11V7.75c0-.41.34-.75.75-.75zm3-2c.37 0 .68.27.74.63l.01.1-.01 10.52a.74.74 0 01-1.48.12l-.01-.1.01-10.52c0-.41.33-.75.74-.75zm-14-3a.5.5 0 00-.5.44l-.25 2a.5.5 0 00.54.56l.18-.02 1.37-.11c.49-.04.91.35.91.84v.22C5 6.52 4.52 7 3.93 7a.98.98 0 01-.75-.32 1.23 1.23 0 01-.2-.3l-.01-.02a.5.5 0 00-.94.36l.01.02a1.44 1.44 0 00.1.2A1.98 1.98 0 003.93 8C5.07 8 6 7.07 6 5.93V5.7c0-1.08-.92-1.93-2-1.84l-.93.08L3.2 3H5.5a.5.5 0 000-1H2.75z",
    fill: primaryFill
  }));
};

export const Cellular5GFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Cellular5GFilledIcon({}), 'Cellular5GFilled');

const Cellular5GRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3h-.25C8.56 3 8 3.56 8 4.25v1.5a1.25 1.25 0 002.5 0h-1a.5.5 0 010-1H11c.28 0 .5.22.5.5v.5a2.25 2.25 0 01-4.5 0v-1.5C7 3.01 8 2 9.25 2h.25c.03 0 1.12 0 1.65 1.02a.5.5 0 11-.89.46.86.86 0 00-.48-.42C9.63 3.01 9.51 3 9.5 3zm7 2a.5.5 0 01.5.41v11.1a.5.5 0 01-.99.08V5.5c0-.28.22-.5.5-.5zm-9 6a.5.5 0 01.5.41v5.09a.5.5 0 01-.99.09V11.5c0-.28.22-.5.5-.5zm-3 2a.5.5 0 01.5.41v3.09a.5.5 0 01-1 .09V13.5c0-.28.22-.5.5-.5zm6-4a.5.5 0 01.5.4v7.1a.5.5 0 01-1 .09V9.5c0-.28.22-.5.5-.5zm3-2a.5.5 0 01.5.41v9.09a.5.5 0 01-1 .09V7.5c0-.27.22-.5.5-.5zM2.75 2a.5.5 0 00-.5.44l-.25 2a.5.5 0 00.54.56l.18-.02 1.37-.11c.49-.04.91.35.91.84v.22C5 6.52 4.52 7 3.93 7a.98.98 0 01-.75-.32 1.23 1.23 0 01-.2-.3l-.01-.02a.5.5 0 00-.94.36l.01.02a1.44 1.44 0 00.1.2A1.98 1.98 0 003.93 8C5.07 8 6 7.07 6 5.93V5.7c0-1.08-.92-1.93-2-1.84l-.93.08L3.2 3H5.5a.5.5 0 000-1H2.75z",
    fill: primaryFill
  }));
};

export const Cellular5GRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Cellular5GRegularIcon({}), 'Cellular5GRegular');

const CellularData1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 12c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.11v-2.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.11v-4.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v6.5a.75.75 0 01-1.5.11V8.75c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v8.5a.75.75 0 01-1.5.11V6.75c0-.41.34-.75.75-.75zm3-2c.37 0 .68.27.74.63l.01.1-.01 10.52a.74.74 0 01-1.48.12l-.01-.1.01-10.52c0-.41.33-.75.74-.75z",
    fill: primaryFill
  }));
};

export const CellularData1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData1FilledIcon({}), 'CellularData1Filled');

const CellularData1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 4a.5.5 0 01.5.41V15.5a.5.5 0 01-.99.09V4.5c0-.28.22-.5.5-.5zm-9 6a.5.5 0 01.5.4v5.1a.5.5 0 01-.99.09v-5.1c0-.27.22-.5.5-.5zm-3 2a.5.5 0 01.5.4v3.1a.5.5 0 01-1 .09v-3.1c0-.27.22-.5.5-.5zm6-4a.5.5 0 01.5.4v7.1a.5.5 0 01-1 .09v-7.1c0-.27.22-.5.5-.5zm3-2a.5.5 0 01.5.41v9.09a.5.5 0 01-1 .09V6.5c0-.27.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CellularData1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData1RegularIcon({}), 'CellularData1Regular');

const CellularData2FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 12c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.1v-2.6c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.1v-4.6c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64v6.61a.75.75 0 01-1.48.11l-.01-.11v-6.5c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64v8.61a.75.75 0 01-1.48.11l-.01-.11v-8.5c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const CellularData2Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData2FilledIcon({}), 'CellularData2Filled');

const CellularData2RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 10a.5.5 0 01.5.41v5.09a.5.5 0 01-.99.09V10.5c0-.28.22-.5.5-.5zm-3 2a.5.5 0 01.5.41v3.09a.5.5 0 01-1 .09V12.5c0-.28.22-.5.5-.5zm6-4a.5.5 0 01.5.4v7.1a.5.5 0 01-1 .09V8.5c0-.28.22-.5.5-.5zm3-2a.5.5 0 01.5.41v9.09a.5.5 0 01-1 .09V6.5c0-.27.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CellularData2Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData2RegularIcon({}), 'CellularData2Regular');

const CellularData3FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 12c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.1v-2.6c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.1v-4.6c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v6.5a.75.75 0 01-1.5.11V8.75c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const CellularData3Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData3FilledIcon({}), 'CellularData3Filled');

const CellularData3RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 10a.5.5 0 01.5.41v5.09a.5.5 0 01-.99.09V10.5c0-.28.22-.5.5-.5zm-3 2a.5.5 0 01.5.41v3.1a.5.5 0 01-1 .08V12.5c0-.28.22-.5.5-.5zm6-4a.5.5 0 01.5.4v7.1a.5.5 0 01-1 .09V8.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CellularData3Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData3RegularIcon({}), 'CellularData3Regular');

const CellularData4FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 12c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.11v-2.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.11v-4.61c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const CellularData4Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData4FilledIcon({}), 'CellularData4Filled');

const CellularData4RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 10a.5.5 0 01.5.41v5.09a.5.5 0 01-.99.09V10.5c0-.28.22-.5.5-.5zm-3 2a.5.5 0 01.5.41v3.09a.5.5 0 01-1 .09V12.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CellularData4Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData4RegularIcon({}), 'CellularData4Regular');

const CellularData5FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 12c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.11v-2.61c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const CellularData5Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData5FilledIcon({}), 'CellularData5Filled');

const CellularData5RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 12a.5.5 0 01.5.41v3.09a.5.5 0 01-1 .09V12.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CellularData5Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularData5RegularIcon({}), 'CellularData5Regular');

const CellularOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L10 10.71v4.65a.75.75 0 001.5-.11v-3.04l1.5 1.5V15.36a.75.75 0 001.5-.11v-.04l2.65 2.64a.5.5 0 00.7-.7l-15-15zM13 10.88V6.75a.75.75 0 011.5-.11v5.74l-1.5-1.5zm4.48 4.48L16 13.88l.01-9.13a.74.74 0 011.48-.12l.01.1-.01 10.52-.01.1zM5.49 12.64a.75.75 0 00-1.49.11v2.61a.75.75 0 001.5-.11v-2.61zm3-2a.75.75 0 00-1.49.11v4.61a.75.75 0 001.5-.11v-4.61z",
    fill: primaryFill
  }));
};

export const CellularOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularOffFilledIcon({}), 'CellularOffFilled');

const CellularOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L10 10.71v4.88a.5.5 0 001-.09v-3.8l2 2V15.6a.5.5 0 001-.09v-.8l3.15 3.15a.5.5 0 00.7-.7l-15-15zM13 10.88V6.5a.5.5 0 011-.09v5.47l-1-1zm3 3V4.5a.5.5 0 011-.09V14.88l-1-1zm-8-3.47a.5.5 0 00-1 .09v5l.01.09a.5.5 0 001-.09v-5L8 10.41zm-3 2a.5.5 0 00-1 .09v3.09a.5.5 0 001-.09v-3.09z",
    fill: primaryFill
  }));
};

export const CellularOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularOffRegularIcon({}), 'CellularOffRegular');

const CellularWarningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 12c.38 0 .69.28.74.64l.01.11v2.5a.75.75 0 01-1.5.11v-2.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v4.5a.75.75 0 01-1.5.11v-4.61c0-.41.34-.75.75-.75zm3-2c.38 0 .69.28.74.64l.01.11v3.79l-1.47 2.93a.75.75 0 01-.02-.1l-.01-.12v-6.5c0-.41.34-.75.75-.75zM13 9.68c.4-.45.95-.68 1.5-.68V6.64a.75.75 0 00-1.5.11v2.93zm3.3.43l1.19 2.39.01-7.76v-.11a.74.74 0 00-1.49.12v4.93c.1.12.2.27.28.43zm-2.7.44l-3.5 7A1 1 0 0011 19h7a1 1 0 00.9-1.45l-3.5-7a1 1 0 00-1.8 0zM15 12.5v3a.5.5 0 11-1 0v-3a.5.5 0 011 0zm-.5 5.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const CellularWarningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularWarningFilledIcon({}), 'CellularWarningFilled');

const CellularWarningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 4a.5.5 0 01.5.41v7.12l-.7-1.42c-.09-.17-.19-.31-.3-.44V4.5c0-.28.23-.5.5-.5zM10 15.53l1-2V8.4a.5.5 0 00-1 .1v7.03zm3-5.85c.27-.32.62-.52 1-.62V6.41a.5.5 0 00-1 .1v3.17zM7.5 10a.5.5 0 01.5.4v5.1a.5.5 0 01-.99.09v-5.1c0-.27.22-.5.5-.5zm-3 2a.5.5 0 01.5.4v3.1a.5.5 0 01-1 .09v-3.1c0-.27.22-.5.5-.5zm9.1-1.45l-3.5 7A1 1 0 0011 19h7a1 1 0 00.9-1.45l-3.5-7a1 1 0 00-1.8 0zM15 12.5v3a.5.5 0 01-1 0v-3a.5.5 0 011 0zm-.5 5.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const CellularWarningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CellularWarningRegularIcon({}), 'CellularWarningRegular');

const CenterHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 18a.5.5 0 01-.5-.5v-15a.5.5 0 011 0v15a.5.5 0 01-.5.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M16 17.5a.5.5 0 001 0v-15a.5.5 0 00-1 0v15z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h2a2 2 0 002-2V6a2 2 0 00-2-2H9z",
    fill: primaryFill
  }));
};

export const CenterHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CenterHorizontalFilledIcon({}), 'CenterHorizontalFilled');

const CenterHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 18a.5.5 0 01-.5-.5v-15a.5.5 0 011 0v15a.5.5 0 01-.5.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M16 17.5a.5.5 0 001 0v-15a.5.5 0 00-1 0v15z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h2a2 2 0 002-2V6a2 2 0 00-2-2H9zM8 6a1 1 0 011-1h2a1 1 0 011 1v8a1 1 0 01-1 1H9a1 1 0 01-1-1V6z",
    fill: primaryFill
  }));
};

export const CenterHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CenterHorizontalRegularIcon({}), 'CenterHorizontalRegular');

const CenterVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 3a.5.5 0 000 1h15a.5.5 0 000-1h-15zM2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM6 7a2 2 0 00-2 2v2c0 1.1.9 2 2 2h8a2 2 0 002-2V9a2 2 0 00-2-2H6z",
    fill: primaryFill
  }));
};

export const CenterVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CenterVerticalFilledIcon({}), 'CenterVerticalFilled');

const CenterVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM2.5 16a.5.5 0 000 1h15a.5.5 0 000-1h-15zM6 7a2 2 0 00-2 2v2c0 1.1.9 2 2 2h8a2 2 0 002-2V9a2 2 0 00-2-2H6zM5 9a1 1 0 011-1h8a1 1 0 011 1v2a1 1 0 01-1 1H6a1 1 0 01-1-1V9z",
    fill: primaryFill
  }));
};

export const CenterVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CenterVerticalRegularIcon({}), 'CenterVerticalRegular');

const CertificateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v8c0 1.1.9 2 2 2h7.5v-.67c-.09-.1-.17-.22-.24-.33H4a1 1 0 01-1-1V5a1 1 0 011-1h12a1 1 0 011 1v2.47c.36.18.7.4 1 .68V5a2 2 0 00-2-2H4zm14.5 8.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM15 16c.93 0 1.79-.28 2.5-.76V18a.5.5 0 01-.8.4l-1.4-1.05a.5.5 0 00-.6 0l-1.4 1.05a.5.5 0 01-.8-.4v-2.76c.71.48 1.57.76 2.5.76zM5 6.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const CertificateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CertificateFilledIcon({}), 'CertificateFilled');

const CertificateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5c0-1.1.9-2 2-2h12a2 2 0 012 2v3.15a4.5 4.5 0 00-1-.68V5a1 1 0 00-1-1H4a1 1 0 00-1 1v8a1 1 0 001 1h7.26l.24.33V15H4a2 2 0 01-2-2V5zm16.5 6.5c0 .95-.38 1.82-1 2.45V18a.5.5 0 01-.8.4l-1.4-1.05a.5.5 0 00-.6 0l-1.4 1.05a.5.5 0 01-.8-.4v-4.05A3.49 3.49 0 0115 8a3.5 3.5 0 013.5 3.5zM15 15c-.54 0-1.05-.12-1.5-.34v2.09l1.24-.75a.5.5 0 01.52 0l1.24.75v-2.09c-.45.22-.96.34-1.5.34zm0-1a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM5 6.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const CertificateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CertificateRegularIcon({}), 'CertificateRegular');

const ChannelFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a2.5 2.5 0 00-2.3 1.52l.3-.02A2 2 0 113 8.44v6.06A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5h3a.5.5 0 010 1h-3a.5.5 0 010-1zm-4-5.5a1 1 0 00-1 1 1 1 0 101-1z",
    fill: primaryFill
  }));
};

export const ChannelFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelFilledIcon({}), 'ChannelFilled');

const ChannelRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 5.5a1 1 0 00-1 1 1 1 0 101-1zm0-1c-.1 0-.2 0-.3.02A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5V8.44a2 2 0 001 0v6.06c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 00-.76-.15zm3.5 4c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }));
};

export const ChannelRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelRegularIcon({}), 'ChannelRegular');

const ChannelAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a2.5 2.5 0 00-2.3 1.52l.3-.02A2 2 0 113 8.44v6.06A2.5 2.5 0 005.5 17h4.1a5.48 5.48 0 010-5H7.5a.5.5 0 010-1h2.76A5.49 5.49 0 0117 9.6V5.5A2.5 2.5 0 0014.5 3h-9zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-3.5-3a1 1 0 00-1 1 1 1 0 101-1zm15.5 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ChannelAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelAddFilledIcon({}), 'ChannelAddFilled');

const ChannelAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 00-.76-.15zM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5V8.44a2 2 0 001 0v6.06c0 .83.67 1.5 1.5 1.5h3.7zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 000 1h2.1zM3.5 5.5a1 1 0 00-1 1 1 1 0 101-1zm4 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ChannelAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelAddRegularIcon({}), 'ChannelAddRegular');

const ChannelAlertFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a2.5 2.5 0 00-2.3 1.52l.3-.02A2 2 0 113 8.44v6.06A2.5 2.5 0 005.5 17h4.1a5.48 5.48 0 010-5H7.5a.5.5 0 010-1h2.76A5.49 5.49 0 0117 9.6V5.5A2.5 2.5 0 0014.5 3h-9zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-3.5-3a1 1 0 00-1 1 1 1 0 101-1zm15.5 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM16.5 13a2 2 0 10-4 0v1.8l-.35.35a.5.5 0 00.35.85h4a.5.5 0 00.35-.85l-.35-.36V13zm-3.41 4a1.5 1.5 0 002.82 0H13.1z",
    fill: primaryFill
  }));
};

export const ChannelAlertFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelAlertFilledIcon({}), 'ChannelAlertFilled');

const ChannelAlertRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 00-.76-.15zM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5V8.44a2 2 0 001 0v6.06c0 .83.67 1.5 1.5 1.5h3.7zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 000 1h2.1zM3.5 5.5a1 1 0 00-1 1 1 1 0 101-1zm4 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM16.5 13a2 2 0 10-4 0v1.8l-.35.35a.5.5 0 00.35.85h4a.5.5 0 00.35-.85l-.35-.36V13zm-3.41 4a1.5 1.5 0 002.82 0H13.1z",
    fill: primaryFill
  }));
};

export const ChannelAlertRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelAlertRegularIcon({}), 'ChannelAlertRegular');

const ChannelArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a2.5 2.5 0 00-2.3 1.52l.3-.02A2 2 0 113 8.44v6.06A2.5 2.5 0 005.5 17h4.1a5.48 5.48 0 010-5H7.5a.5.5 0 010-1h2.76A5.49 5.49 0 0117 9.6V5.5A2.5 2.5 0 0014.5 3h-9zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-3.5-3a1 1 0 00-1 1 1 1 0 101-1zm15.5 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const ChannelArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelArrowLeftFilledIcon({}), 'ChannelArrowLeftFilled');

const ChannelArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 00-.76-.15zM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5V8.44a2 2 0 001 0v6.06c0 .83.67 1.5 1.5 1.5h3.7zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 000 1h2.1zM3.5 5.5a1 1 0 00-1 1 1 1 0 101-1zm4 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const ChannelArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelArrowLeftRegularIcon({}), 'ChannelArrowLeftRegular');

const ChannelDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a2.5 2.5 0 00-2.3 1.52l.3-.02A2 2 0 113 8.44v6.06A2.5 2.5 0 005.5 17h4.1a5.48 5.48 0 010-5H7.5a.5.5 0 010-1h2.76A5.49 5.49 0 0117 9.6V5.5A2.5 2.5 0 0014.5 3h-9zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-3.5-3a1 1 0 00-1 1 1 1 0 101-1zm15.5 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const ChannelDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelDismissFilledIcon({}), 'ChannelDismissFilled');

const ChannelDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 00-.76-.15zM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5V8.44a2 2 0 001 0v6.06c0 .83.67 1.5 1.5 1.5h3.7zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 000 1h2.1zM3.5 5.5a1 1 0 00-1 1 1 1 0 101-1zm4 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const ChannelDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelDismissRegularIcon({}), 'ChannelDismissRegular');

const ChannelShareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h5A2.5 2.5 0 0113 5.5a.5.5 0 01-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 11.12 1H5.5A2.5 2.5 0 013 10.5v-5zM7.5 14a.5.5 0 00-.5.5A2.5 2.5 0 009.5 17h5a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0014.5 7H9.87A2.25 2.25 0 1010 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 018 14.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const ChannelShareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelShareFilledIcon({}), 'ChannelShareFilled');

const ChannelShareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h5A2.5 2.5 0 0113 5.5a.5.5 0 01-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 11.12 1H5.5A2.5 2.5 0 013 10.5v-5zm8 6.75a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zM7.5 14a.5.5 0 00-.5.5A2.5 2.5 0 009.5 17h5a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0014.5 7H9.87A2.25 2.25 0 1010 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 018 14.5a.5.5 0 00-.5-.5zm.25-7.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z",
    fill: primaryFill
  }));
};

export const ChannelShareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelShareRegularIcon({}), 'ChannelShareRegular');

const ChannelSubtractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.2 4.52A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1a5.48 5.48 0 00-6.74 1.4H7.5a.5.5 0 000 1h2.1a5.48 5.48 0 000 5H5.5A2.5 2.5 0 013 14.5V8.44a2 2 0 10.2-3.92zM7.5 8a.5.5 0 000 1h5a.5.5 0 000-1h-5zM3 5.63a1 1 0 111 1.73 1 1 0 01-1-1.73zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2-4h-4a.5.5 0 010-1h4a.5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const ChannelSubtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelSubtractFilledIcon({}), 'ChannelSubtractFilled');

const ChannelSubtractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.2 4.52a2.02 2.02 0 011.06.13C4.53 4.25 5 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v3.7c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0014.5 3h-9a2.5 2.5 0 00-2.3 1.52zM9.6 17c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V8.44a2 2 0 01-1 0v6.06A2.5 2.5 0 005.5 17h4.1zm0-5c.18-.36.4-.7.66-1H7.5a.5.5 0 000 1h2.1zM3 5.63a1 1 0 011 0 1 1 0 11-1 0zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2-4h-4a.5.5 0 010-1h4a.5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const ChannelSubtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChannelSubtractRegularIcon({}), 'ChannelSubtractRegular');

const ChartMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 11c0-.37.1-.7.27-1H10.5A1.5 1.5 0 019 8.5V2.02a7.5 7.5 0 000 14.96V15a2 2 0 013-1.73V13a2 2 0 013-1.73V11zm-5-8.98V8.5c0 .28.22.5.5.5h6.48A7.5 7.5 0 0010 2.02zM16 11a1 1 0 112 0v7a1 1 0 11-2 0v-7zm-6 4a1 1 0 112 0v3a1 1 0 11-2 0v-3zm3-2a1 1 0 112 0v5a1 1 0 11-2 0v-5z",
    fill: primaryFill
  }));
};

export const ChartMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChartMultipleFilledIcon({}), 'ChartMultipleFilled');

const ChartMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 9.5a6.5 6.5 0 006 6.48v1A7.5 7.5 0 1116.98 9a2 2 0 00-1.71 1H10.5A1.5 1.5 0 019 8.5V3.02A6.5 6.5 0 003 9.5zM15.98 9A6.5 6.5 0 0010 3.02V8.5c0 .28.22.5.5.5h5.48zm.02 2a1 1 0 112 0v7a1 1 0 11-2 0v-7zm-6 4a1 1 0 112 0v3a1 1 0 11-2 0v-3zm3-2a1 1 0 112 0v5a1 1 0 11-2 0v-5z",
    fill: primaryFill
  }));
};

export const ChartMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChartMultipleRegularIcon({}), 'ChartMultipleRegular');

const ChartPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 10-1 0V3H4.75A2.75 2.75 0 002 5.75v6.5A2.75 2.75 0 004.75 15h1.82l-1.49 2.23a.5.5 0 00.84.55L7.77 15H11.5a2.5 2.5 0 011.77-.99A2.99 2.99 0 0115.5 9a3 3 0 012.5 1.34V5.75A2.75 2.75 0 0015.25 3H10.5v-.5zM5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm.5 4.5h4a.5.5 0 010 1h-4a.5.5 0 010-1zm0-2.5h5a.5.5 0 010 1h-5a.5.5 0 010-1zm12 3.5a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ChartPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChartPersonFilledIcon({}), 'ChartPersonFilled');

const ChartPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c.28 0 .5.22.5.5V3h4.75A2.75 2.75 0 0118 5.75v4.6c-.26-.4-.6-.72-1-.95V5.75c0-.65-.35-1.22-.88-1.52l-.02-.01a1.74 1.74 0 00-.85-.22H4.75C3.78 4 3 4.78 3 5.75v6.55c.03.94.8 1.7 1.75 1.7h8.51l.01.01a2.5 2.5 0 00-1.77.99H7.77l-1.85 2.78a.5.5 0 11-.84-.55L6.57 15H4.75A2.75 2.75 0 012 12.25v-6.5A2.75 2.75 0 014.75 3H9.5v-.5c0-.28.22-.5.5-.5zM5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM5 9c0-.27.22-.5.5-.5h5a.5.5 0 010 1h-5A.5.5 0 015 9zm12.5 3a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ChartPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChartPersonRegularIcon({}), 'ChartPersonRegular');

const ChatFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 11-3.61 15.14l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm.5 9H7.41a.5.5 0 000 1H10.59a.5.5 0 000-1h-.09zm2-3H7.41a.5.5 0 000 1h5.18a.5.5 0 000-1h-.09z",
    fill: primaryFill
  }));
};

export const ChatFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatFilledIcon({}), 'ChatFilled');

const ChatRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 11-3.61 15.14l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm0 1a7 7 0 00-6.1 10.42.5.5 0 01.06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 01.19-.01l.09.02.09.04A7 7 0 1010 3zm.5 8a.5.5 0 01.09 1H7.5a.5.5 0 01-.09-1h3.09zm2-3a.5.5 0 01.09 1H7.5a.5.5 0 01-.09-1h5.09z",
    fill: primaryFill
  }));
};

export const ChatRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatRegularIcon({}), 'ChatRegular');

const ChatArrowBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8.25A5.5 5.5 0 0010.26 18a7.93 7.93 0 01-3.87-.85l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm4.5 17a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const ChatArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatArrowBackFilledIcon({}), 'ChatArrowBackFilled');

const ChatArrowBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8.25 5.5 5.5 0 00-1.01-.66 7 7 0 10-13.1 3.83.5.5 0 01.07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 01.19-.01l.09.02.09.04c.92.51 1.94.82 3.01.88.19.36.4.7.66 1a7.93 7.93 0 01-3.86-.85l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm4.5 17a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const ChatArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatArrowBackRegularIcon({}), 'ChatArrowBackRegular');

const ChatArrowDoubleBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8.25A5.5 5.5 0 0010.26 18a7.93 7.93 0 01-3.87-.85l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm9 12.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.65-1.15a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15zm1.86.65l.64-.65a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-.64-.65H17v.5a.5.5 0 001 0V15a1 1 0 00-1-1h-1.8z",
    fill: primaryFill,
    opacity: 0.99
  }));
};

export const ChatArrowDoubleBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatArrowDoubleBackFilledIcon({}), 'ChatArrowDoubleBackFilled');

const ChatArrowDoubleBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8.25 5.5 5.5 0 00-1.01-.66 7 7 0 10-13.1 3.83.5.5 0 01.07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 01.19-.01l.09.02.09.04c.92.51 1.94.82 3.01.88.19.36.4.7.66 1a7.93 7.93 0 01-3.86-.85l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm9 12.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.65-1.15a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15zm1.86.65l.64-.65a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-.64-.65H17v.5a.5.5 0 001 0V15a1 1 0 00-1-1h-1.8z",
    fill: primaryFill,
    opacity: 0.99
  }));
};

export const ChatArrowDoubleBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatArrowDoubleBackRegularIcon({}), 'ChatArrowDoubleBackRegular');

const ChatBubblesQuestionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 1a6.5 6.5 0 00-5.68 9.67l-.8 2.08a1 1 0 001.21 1.32l2.49-.7A6.5 6.5 0 108.5 1zm0 3.9c-.37.07-.76.3-1.07.85a.5.5 0 11-.87-.5A2.57 2.57 0 018.3 3.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.1.21-.1.44a.5.5 0 01-1 0c0-.27.02-.61.25-.97.2-.34.56-.64 1.11-.96.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.3-.2-.68-.3-1.05-.22zm.25 6.6a.75.75 0 110-1.5.75.75 0 010 1.5zm-2.21 3.24a6.49 6.49 0 007.7 1.64l2.49.7a1 1 0 001.2-1.33l-.8-2.08a6.47 6.47 0 00-1.37-8.04c.15.56.23 1.15.24 1.76a5.47 5.47 0 01.16 5.98l-.13.2.97 2.54-2.86-.8-.18.09A5.47 5.47 0 018.3 15a7.5 7.5 0 01-1.75-.26z",
    fill: primaryFill
  }));
};

export const ChatBubblesQuestionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatBubblesQuestionFilledIcon({}), 'ChatBubblesQuestionFilled');

const ChatBubblesQuestionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 4.9c-.37.07-.76.3-1.07.85a.5.5 0 11-.86-.5A2.57 2.57 0 018.3 3.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.09.21-.09.44a.5.5 0 01-1 0c0-.27.01-.61.24-.97.2-.34.57-.64 1.11-.96.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.29-.2-.67-.3-1.05-.22zm.25 6.6a.75.75 0 100-1.5.75.75 0 000 1.5zM8.5 1a6.5 6.5 0 00-5.67 9.67l-.8 2.08a1 1 0 001.2 1.32l2.5-.7A6.5 6.5 0 108.5 1zM3 7.5a5.5 5.5 0 113 4.9l-.18-.09-2.86.8.97-2.53-.13-.21A5.47 5.47 0 013 7.5zm8.46 9.5a6.49 6.49 0 01-4.92-2.26A7.5 7.5 0 008.3 15a5.47 5.47 0 005.66.4l.18-.09 2.86.8-.97-2.53.13-.21A5.47 5.47 0 0016 7.39c0-.6-.1-1.2-.24-1.76a6.48 6.48 0 011.38 8.04l.8 2.08a1 1 0 01-1.21 1.32l-2.49-.7c-.84.4-1.78.63-2.78.63z",
    fill: primaryFill
  }));
};

export const ChatBubblesQuestionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatBubblesQuestionRegularIcon({}), 'ChatBubblesQuestionRegular');

const ChatDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10zM7.85 7.15L10 9.29l2.15-2.14a.5.5 0 01.7.7L10.71 10l2.14 2.15a.5.5 0 01-.7.7L10 10.71l-2.15 2.14a.5.5 0 01-.7-.7L9.29 10 7.15 7.85a.5.5 0 11.7-.7z",
    fill: primaryFill
  }));
};

export const ChatDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatDismissFilledIcon({}), 'ChatDismissFilled');

const ChatDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.85 7.15a.5.5 0 10-.7.7L9.29 10l-2.14 2.15a.5.5 0 00.7.7L10 10.71l2.15 2.14a.5.5 0 00.7-.7L10.71 10l2.14-2.15a.5.5 0 00-.7-.7L10 9.29 7.85 7.15zM18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10zM3 10a7 7 0 113.58 6.1l-.09-.03-.1-.02a.5.5 0 00-.18 0l-3.02.76.75-3.02.02-.1a.5.5 0 00-.07-.27A6.97 6.97 0 013 10z",
    fill: primaryFill
  }));
};

export const ChatDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatDismissRegularIcon({}), 'ChatDismissRegular');

const ChatHelpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 114.26 7.07L2.62 18a.5.5 0 01-.6-.61l.9-3.64A7.97 7.97 0 012 10zm7.25-2.7c.15-.17.39-.3.75-.3s.6.13.75.3c.16.2.25.44.25.7 0 .32-.07.52-.17.69-.1.17-.23.3-.42.5l-.02.03c-.19.2-.42.44-.6.78-.18.35-.29.76-.29 1.3a.5.5 0 101 0c0-.4.08-.64.18-.84.1-.2.24-.35.43-.55l.04-.04c.17-.18.38-.4.55-.68.18-.32.3-.7.3-1.19a1.95 1.95 0 00-2-2 1.95 1.95 0 00-2 2 .5.5 0 001 0c0-.26.09-.5.25-.7zm1.45 6.21a.7.7 0 10-1.4 0 .7.7 0 001.4 0z",
    fill: primaryFill
  }));
};

export const ChatHelpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatHelpFilledIcon({}), 'ChatHelpFilled');

const ChatHelpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.25 7.3c-.16.2-.25.44-.25.7a.5.5 0 01-1 0 1.95 1.95 0 012-2 1.95 1.95 0 012 2c0 .49-.12.87-.3 1.19-.17.28-.38.5-.55.68l-.04.04c-.19.2-.33.35-.43.55-.1.2-.18.45-.18.83a.5.5 0 11-1 0 2.71 2.71 0 01.89-2.07l.02-.02c.19-.2.32-.34.42-.51.1-.17.17-.37.17-.69 0-.26-.09-.5-.25-.7A.95.95 0 0010 7c-.36 0-.6.13-.75.3zm.75 6.91a.7.7 0 100-1.4.7.7 0 000 1.4zM2 10a8 8 0 114.26 7.07L2.62 18a.5.5 0 01-.6-.61l.9-3.64A7.97 7.97 0 012 10zm8-7a7 7 0 00-6.1 10.42.5.5 0 01.04.37l-.75 3.02 3.02-.75a.5.5 0 01.37.05A7 7 0 1010 3z",
    fill: primaryFill
  }));
};

export const ChatHelpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatHelpRegularIcon({}), 'ChatHelpRegular');

const ChatMailFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a6 6 0 113 5.2l-2.34.77a.5.5 0 01-.64-.6l.71-2.5A5.98 5.98 0 012 7zm4.5-1.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zm2 2h-2a.5.5 0 000 1h2a.5.5 0 000-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.28 14.95l-2.4-1.2c.43-.13.86-.29 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 00-1-1h-1.67c.15-.32.28-.65.38-1H16a2 2 0 012 2v5a2 2 0 01-2 2H9a2 2 0 01-2-2v-2.07c.33.05.66.07 1 .07v2a1 1 0 001 1h7a1 1 0 001-1v-3.2l-4.28 2.15a.5.5 0 01-.44 0z",
    fill: primaryFill
  }));
};

export const ChatMailFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatMailFilledIcon({}), 'ChatMailFilled');

const ChatMailRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3A.5.5 0 016 6zm.5 1.5a.5.5 0 000 1h2a.5.5 0 000-1h-2zM8 1a6 6 0 00-5.27 8.87l-.71 2.5a.5.5 0 00.64.6L5 12.2A6 6 0 108 1zM3 7a5 5 0 112.33 4.23.5.5 0 00-.43-.06l-1.66.56.51-1.79a.5.5 0 00-.05-.39A4.97 4.97 0 013 7zm9.28 7.95l-2.4-1.2c.43-.13.86-.29 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 00-1-1h-1.67c.15-.32.28-.65.38-1H16a2 2 0 012 2v5a2 2 0 01-2 2H9a2 2 0 01-2-2v-2.07c.33.05.66.07 1 .07v2a1 1 0 001 1h7a1 1 0 001-1v-3.2l-4.28 2.15a.5.5 0 01-.44 0z",
    fill: primaryFill
  }));
};

export const ChatMailRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatMailRegularIcon({}), 'ChatMailRegular');

const ChatMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.54 2a6.5 6.5 0 00-5.68 9.67l-.8 2.08a1 1 0 001.21 1.32l2.49-.7A6.5 6.5 0 108.54 2zM6.57 15.74a6.49 6.49 0 007.71 1.64l2.49.7a1 1 0 001.2-1.33l-.8-2.08a6.47 6.47 0 00-1.37-8.04c.15.56.23 1.15.24 1.76a5.47 5.47 0 01.16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.47 5.47 0 01-5.67-.4 7.5 7.5 0 01-1.76-.26z",
    fill: primaryFill
  }));
};

export const ChatMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatMultipleFilledIcon({}), 'ChatMultipleFilled');

const ChatMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.54 2a6.5 6.5 0 00-5.68 9.67l-.8 2.08a1 1 0 001.21 1.32l2.49-.7A6.5 6.5 0 108.54 2zm-5.5 6.5a5.5 5.5 0 113 4.9l-.18-.09-2.86.8.97-2.53-.13-.21a5.47 5.47 0 01-.8-2.87zM11.5 18a6.49 6.49 0 01-4.93-2.26 7.5 7.5 0 001.76.26 5.47 5.47 0 005.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.47 5.47 0 00-.16-5.98c-.01-.6-.1-1.2-.24-1.76a6.48 6.48 0 011.38 8.04l.8 2.08a1 1 0 01-1.21 1.32l-2.49-.7c-.84.4-1.79.63-2.78.63z",
    fill: primaryFill
  }));
};

export const ChatMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatMultipleRegularIcon({}), 'ChatMultipleRegular');

const ChatOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.7L2.15 2.86a.5.5 0 11.7-.7L4.71 4 16 15.3l1.85 1.85a.5.5 0 01-.7.7L15.29 16a7.97 7.97 0 01-8.9 1.14l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3zm6.97 6.98l-.68-.68H7.41a.5.5 0 000 1H10.59a.5.5 0 00.38-.32zM8.29 9l-.97-.97a.5.5 0 00.09.96L7.5 9h.8z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.5 9h-1.38l5.5 5.5A8 8 0 005.5 3.39L10.11 8H12.6a.5.5 0 010 1h-.09z",
    fill: primaryFill
  }));
};

export const ChatOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatOffFilledIcon({}), 'ChatOffFilled');

const ChatOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.7L2.15 2.86a.5.5 0 11.7-.7L4.71 4l.7.7 9.88 9.88.7.71 1.86 1.86a.5.5 0 01-.7.7L15.29 16a7.97 7.97 0 01-8.9 1.14l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3zm10.58 10.6l-3.61-3.62a.5.5 0 01-.38.31l-.09.01h-3a.5.5 0 01-.09-1H10.3l-2-2h-.8a.5.5 0 01-.18-.97L4.71 5.42a6.97 6.97 0 00-.82 8 .5.5 0 01.07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 01.19-.01l.09.02.09.04a6.97 6.97 0 008-.82z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M16.62 14.5l-.72-.73A7 7 0 006.23 4.1l-.73-.72A8 8 0 0116.61 14.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.5 9h-1.38l-1-1h2.38a.5.5 0 01.09 1h-.09z",
    fill: primaryFill
  }));
};

export const ChatOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatOffRegularIcon({}), 'ChatOffRegular');

const ChatSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8.25A5.5 5.5 0 0010.26 18a7.93 7.93 0 01-3.87-.85l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm2.07 9.44a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const ChatSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatSettingsFilledIcon({}), 'ChatSettingsFilled');

const ChatSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 00-6.1 10.42.5.5 0 01.04.37l-.75 3.02 3.02-.75a.5.5 0 01.37.05c.9.5 1.92.82 3.01.88.19.36.4.7.66 1a7.93 7.93 0 01-3.99-.92L2.62 18a.5.5 0 01-.6-.61l.9-3.64A8 8 0 1118 10.26c-.3-.26-.64-.48-1-.67A7 7 0 0010 3zm2.07 8.44a2 2 0 01-1.44 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const ChatSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatSettingsRegularIcon({}), 'ChatSettingsRegular');

const ChatVideoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10zM6 8a1 1 0 011-1h3a1 1 0 011 1v4a1 1 0 01-1 1H7a1 1 0 01-1-1V8zm7.15-.15a.5.5 0 01.85.36v3.58a.5.5 0 01-.85.36L12 11V9l1.15-1.15z",
    fill: primaryFill
  }));
};

export const ChatVideoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatVideoFilledIcon({}), 'ChatVideoFilled');

const ChatVideoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 8a1 1 0 011-1h3a1 1 0 011 1v4a1 1 0 01-1 1H7a1 1 0 01-1-1V8zm6 1l1.15-1.15a.5.5 0 01.85.36v3.58a.5.5 0 01-.85.36L12 11V9zm-2-7a8 8 0 11-3.61 15.14l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm0 1a7 7 0 00-6.1 10.42.5.5 0 01.06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 01.19-.01l.09.02.09.04A7 7 0 1010 3z",
    fill: primaryFill
  }));
};

export const ChatVideoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatVideoRegularIcon({}), 'ChatVideoRegular');

const ChatWarningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 11-3.61 15.14l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm0 3.5a.5.5 0 00-.5.5v5.5a.5.5 0 001 0V6a.5.5 0 00-.5-.5zm0 9a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const ChatWarningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatWarningFilledIcon({}), 'ChatWarningFilled');

const ChatWarningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 11-3.61 15.14l-.12-.07-3.65.92a.5.5 0 01-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 01-.83-2.9l-.02-.37L2 10a8 8 0 018-8zm0 1a7 7 0 00-6.1 10.42.5.5 0 01.06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 01.19-.01l.09.02.09.04A7 7 0 1010 3zm0 2.5c.28 0 .5.22.5.5v5.5a.5.5 0 01-1 0V6c0-.28.22-.5.5-.5zm0 9a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const ChatWarningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatWarningRegularIcon({}), 'ChatWarningRegular');

const CheckFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.88 5H4a2 2 0 00-2 2v6c0 1.1.9 2 2 2h12a2 2 0 002-2V7.12l-4.44 4.44a1.5 1.5 0 01-2.12-2.12L15.88 5zM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5H9a.5.5 0 010 1H4.5a.5.5 0 01-.5-.5zm13.85-5.65a.5.5 0 00-.7-.7l-5 5a.5.5 0 00.7.7l5-5z",
    fill: primaryFill
  }));
};

export const CheckFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckFilledIcon({}), 'CheckFilled');

const CheckRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 7.12V13a2 2 0 01-2 2H4a2 2 0 01-2-2V7c0-1.1.9-2 2-2h11.88l-1 1H4a1 1 0 00-1 1v6a1 1 0 001 1h12a1 1 0 001-1V8.12l1-1zM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5H9a.5.5 0 010 1H4.5a.5.5 0 01-.5-.5zm13.85-6.35c.2.2.2.5 0 .7l-6 6a.5.5 0 01-.7-.7l6-6c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const CheckRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckRegularIcon({}), 'CheckRegular');

const Checkbox1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.68C3 4.2 4.2 3 5.68 3h8.64C15.8 3 17 4.2 17 5.68v5.4a1.5 1.5 0 00-.4.22l-2 1.5a1.5 1.5 0 001.4 2.61v1c-.46.37-1.04.59-1.68.59H5.68A2.68 2.68 0 013 14.32V5.68zm10.85 2.17a.5.5 0 00-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5zM18 12.5a.5.5 0 00-.8-.4l-2 1.5a.5.5 0 00.6.8l1.2-.9v4a.5.5 0 101 0v-5z",
    fill: primaryFill
  }));
};

export const Checkbox1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Checkbox1FilledIcon({}), 'Checkbox1Filled');

const Checkbox1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 7.85a.5.5 0 00-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5zM5.68 3A2.68 2.68 0 003 5.68v8.64C3 15.8 4.2 17 5.68 17h8.64c.64 0 1.22-.22 1.68-.6v-.99a1.5 1.5 0 01-.49.09c-.3.3-.72.5-1.2.5H5.69C4.75 16 4 15.25 4 14.32V5.68C4 4.75 4.75 4 5.68 4h8.64c.93 0 1.68.75 1.68 1.68v6.07l.6-.45c.12-.1.26-.16.4-.21v-5.4C17 4.2 15.8 3 14.32 3H5.68zM18 12.5a.5.5 0 00-.8-.4l-2 1.5a.5.5 0 00.6.8l1.2-.9v4a.5.5 0 101 0v-5z",
    fill: primaryFill
  }));
};

export const Checkbox1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Checkbox1RegularIcon({}), 'Checkbox1Regular');

const Checkbox2FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.68 3A2.68 2.68 0 003 5.68v8.64C3 15.8 4.2 17 5.68 17h7.37c.06-.3.18-.63.4-1 .23-.4.57-.8 1.04-1.23a1.5 1.5 0 01-1.12-2.49A3.51 3.51 0 0115.82 11c.42-.02.82.05 1.18.17V5.68C17 4.2 15.8 3 14.32 3H5.68zm8.17 4.15c.2.2.2.5 0 .7l-5 5a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64 4.65-4.64c.2-.2.5-.2.7 0zM15.93 13c-.3.02-.67.16-1.05.6a.5.5 0 11-.76-.65c.54-.61 1.15-.91 1.76-.95.6-.03 1.14.2 1.52.57.38.36.63.88.59 1.43-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 110 1h-3a.5.5 0 01-.5-.45 1.43 1.43 0 01.03-.34c.04-.19.12-.42.28-.7a5.8 5.8 0 012.2-1.93c.36-.21.47-.46.48-.65a.84.84 0 00-.28-.64c-.2-.19-.48-.3-.78-.29z",
    fill: primaryFill
  }));
};

export const Checkbox2Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Checkbox2FilledIcon({}), 'Checkbox2Filled');

const Checkbox2RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 7.85a.5.5 0 00-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5zM5.68 3A2.68 2.68 0 003 5.68v8.64C3 15.8 4.2 17 5.68 17h7.37c.06-.3.18-.63.4-1H5.68C4.75 16 4 15.25 4 14.32V5.68C4 4.75 4.75 4 5.68 4h8.64c.93 0 1.68.75 1.68 1.68V11c.35 0 .69.06 1 .17V5.68C17 4.2 15.8 3 14.32 3H5.68zm9.2 10.6c.38-.44.76-.58 1.05-.6.3-.01.58.1.78.3.2.19.3.43.28.63-.01.2-.12.44-.49.65a5.8 5.8 0 00-2.2 1.93 2.25 2.25 0 00-.3.92.9.9 0 000 .12.5.5 0 00.5.45h3a.5.5 0 000-1h-2.32c.22-.36.71-.91 1.82-1.55.61-.36.95-.88.99-1.45a1.84 1.84 0 00-.59-1.43c-.38-.36-.92-.6-1.52-.57-.61.04-1.22.34-1.76.95a.5.5 0 00.76.65z",
    fill: primaryFill
  }));
};

export const Checkbox2Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Checkbox2RegularIcon({}), 'Checkbox2Regular');

const CheckboxArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.68C2 3.2 3.2 2 4.68 2h8.64C14.8 2 16 3.2 16 4.68v4.53A5.5 5.5 0 009.2 16H4.69A2.68 2.68 0 012 13.32V4.68zm10.85 2.17a.5.5 0 00-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l5-5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CheckboxArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxArrowRightFilledIcon({}), 'CheckboxArrowRightFilled');

const CheckboxArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 6.85a.5.5 0 00-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l5-5zM4.68 2A2.68 2.68 0 002 4.68v8.64C2 14.8 3.2 16 4.68 16h4.53c-.1-.32-.16-.66-.19-1H4.68C3.75 15 3 14.25 3 13.32V4.68C3 3.75 3.75 3 4.68 3h8.64c.93 0 1.68.75 1.68 1.68v4.34c.34.03.68.1 1 .19V4.68C16 3.2 14.8 2 13.32 2H4.68zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CheckboxArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxArrowRightRegularIcon({}), 'CheckboxArrowRightRegular');

const CheckboxCheckedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.68C3 4.2 4.2 3 5.68 3h8.64C15.8 3 17 4.2 17 5.68v8.64C17 15.8 15.8 17 14.32 17H5.68A2.68 2.68 0 013 14.32V5.68zm10.85 2.17a.5.5 0 00-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5z",
    fill: primaryFill
  }));
};

export const CheckboxCheckedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxCheckedFilledIcon({}), 'CheckboxCheckedFilled');

const CheckboxCheckedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 7.85a.5.5 0 00-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5zM5.68 3A2.68 2.68 0 003 5.68v8.64C3 15.8 4.2 17 5.68 17h8.64C15.8 17 17 15.8 17 14.32V5.68C17 4.2 15.8 3 14.32 3H5.68zM4 5.68C4 4.75 4.75 4 5.68 4h8.64c.93 0 1.68.75 1.68 1.68v8.64c0 .93-.75 1.68-1.68 1.68H5.68C4.75 16 4 15.25 4 14.32V5.68z",
    fill: primaryFill
  }));
};

export const CheckboxCheckedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxCheckedRegularIcon({}), 'CheckboxCheckedRegular');

const CheckboxCheckedSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.68 2A2.68 2.68 0 002 4.68v8.64C2 14.8 3.2 16 4.68 16h4.53A5.5 5.5 0 0116 9.2V4.69C16 3.2 14.8 2 13.32 2H4.68zm8.17 4.15c.2.2.2.5 0 .7l-5 5a.5.5 0 01-.7 0l-2-2a.5.5 0 11.7-.7l1.65 1.64 4.65-4.64c.2-.2.5-.2.7 0zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const CheckboxCheckedSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxCheckedSyncFilledIcon({}), 'CheckboxCheckedSyncFilled');

const CheckboxCheckedSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 6.15c.2.2.2.5 0 .7l-5 5a.5.5 0 01-.7 0l-2-2a.5.5 0 11.7-.7l1.65 1.64 4.65-4.64c.2-.2.5-.2.7 0zM2 4.68C2 3.2 3.2 2 4.68 2h8.64C14.8 2 16 3.2 16 4.68v4.53c-.32-.1-.66-.16-1-.19V4.68C15 3.75 14.25 3 13.32 3H4.68C3.75 3 3 3.75 3 4.68v8.64c0 .93.75 1.68 1.68 1.68h4.34c.03.34.1.68.19 1H4.68A2.68 2.68 0 012 13.32V4.68zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const CheckboxCheckedSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxCheckedSyncRegularIcon({}), 'CheckboxCheckedSyncRegular');

const CheckboxIndeterminateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 5.5a.75.75 0 00-.75.75v7.5c0 .41.33.75.75.75h7.5c.41 0 .75-.34.75-.75v-7.5a.75.75 0 00-.75-.75h-7.5zm-1-2.5C4.01 3 3 4 3 5.25v9.5C3 15.99 4 17 5.25 17h9.5c1.24 0 2.25-1 2.25-2.25v-9.5C17 4.01 16 3 14.75 3h-9.5zM4.5 5.25c0-.41.34-.75.75-.75h9.5c.41 0 .75.34.75.75v9.5c0 .41-.34.75-.75.75h-9.5a.75.75 0 01-.75-.75v-9.5z",
    fill: primaryFill
  }));
};

export const CheckboxIndeterminateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxIndeterminateFilledIcon({}), 'CheckboxIndeterminateFilled');

const CheckboxIndeterminateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.75 5a.75.75 0 00-.75.75v8.5c0 .41.34.75.75.75h8.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 00-.75-.75h-8.5zM5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zM4 5a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V5z",
    fill: primaryFill
  }));
};

export const CheckboxIndeterminateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxIndeterminateRegularIcon({}), 'CheckboxIndeterminateRegular');

const CheckboxPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.68C2 3.2 3.2 2 4.68 2h8.64C14.8 2 16 3.2 16 4.68v4.36a3 3 0 00-2.73 4.97c-1.1.1-2 .92-2.22 1.99H4.68A2.68 2.68 0 012 13.32V4.68zm10.85 2.17a.5.5 0 00-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l5-5zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CheckboxPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxPersonFilledIcon({}), 'CheckboxPersonFilled');

const CheckboxPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 6.85a.5.5 0 00-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l5-5zM4.68 2A2.68 2.68 0 002 4.68v8.64C2 14.8 3.2 16 4.68 16h6.37c.07-.37.23-.7.45-1H4.68C3.75 15 3 14.25 3 13.32V4.68C3 3.75 3.75 3 4.68 3h8.64c.93 0 1.68.75 1.68 1.68v4.36a3.02 3.02 0 011 0V4.68C16 3.2 14.8 2 13.32 2H4.68zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CheckboxPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxPersonRegularIcon({}), 'CheckboxPersonRegular');

const CheckboxUncheckedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.25C3 4.01 4 3 5.25 3h9.5C15.99 3 17 4 17 5.25v9.5c0 1.24-1 2.25-2.25 2.25h-9.5C4.01 17 3 16 3 14.75v-9.5zm2.25-.75a.75.75 0 00-.75.75v9.5c0 .41.34.75.75.75h9.5c.41 0 .75-.34.75-.75v-9.5a.75.75 0 00-.75-.75h-9.5z",
    fill: primaryFill
  }));
};

export const CheckboxUncheckedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxUncheckedFilledIcon({}), 'CheckboxUncheckedFilled');

const CheckboxUncheckedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const CheckboxUncheckedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxUncheckedRegularIcon({}), 'CheckboxUncheckedRegular');

const CheckboxWarningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.68C2 3.2 3.2 2 4.68 2h8.64C14.8 2 16 3.2 16 4.68v5a2 2 0 00-3.3.43L9.78 16H4.68A2.68 2.68 0 012 13.32V4.68zm10.85 2.17a.5.5 0 00-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l5-5zm.75 3.7l-3.5 7A1 1 0 0011 19h7a1 1 0 00.89-1.45l-3.5-7a1 1 0 00-1.8 0zM15 12.5v3a.5.5 0 01-1 0v-3a.5.5 0 111 0zm-.5 5.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const CheckboxWarningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxWarningFilledIcon({}), 'CheckboxWarningFilled');

const CheckboxWarningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 6.85a.5.5 0 00-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l5-5zM4.68 2A2.68 2.68 0 002 4.68v8.64C2 14.8 3.2 16 4.68 16h5.09l.5-1H4.67C3.75 15 3 14.25 3 13.32V4.68C3 3.75 3.75 3 4.68 3h8.64c.93 0 1.68.75 1.68 1.68v4.38c.38.1.73.3 1 .61V4.68C16 3.2 14.8 2 13.32 2H4.68zm8.92 8.55l-3.5 7A1 1 0 0011 19h7a1 1 0 00.89-1.45l-3.5-7a1 1 0 00-1.8 0zM15 12.5v3a.5.5 0 01-1 0v-3a.5.5 0 111 0zm-.5 5.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const CheckboxWarningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckboxWarningRegularIcon({}), 'CheckboxWarningRegular');

const CheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.03 13.9L3.56 10a.75.75 0 00-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 00-1.06-1.06l-9.94 9.94z",
    fill: primaryFill
  }));
};

export const CheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkFilledIcon({}), 'CheckmarkFilled');

const CheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.37 10.17a.5.5 0 00-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 00-.7-.7L7.02 14.27l-3.65-4.1z",
    fill: primaryFill
  }));
};

export const CheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkRegularIcon({}), 'CheckmarkRegular');

const CheckmarkCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm3.36 5.65a.5.5 0 00-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 00-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 00-.06-.63z",
    fill: primaryFill
  }));
};

export const CheckmarkCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkCircleFilledIcon({}), 'CheckmarkCircleFilled');

const CheckmarkCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm3.36 4.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 01-.64.07l-.07-.06-2-2a.5.5 0 01.63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0z",
    fill: primaryFill
  }));
};

export const CheckmarkCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkCircleRegularIcon({}), 'CheckmarkCircleRegular');

const CheckmarkLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8.33A3 3 0 0012.5 12v.06A2 2 0 0011 14v3.94A8 8 0 1110 2zm3.36 5.65a.5.5 0 00-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 00-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 00-.06-.63zM15.5 10a2 2 0 012 2v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4a1 1 0 011-1h.5v-1c0-1.1.9-2 2-2zm-.65 6.37a.75.75 0 101.3-.74.75.75 0 00-1.3.74zM15.5 11a1 1 0 00-1 1v1h2v-1a1 1 0 00-1-1z",
    fill: primaryFill
  }));
};

export const CheckmarkLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkLockFilledIcon({}), 'CheckmarkLockFilled');

const CheckmarkLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8.33 3.02 3.02 0 00-1.03-.94A7 7 0 1011 16.93v1A8 8 0 1110 2zm6.97 8.64A2 2 0 0117.5 12v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4a1 1 0 011-1h.5v-1a2 2 0 013.47-1.36zM14.5 13h2v-1a1 1 0 10-2 0v1zm.35 3.37a.75.75 0 101.3-.74.75.75 0 00-1.3.74zm-1.5-8.72c.18.17.2.44.07.63l-.06.07-4 4a.5.5 0 01-.64.07l-.07-.06-2-2a.5.5 0 01.63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0z",
    fill: primaryFill
  }));
};

export const CheckmarkLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkLockRegularIcon({}), 'CheckmarkLockRegular');

const CheckmarkNoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.03 12.9L2.56 9a.75.75 0 10-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 00-1.06-1.06l-9.94 9.94zM11 13c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2h-5a2 2 0 01-2-2v-4zm6.5 3h-4a.5.5 0 100 1h4a.5.5 0 100-1zm-4-3a.5.5 0 100 1h4a.5.5 0 100-1h-4z",
    fill: primaryFill
  }));
};

export const CheckmarkNoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkNoteFilledIcon({}), 'CheckmarkNoteFilled');

const CheckmarkNoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1.67 9.13a.5.5 0 01.7.04l3.65 4.1L16.15 3.15a.5.5 0 11.7.7l-10.5 10.5a.5.5 0 01-.72-.02l-4-4.5a.5.5 0 01.04-.7zM11 13c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2h-5a2 2 0 01-2-2v-4zm6.5 3h-4a.5.5 0 100 1h4a.5.5 0 100-1zm-4-3a.5.5 0 100 1h4a.5.5 0 100-1h-4z",
    fill: primaryFill
  }));
};

export const CheckmarkNoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkNoteRegularIcon({}), 'CheckmarkNoteRegular');

const CheckmarkStarburstFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.46 1.9l.99.39c.35.14.75.14 1.1 0l.99-.4c1.21-.47 2.58.1 3.1 1.3l.42.97c.16.35.43.62.78.77l.98.43c1.2.52 1.76 1.89 1.28 3.1l-.39.99a1.5 1.5 0 000 1.1l.4.99a2.42 2.42 0 01-1.3 3.1l-.97.42a1.5 1.5 0 00-.78.78l-.42.98a2.42 2.42 0 01-3.1 1.28l-1-.39a1.5 1.5 0 00-1.09 0l-.99.4a2.42 2.42 0 01-3.1-1.3l-.43-.97a1.5 1.5 0 00-.77-.78l-.98-.42a2.42 2.42 0 01-1.28-3.1l.39-1a1.5 1.5 0 000-1.09l-.4-.99a2.42 2.42 0 011.3-3.1l.97-.43c.35-.15.62-.42.77-.77l.43-.98a2.42 2.42 0 013.1-1.28zm4.17 5.77l-3.65 4.1-1.63-1.62a.5.5 0 00-.7.7l2 2c.2.2.53.2.72-.02l4-4.5a.5.5 0 00-.74-.66z",
    fill: primaryFill
  }));
};

export const CheckmarkStarburstFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkStarburstFilledIcon({}), 'CheckmarkStarburstFilled');

const CheckmarkStarburstRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.46 1.9l.99.39c.35.14.75.14 1.1 0l.99-.4c1.21-.47 2.58.1 3.1 1.3l.42.97c.16.35.43.62.78.77l.98.43c1.2.52 1.76 1.89 1.28 3.1l-.39.99a1.5 1.5 0 000 1.1l.4.99a2.42 2.42 0 01-1.3 3.1l-.97.42a1.5 1.5 0 00-.78.78l-.42.98a2.42 2.42 0 01-3.1 1.28l-1-.39a1.5 1.5 0 00-1.09 0l-.99.4a2.42 2.42 0 01-3.1-1.3l-.43-.97a1.5 1.5 0 00-.77-.78l-.98-.42a2.42 2.42 0 01-1.28-3.1l.39-1a1.5 1.5 0 000-1.09l-.4-.99a2.42 2.42 0 011.3-3.1l.97-.43c.35-.15.62-.42.77-.77l.43-.98a2.42 2.42 0 013.1-1.28zm3.44.93l-.99.39a2.5 2.5 0 01-1.83 0l-.99-.4a1.42 1.42 0 00-1.81.76l-.43.98a2.5 2.5 0 01-1.3 1.3l-.97.42c-.7.3-1.03 1.1-.75 1.81l.39 1a2.5 2.5 0 010 1.82l-.4 1c-.27.7.06 1.5.76 1.81l.98.43a2.5 2.5 0 011.3 1.3l.42.97c.3.7 1.1 1.03 1.81.75l1-.39a2.5 2.5 0 011.82 0l1 .4c.7.27 1.5-.06 1.81-.76l.43-.98a2.5 2.5 0 011.3-1.3l.97-.42c.7-.3 1.03-1.1.75-1.82l-.39-.99a2.5 2.5 0 010-1.83l.4-.99a1.42 1.42 0 00-.76-1.81l-.98-.43a2.5 2.5 0 01-1.3-1.3l-.42-.97c-.3-.7-1.1-1.03-1.82-.75zm-2.92 8.94l3.65-4.1a.5.5 0 01.8.59l-.06.07-4 4.5a.5.5 0 01-.65.08l-.07-.06-2-2a.5.5 0 01.63-.76l.07.06 1.63 1.62 3.65-4.1-3.65 4.1z",
    fill: primaryFill
  }));
};

export const CheckmarkStarburstRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkStarburstRegularIcon({}), 'CheckmarkStarburstRegular');

const CheckmarkUnderlineCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 01-.7 0l-2-2a.5.5 0 11.7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0zM7.5 13h5a.5.5 0 010 1h-5a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const CheckmarkUnderlineCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkUnderlineCircleFilledIcon({}), 'CheckmarkUnderlineCircleFilled');

const CheckmarkUnderlineCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 17a7 7 0 110-14 7 7 0 010 14zm0 1a8 8 0 100-16 8 8 0 000 16zm3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 01-.7 0l-2-2a.5.5 0 11.7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0zM7 13.5c0 .28.22.5.5.5h5a.5.5 0 000-1h-5a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const CheckmarkUnderlineCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkUnderlineCircleRegularIcon({}), 'CheckmarkUnderlineCircleRegular');

const ChevronCircleDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm4.85-1.85a.5.5 0 10-.7.7l3.5 3.5a.5.5 0 00.7 0l3.5-3.5a.5.5 0 00-.7-.7L10 11.29 6.85 8.15z",
    fill: primaryFill
  }));
};

export const ChevronCircleDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleDownFilledIcon({}), 'ChevronCircleDownFilled');

const ChevronCircleDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 10a7 7 0 1114 0 7 7 0 01-14 0zm7-8a8 8 0 100 16 8 8 0 000-16zM6.85 8.15a.5.5 0 10-.7.7l3.5 3.5a.5.5 0 00.7 0l3.5-3.5a.5.5 0 00-.7-.7L10 11.29 6.85 8.15z",
    fill: primaryFill
  }));
};

export const ChevronCircleDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleDownRegularIcon({}), 'ChevronCircleDownRegular');

const ChevronCircleLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm1.85 4.85a.5.5 0 00-.7-.7l-3.5 3.5a.5.5 0 000 .7l3.5 3.5a.5.5 0 00.7-.7L8.71 10l3.14-3.15z",
    fill: primaryFill
  }));
};

export const ChevronCircleLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleLeftFilledIcon({}), 'ChevronCircleLeftFilled');

const ChevronCircleLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 110 14 7 7 0 010-14zm8 7a8 8 0 10-16 0 8 8 0 0016 0zm-6.15-3.15a.5.5 0 00-.7-.7l-3.5 3.5a.5.5 0 000 .7l3.5 3.5a.5.5 0 00.7-.7L8.71 10l3.14-3.15z",
    fill: primaryFill
  }));
};

export const ChevronCircleLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleLeftRegularIcon({}), 'ChevronCircleLeftRegular');

const ChevronCircleRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 110-16 8 8 0 010 16zm-1.85-4.85a.5.5 0 00.7.7l3.5-3.5a.5.5 0 000-.7l-3.5-3.5a.5.5 0 10-.7.7L11.29 10l-3.14 3.15z",
    fill: primaryFill
  }));
};

export const ChevronCircleRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleRightFilledIcon({}), 'ChevronCircleRightFilled');

const ChevronCircleRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 17a7 7 0 110-14 7 7 0 010 14zm-8-7a8 8 0 1016 0 8 8 0 00-16 0zm6.15 3.15a.5.5 0 00.7.7l3.5-3.5a.5.5 0 000-.7l-3.5-3.5a.5.5 0 10-.7.7L11.29 10l-3.14 3.15z",
    fill: primaryFill
  }));
};

export const ChevronCircleRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleRightRegularIcon({}), 'ChevronCircleRightRegular');

const ChevronCircleUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1016 0 8 8 0 00-16 0zm4.85 1.85a.5.5 0 01-.7-.7l3.5-3.5a.5.5 0 01.7 0l3.5 3.5a.5.5 0 01-.7.7L10 8.71l-3.15 3.14z",
    fill: primaryFill
  }));
};

export const ChevronCircleUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleUpFilledIcon({}), 'ChevronCircleUpFilled');

const ChevronCircleUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 10a7 7 0 1014 0 7 7 0 00-14 0zm7 8a8 8 0 110-16 8 8 0 010 16zm-3.15-6.15a.5.5 0 01-.7-.7l3.5-3.5a.5.5 0 01.7 0l3.5 3.5a.5.5 0 01-.7.7L10 8.71l-3.15 3.14z",
    fill: primaryFill
  }));
};

export const ChevronCircleUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronCircleUpRegularIcon({}), 'ChevronCircleUpRegular');

const ChevronDoubleDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.8 8.73c.28.3.27.78-.03 1.06l-5.25 5a.75.75 0 01-1.04 0l-5.25-5a.75.75 0 011.04-1.08L10 13.2l4.73-4.5a.75.75 0 011.06.02zm0-4c.28.3.27.78-.03 1.06l-5.25 5a.75.75 0 01-1.04 0l-5.25-5a.75.75 0 011.04-1.08L10 9.2l4.73-4.5a.75.75 0 011.06.02z",
    fill: primaryFill
  }));
};

export const ChevronDoubleDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleDownFilledIcon({}), 'ChevronDoubleDownFilled');

const ChevronDoubleDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.85 8.65c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 01-.78 0L4.15 9.35a.5.5 0 11.7-.7L10 13.8l5.15-5.16c.2-.2.5-.2.7 0zm0-4c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 01-.78 0L4.15 5.35a.5.5 0 11.7-.7L10 9.8l5.15-5.16c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const ChevronDoubleDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleDownRegularIcon({}), 'ChevronDoubleDownRegular');

const ChevronDoubleLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.27 15.8a.75.75 0 01-1.06-.03l-5-5.25a.75.75 0 010-1.04l5-5.25a.75.75 0 111.08 1.04L6.8 10l4.5 4.73c.29.3.28.78-.02 1.06zm4 0a.75.75 0 01-1.06-.03l-5-5.25a.75.75 0 010-1.04l5-5.25a.75.75 0 111.09 1.04L10.79 10l4.5 4.73c.3.3.28.78-.02 1.06z",
    fill: primaryFill
  }));
};

export const ChevronDoubleLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleLeftFilledIcon({}), 'ChevronDoubleLeftFilled');

const ChevronDoubleLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.35 15.85a.5.5 0 01-.7 0L5.16 10.4a.55.55 0 010-.78l5.49-5.46a.5.5 0 11.7.7L6.2 10l5.16 5.15c.2.2.2.5 0 .7zm4 0a.5.5 0 01-.7 0L9.16 10.4a.55.55 0 010-.78l5.49-5.46a.5.5 0 11.7.7L10.2 10l5.16 5.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const ChevronDoubleLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleLeftRegularIcon({}), 'ChevronDoubleLeftRegular');

const ChevronDoubleRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.73 4.2a.75.75 0 011.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 11-1.08-1.04L13.2 10l-4.5-4.73a.75.75 0 01.02-1.06zm-4 0a.75.75 0 011.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 11-1.08-1.04L9.2 10l-4.5-4.73a.75.75 0 01.02-1.06z",
    fill: primaryFill
  }));
};

export const ChevronDoubleRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleRightFilledIcon({}), 'ChevronDoubleRightFilled');

const ChevronDoubleRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 01-.7-.7L13.8 10 8.65 4.85a.5.5 0 010-.7zm-4 0c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 01-.7-.7L9.8 10 4.65 4.85a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const ChevronDoubleRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleRightRegularIcon({}), 'ChevronDoubleRightRegular');

const ChevronDoubleUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.2 15.27a.75.75 0 01.03-1.06l5.25-5a.75.75 0 011.04 0l5.25 5a.75.75 0 01-1.04 1.08L10 10.8l-4.73 4.5a.75.75 0 01-1.06-.02zm0-5a.75.75 0 01.03-1.06l5.25-5a.75.75 0 011.04 0l5.25 5a.75.75 0 01-1.04 1.08L10 5.8l-4.73 4.5a.75.75 0 01-1.06-.02z",
    fill: primaryFill
  }));
};

export const ChevronDoubleUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleUpFilledIcon({}), 'ChevronDoubleUpFilled');

const ChevronDoubleUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.15 9.65a.5.5 0 00.7.7L10 5.2l5.15 5.16a.5.5 0 10.7-.7L10.4 4.16a.55.55 0 00-.78 0L4.15 9.65zm0 5a.5.5 0 00.7.7L10 10.2l5.15 5.16a.5.5 0 10.7-.7L10.4 9.16a.55.55 0 00-.78 0l-5.46 5.49z",
    fill: primaryFill
  }));
};

export const ChevronDoubleUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDoubleUpRegularIcon({}), 'ChevronDoubleUpRegular');

const ChevronDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.8 7.73c.28.3.27.78-.03 1.06l-5.25 5a.75.75 0 01-1.04 0l-5.25-5a.75.75 0 011.04-1.08L10 12.2l4.73-4.5a.75.75 0 011.06.02z",
    fill: primaryFill
  }));
};

export const ChevronDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDownFilledIcon({}), 'ChevronDownFilled');

const ChevronDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.85 7.65c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 01-.78 0L4.15 8.35a.5.5 0 11.7-.7L10 12.8l5.15-5.16c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const ChevronDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronDownRegularIcon({}), 'ChevronDownRegular');

const ChevronLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.27 15.8a.75.75 0 01-1.06-.03l-5-5.25a.75.75 0 010-1.04l5-5.25a.75.75 0 111.08 1.04L7.8 10l4.5 4.73c.29.3.28.78-.02 1.06z",
    fill: primaryFill
  }));
};

export const ChevronLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronLeftFilledIcon({}), 'ChevronLeftFilled');

const ChevronLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.35 15.85a.5.5 0 01-.7 0L6.16 10.4a.55.55 0 010-.78l5.49-5.46a.5.5 0 11.7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const ChevronLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronLeftRegularIcon({}), 'ChevronLeftRegular');

const ChevronRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.73 4.2a.75.75 0 011.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 11-1.08-1.04L12.2 10l-4.5-4.73a.75.75 0 01.02-1.06z",
    fill: primaryFill
  }));
};

export const ChevronRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronRightFilledIcon({}), 'ChevronRightFilled');

const ChevronRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 01-.7-.7L12.8 10 7.65 4.85a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const ChevronRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronRightRegularIcon({}), 'ChevronRightRegular');

const ChevronUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.2 12.27a.75.75 0 01.03-1.06l5.25-5a.75.75 0 011.04 0l5.25 5a.75.75 0 01-1.04 1.08L10 7.8l-4.73 4.5a.75.75 0 01-1.06-.02z",
    fill: primaryFill
  }));
};

export const ChevronUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronUpFilledIcon({}), 'ChevronUpFilled');

const ChevronUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.15 12.35a.5.5 0 010-.7L9.6 6.16a.55.55 0 01.78 0l5.46 5.49a.5.5 0 01-.7.7L10 7.2l-5.15 5.16a.5.5 0 01-.7 0z",
    fill: primaryFill
  }));
};

export const ChevronUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronUpRegularIcon({}), 'ChevronUpRegular');

const ChevronUpDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.1 7.3a.75.75 0 01-1.13.98L10 4.31 6.03 8.28l-.08.07a.75.75 0 01-.98-1.13l4.5-4.5.08-.07c.3-.22.71-.2.98.07l4.5 4.5.07.08zM4.9 12.7a.75.75 0 011.13-.98L10 15.69l3.97-3.97.08-.07a.75.75 0 01.98 1.13l-4.5 4.5-.08.07c-.3.22-.71.2-.98-.07l-4.5-4.5-.07-.08z",
    fill: primaryFill
  }));
};

export const ChevronUpDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronUpDownFilledIcon({}), 'ChevronUpDownFilled');

const ChevronUpDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.91 7.22a.5.5 0 01-.76.63L10 3.71 5.85 7.85l-.07.06a.5.5 0 01-.63-.76l4.5-4.5.07-.06a.5.5 0 01.63.06l4.5 4.5.06.07zM5.1 12.78a.5.5 0 01.76-.63L10 16.29l4.15-4.14.07-.06a.5.5 0 01.63.76l-4.5 4.5-.07.06a.5.5 0 01-.63-.06l-4.5-4.5-.06-.07z",
    fill: primaryFill
  }));
};

export const ChevronUpDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChevronUpDownRegularIcon({}), 'ChevronUpDownRegular');

const CircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16z",
    fill: primaryFill
  }));
};

export const CircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleFilledIcon({}), 'CircleFilled');

const CircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 100 14 7 7 0 000-14zm-8 7a8 8 0 1116 0 8 8 0 01-16 0z",
    fill: primaryFill
  }));
};

export const CircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleRegularIcon({}), 'CircleRegular');

const CircleEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 00-1 15.94c.02-.1.03-.2.06-.29l.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83a2.87 2.87 0 012.85-.72A8 8 0 0010 2zm.98 13.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const CircleEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleEditFilledIcon({}), 'CircleEditFilled');

const CircleEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 00-.77 13.96l-.17.7c-.03.09-.04.18-.05.28a8 8 0 118.94-8.82c-.33-.1-.68-.14-1.02-.11A7 7 0 0010 3zm.98 12.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const CircleEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleEditRegularIcon({}), 'CircleEditRegular');

const CircleHalfFillFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.54 9.25h12.92a6.5 6.5 0 00-12.92 0zM2 10a8 8 0 1116 0 8 8 0 01-16 0z",
    fill: primaryFill
  }));
};

export const CircleHalfFillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleHalfFillFilledIcon({}), 'CircleHalfFillFilled');

const CircleHalfFillRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zm0 1a7 7 0 016.98 6.5H3.02A7 7 0 0110 3z",
    fill: primaryFill
  }));
};

export const CircleHalfFillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleHalfFillRegularIcon({}), 'CircleHalfFillRegular');

const CircleLineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.98 10.5H2.02a8 8 0 0015.96 0zm0-1H2.02a8 8 0 0115.96 0z",
    fill: primaryFill
  }));
};

export const CircleLineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleLineFilledIcon({}), 'CircleLineFilled');

const CircleLineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.02 9.5h13.96a7 7 0 00-13.96 0zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm14.98.5H3.02a7 7 0 0013.96 0z",
    fill: primaryFill
  }));
};

export const CircleLineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleLineRegularIcon({}), 'CircleLineRegular');

const CircleMultipleSubtractCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 6A7 7 0 006 12.92 6 6 0 1112.92 6zm-3.8 0H4.5a.5.5 0 000 1h3.2c.44-.38.92-.72 1.42-1zM19 13a6 6 0 11-12 0 6 6 0 0112 0zm-3.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-1.15-1.14a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CircleMultipleSubtractCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleMultipleSubtractCheckmarkFilledIcon({}), 'CircleMultipleSubtractCheckmarkFilled');

const CircleMultipleSubtractCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a5 5 0 014.92 4.08c.32-.05.66-.08 1-.08A6 6 0 106 12.92c0-.34.03-.68.08-1A5 5 0 017 2zM4.5 6a.5.5 0 000 1h5a.5.5 0 000-1h-5zm11.35 5.85a.5.5 0 00-.7-.7l-2.65 2.64-1.15-1.14a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3zM13 19a6 6 0 100-12 6 6 0 000 12zm0-1a5 5 0 110-10 5 5 0 010 10z",
    fill: primaryFill
  }));
};

export const CircleMultipleSubtractCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleMultipleSubtractCheckmarkRegularIcon({}), 'CircleMultipleSubtractCheckmarkRegular');

const CircleOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.3 16l1.85 1.85a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7L4 4.71A8 8 0 0015.3 16zm2.7-6c0 1.67-.51 3.21-1.38 4.5L5.5 3.38A8 8 0 0118 10z",
    fill: primaryFill
  }));
};

export const CircleOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleOffFilledIcon({}), 'CircleOffFilled');

const CircleOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.7L2.15 2.86a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7L15.29 16A8 8 0 014 4.7zm10.58 10.6L4.71 5.41a7 7 0 009.87 9.87zM17 10c0 1.39-.4 2.69-1.1 3.77l.72.73A8 8 0 005.5 3.39l.72.71A7 7 0 0117 10z",
    fill: primaryFill
  }));
};

export const CircleOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleOffRegularIcon({}), 'CircleOffRegular');

const CircleSmallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 10a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const CircleSmallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleSmallFilledIcon({}), 'CircleSmallFilled');

const CircleSmallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 12a2 2 0 110-4 2 2 0 010 4zm0 1a3 3 0 100-6 3 3 0 000 6z",
    fill: primaryFill
  }));
};

export const CircleSmallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleSmallRegularIcon({}), 'CircleSmallRegular');

const CityFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2c.28 0 .5.22.5.5V4h1c.83 0 1.5.67 1.5 1.5v2.55a2.5 2.5 0 00-2 2.45V18h-2V8a2 2 0 00-2-2v-.5C8 4.67 8.67 4 9.5 4h1V2.5c0-.28.22-.5.5-.5zM8.64 7.24c-.28-.2-.48-.2-.64-.15a.77.77 0 00-.14.06L4.73 9.03A1.5 1.5 0 004 10.32v6.18c0 .83.67 1.5 1.5 1.5H9V8a1 1 0 00-.36-.76zM15.5 9h-1c-.83 0-1.5.68-1.5 1.5V18h3.5c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-1z",
    fill: primaryFill
  }));
};

export const CityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CityFilledIcon({}), 'CityFilled');

const CityRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c.28 0 .5.22.5.5V4h1c.83 0 1.5.67 1.5 1.5V9h2.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 16.5v-6.18c0-.53.28-1.02.73-1.29l3-1.8c.09-.05.18-.1.27-.13V5.5C7 4.67 7.67 4 8.5 4h1V2.5c0-.28.22-.5.5-.5zM8 7.1c.56.2 1 .73 1 1.42V17h2v-6.5c0-.65.42-1.2 1-1.41V5.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v1.6zm4.5 2.9a.5.5 0 00-.5.5V17h3.5a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-3zM7.24 8.09l-3 1.8a.5.5 0 00-.24.43v6.18c0 .28.22.5.5.5H8V8.52a.5.5 0 00-.76-.43z",
    fill: primaryFill
  }));
};

export const CityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CityRegularIcon({}), 'CityRegular');

const ClassFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2h-3v6.5a.5.5 0 01-.8.4L8.5 7.62 6.8 8.9a.5.5 0 01-.8-.4V2zm4 0H7v5.5l1.2-.9a.5.5 0 01.6 0l1.2.9V2z",
    fill: primaryFill
  }));
};

export const ClassFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClassFilledIcon({}), 'ClassFilled');

const ClassRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 011-1.73V16a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1h-2V2h2a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2-2v6.5a.5.5 0 00.8.4l1.7-1.28 1.7 1.28a.5.5 0 00.8-.4V2H6zm1 5.5V3h3v4.5l-1.2-.9a.5.5 0 00-.6 0L7 7.5z",
    fill: primaryFill
  }));
};

export const ClassRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClassRegularIcon({}), 'ClassRegular');

const ClassificationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.57 16.48a1 1 0 01-1.42 0L3.5 10.82a1 1 0 010-1.41l1.42-1.42-.08-.1a1 1 0 01.08-1.31L6.68 4.8a2.5 2.5 0 013.53 0l1.31 1.31 1.44-2.41a2.44 2.44 0 013.83-.48 2.42 2.42 0 01-.5 3.8l-2.43 1.42 1.3 1.31a2.5 2.5 0 010 3.54l-1.77 1.76a1 1 0 01-1.41 0l-1.41 1.42zM5.62 8.7L4.2 10.1l5.66 5.66 1.41-1.41L5.62 8.7zm8.2-4.48l-1.56 2.63.87.87 2.66-1.55a1.43 1.43 0 00.01-2.46 1.44 1.44 0 00-1.98.5z",
    fill: primaryFill
  }));
};

export const ClassificationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClassificationFilledIcon({}), 'ClassificationFilled');

const ClassificationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.31 2.85a2.42 2.42 0 01-.02 4.18l-2.43 1.42 1.3 1.31a2.5 2.5 0 010 3.54l-1.77 1.76a1 1 0 01-1.41 0l-1.41 1.42a1 1 0 01-1.42 0L3.5 10.82a1 1 0 010-1.41l1.42-1.42-.08-.1a1 1 0 01.08-1.31L6.68 4.8a2.5 2.5 0 013.53 0l1.31 1.31 1.44-2.41a2.44 2.44 0 013.35-.86zM5.61 8.7l-1.4 1.41 5.65 5.66 1.41-1.41L5.62 8.7zm1.77-3.18L5.62 7.28l7.07 7.08 1.76-1.77a1.5 1.5 0 000-2.12l-1.7-1.71-.04-.03-1.44-1.44-.05-.06L9.5 5.52a1.5 1.5 0 00-2.12 0zm6.44-1.3l-1.56 2.63.87.87 2.66-1.55a1.43 1.43 0 00.01-2.46 1.44 1.44 0 00-1.98.5z",
    fill: primaryFill
  }));
};

export const ClassificationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClassificationRegularIcon({}), 'ClassificationRegular');

const ClearFormattingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.47 3c-.38 0-.7.28-.75.65l-.13 1a.75.75 0 101.49.2l.04-.35H7.9l-1.57 9h-.58a.75.75 0 000 1.5h2.5a.75.75 0 000-1.5h-.4l1.57-9h2.69l-.02.16a.75.75 0 101.48.2l.14-1.01a.75.75 0 00-.75-.85h-8.5zM2.75 15.5a.75.75 0 000 1.5H9.6a5.46 5.46 0 01-.5-1.5H2.74zm16.25-1a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const ClearFormattingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClearFormattingFilledIcon({}), 'ClearFormattingFilled');

const ClearFormattingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.25 3a.5.5 0 00-.5.42l-.24 1.5a.5.5 0 00.98.16L4.67 4h3.57l-1.73 9.91a.5.5 0 00-.01.09h-1a.5.5 0 000 1h3a.5.5 0 000-1h-1l1.74-9.91A.5.5 0 009.25 4h3.41l-.15.92a.5.5 0 10.98.16l.25-1.5a.5.5 0 00-.49-.58h-9zM9.6 17c-.16-.32-.3-.65-.4-1H2.5a.5.5 0 000 1h7.1zm9.4-2.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const ClearFormattingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClearFormattingRegularIcon({}), 'ClearFormattingRegular');

const ClipboardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }));
};

export const ClipboardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardFilledIcon({}), 'ClipboardFilled');

const ClipboardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM7.09 4H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1z",
    fill: primaryFill
  }));
};

export const ClipboardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardRegularIcon({}), 'ClipboardRegular');

const ClipboardArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 00-5.74 8.8H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const ClipboardArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardArrowRightFilledIcon({}), 'ClipboardArrowRightFilled');

const ClipboardArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7c-.32-.08-.66-.15-1-.18V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const ClipboardArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardArrowRightRegularIcon({}), 'ClipboardArrowRightRegular');

const ClipboardBulletListLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1zM8.5 3h3a.5.5 0 010 1h-3a.5.5 0 010-1zM9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 010 1H9.5a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5H13a.5.5 0 010 1H9.5a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5H13a.5.5 0 010 1H9.5a.5.5 0 01-.5-.5zm-1-6a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 3a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const ClipboardBulletListLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardBulletListLtrFilledIcon({}), 'ClipboardBulletListLtrFilled');

const ClipboardBulletListLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 010 1H9.5a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5H13a.5.5 0 010 1H9.5a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5H13a.5.5 0 010 1H9.5a.5.5 0 01-.5-.5zm-1-6a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 3a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zM7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM7.09 4H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1z",
    fill: primaryFill
  }));
};

export const ClipboardBulletListLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardBulletListLtrRegularIcon({}), 'ClipboardBulletListLtrRegular');

const ClipboardBulletListRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59c.2-.58.76-1 1.41-1zM8 3.5c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5zm4.75 5.75a.75.75 0 100-1.5.75.75 0 000 1.5zm0 3a.75.75 0 100-1.5.75.75 0 000 1.5zM12 14.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-1-6a.5.5 0 00-.5-.5H7a.5.5 0 000 1h3.5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5H7a.5.5 0 000 1h3.5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5H7a.5.5 0 000 1h3.5a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardBulletListRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardBulletListRtlFilledIcon({}), 'ClipboardBulletListRtlFilled');

const ClipboardBulletListRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.75 9.25a.75.75 0 110-1.5.75.75 0 010 1.5zm0 3a.75.75 0 110-1.5.75.75 0 010 1.5zM12 14.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-1-6a.5.5 0 00-.5-.5H7a.5.5 0 000 1h3.5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5H7a.5.5 0 000 1h3.5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5H7a.5.5 0 000 1h3.5a.5.5 0 00.5-.5zM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardBulletListRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardBulletListRtlRegularIcon({}), 'ClipboardBulletListRtlRegular');

const ClipboardCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 00-5.74 8.8H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const ClipboardCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardCheckmarkFilledIcon({}), 'ClipboardCheckmarkFilled');

const ClipboardCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7c-.32-.08-.66-.15-1-.18V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const ClipboardCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardCheckmarkRegularIcon({}), 'ClipboardCheckmarkRegular');

const ClipboardClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 9.5a.5.5 0 00-1 0V11c0 .28.22.5.5.5h1.5a.5.5 0 000-1h-1v-1zM7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm5.5 8a4 4 0 10-8 0 4 4 0 008 0z",
    fill: primaryFill
  }));
};

export const ClipboardClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardClockFilledIcon({}), 'ClipboardClockFilled');

const ClipboardClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 9.5a.5.5 0 00-1 0V11c0 .28.22.5.5.5h1.5a.5.5 0 000-1h-1v-1zM10 15a4 4 0 100-8 4 4 0 000 8zm0-1a3 3 0 110-6 3 3 0 010 6zM7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM7.09 4H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1z",
    fill: primaryFill
  }));
};

export const ClipboardClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardClockRegularIcon({}), 'ClipboardClockRegular');

const ClipboardCodeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.88a1.5 1.5 0 00-2.44.71l-.4 1.41h-.74a1.5 1.5 0 00-2.55-.48l-1.5 1.75a1.5 1.5 0 000 1.95l1.5 1.75c.29.35.7.53 1.13.53H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm2.88 10.32a.5.5 0 10-.76-.65l-1.5 1.75a.5.5 0 000 .65l1.5 1.75a.5.5 0 00.7.06.5.5 0 00.06-.71l-1.22-1.42 1.22-1.43zm4.1-1.68a.5.5 0 10-.96-.28l-2 7a.5.5 0 10.97.28l2-7zm1.2 5.24a.5.5 0 01-.06-.71l1.22-1.42-1.22-1.43a.5.5 0 01.76-.65l1.5 1.75a.5.5 0 010 .65l-1.5 1.75a.5.5 0 01-.7.06z",
    fill: primaryFill
  }));
};

export const ClipboardCodeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardCodeFilledIcon({}), 'ClipboardCodeFilled');

const ClipboardCodeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.88a1.5 1.5 0 00-1-.38V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h3.96l.4.47c.3.35.72.53 1.14.53H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm6.99 8.64a.5.5 0 10-.97-.28l-2 7a.5.5 0 10.97.28l2-7zm-4.11 1.68a.5.5 0 10-.76-.65l-1.5 1.75a.5.5 0 000 .65l1.5 1.75a.5.5 0 10.76-.65l-1.22-1.42 1.22-1.43zm5.3 3.56a.5.5 0 01-.06-.71l1.22-1.42-1.22-1.43a.5.5 0 01.76-.65l1.5 1.75a.5.5 0 010 .65l-1.5 1.75a.5.5 0 01-.7.06z",
    fill: primaryFill
  }));
};

export const ClipboardCodeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardCodeRegularIcon({}), 'ClipboardCodeRegular');

const ClipboardDataBarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm5 8.5v2.5a.5.5 0 01-1 0V12a.5.5 0 011 0zm-3-3c.28 0 .5.22.5.5v5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zM8 7.5v7a.5.5 0 01-1 0v-7a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const ClipboardDataBarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardDataBarFilledIcon({}), 'ClipboardDataBarFilled');

const ClipboardDataBarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5zm7.5 8a.5.5 0 00-1 0v2.5a.5.5 0 001 0V12zm-3-3c.28 0 .5.22.5.5v5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zM8 7.5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7z",
    fill: primaryFill
  }));
};

export const ClipboardDataBarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardDataBarRegularIcon({}), 'ClipboardDataBarRegular');

const ClipboardEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H8l.06-.35.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83c.53-.53 1.21-.8 1.9-.84V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm1.98 11.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const ClipboardEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardEditFilledIcon({}), 'ClipboardEditFilled');

const ClipboardEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H8l.06-.35.16-.65H5.5a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v4.73c.32-.14.66-.21 1-.23V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm1.98 11.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const ClipboardEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardEditRegularIcon({}), 'ClipboardEditRegular');

const ClipboardErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 00-5.74 8.8H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const ClipboardErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardErrorFilledIcon({}), 'ClipboardErrorFilled');

const ClipboardErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7c-.32-.08-.66-.15-1-.18V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const ClipboardErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardErrorRegularIcon({}), 'ClipboardErrorRegular');

const ClipboardHeartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9c-.7.03-1.4.25-2 .66a3.85 3.85 0 00-4.87 5.91L11.55 18H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm5.15 15.68a.5.5 0 00.7 0l3.82-3.81a2.85 2.85 0 10-4.03-4.04l-.14.14-.13-.14a2.85 2.85 0 10-4.04 4.04l3.82 3.81z",
    fill: primaryFill
  }));
};

export const ClipboardHeartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardHeartFilledIcon({}), 'ClipboardHeartFilled');

const ClipboardHeartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9c-.34.02-.67.07-1 .18V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h5.05l1 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm1.33 7.83a2.85 2.85 0 014.04 0l.13.14.14-.14a2.85 2.85 0 014.03 4.04l-3.81 3.81a.5.5 0 01-.71 0l-3.82-3.81a2.85 2.85 0 010-4.04z",
    fill: primaryFill
  }));
};

export const ClipboardHeartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardHeartRegularIcon({}), 'ClipboardHeartRegular');

const ClipboardImageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9h-3.5A3.5 3.5 0 009 12.5v4c0 .54.12 1.05.34 1.5H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm1.5 9.5a2.5 2.5 0 012.5-2.5h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0l-3.03 3.03z",
    fill: primaryFill
  }));
};

export const ClipboardImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardImageFilledIcon({}), 'ClipboardImageFilled');

const ClipboardImageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9h-1V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h3.54c.05.35.15.69.3 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm1.5 9.5a2.5 2.5 0 012.5-2.5h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0l-3.03 3.03z",
    fill: primaryFill
  }));
};

export const ClipboardImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardImageRegularIcon({}), 'ClipboardImageRegular');

const ClipboardLetterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.59a1.5 1.5 0 01.04-1.1l3.5-8a1.5 1.5 0 012.74 0l.63 1.44V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zm3 1a.5.5 0 010 1h-3a.5.5 0 010-1h3zm2.95 6.3a.5.5 0 00-.91 0l-3.5 8a.5.5 0 10.92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 00.92-.4l-3.5-8zm.97 4.7h-2.84L14 10.75 15.42 14z",
    fill: primaryFill
  }));
};

export const ClipboardLetterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLetterFilledIcon({}), 'ClipboardLetterFilled');

const ClipboardLetterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.84l-.63-1.44a1.5 1.5 0 00-.37-.51V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h3.59a1.5 1.5 0 000 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm5.95 6.3a.5.5 0 00-.91 0l-3.5 8a.5.5 0 00.92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 00.92-.4l-3.5-8zm.97 4.7h-2.85L14 10.75 15.42 14z",
    fill: primaryFill
  }));
};

export const ClipboardLetterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLetterRegularIcon({}), 'ClipboardLetterRegular');

const ClipboardLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-3.5a4.5 4.5 0 00-3.74 7H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 15.5a3.5 3.5 0 00-3.5-3.5h-.09a.5.5 0 00.09 1h.16a2.5 2.5 0 01-.16 5l-.1.01a.5.5 0 00.1 1V19h.2a3.5 3.5 0 003.3-3.5zm-6-3a.5.5 0 00-.5-.5h-.2a3.5 3.5 0 00.2 7h.09a.5.5 0 00-.09-1h-.16a2.5 2.5 0 01.16-5h.09a.5.5 0 00.41-.5zm2.5 2.5h-3.09a.5.5 0 00.09 1h3.09a.5.5 0 00-.09-1z",
    fill: primaryFill
  }));
};

export const ClipboardLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLinkFilledIcon({}), 'ClipboardLinkFilled');

const ClipboardLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-1V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h2.76c.12.36.3.7.5 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM19 15.5a3.5 3.5 0 00-3.5-3.5h-.09a.5.5 0 00.09 1h.16a2.5 2.5 0 01-.16 5l-.1.01a.5.5 0 00.1 1V19h.2a3.5 3.5 0 003.3-3.5zm-6-3a.5.5 0 00-.5-.5h-.2a3.5 3.5 0 00.2 7h.09a.5.5 0 00-.09-1h-.16a2.5 2.5 0 01.16-5h.09a.5.5 0 00.41-.5zm2.5 2.5h-3.09a.5.5 0 00.09 1h3.09a.5.5 0 00-.09-1z",
    fill: primaryFill
  }));
};

export const ClipboardLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLinkRegularIcon({}), 'ClipboardLinkRegular');

const ClipboardMoreFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48c-.43.22-.78.56-1 .99a2.25 2.25 0 00-4 0A2.25 2.25 0 006.98 18H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm1.75 14a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM13 18.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm4 0a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const ClipboardMoreFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardMoreFilledIcon({}), 'ClipboardMoreFilled');

const ClipboardMoreRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48c-.43.22-.78.56-1 .99V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h1.25c0 .36.08.7.23 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm1.75 14a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM13 18.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm4 0a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const ClipboardMoreRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardMoreRegularIcon({}), 'ClipboardMoreRegular');

const ClipboardNoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-4a3 3 0 00-3 3v4a3 3 0 00.17 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm3.5 8a2 2 0 00-2 2v4c0 1.1.9 2 2 2h5a2 2 0 002-2v-4a2 2 0 00-2-2h-5zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5zm0-3c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardNoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardNoteFilledIcon({}), 'ClipboardNoteFilled');

const ClipboardNoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.84a3.48 3.48 0 01-.3-1H5.5a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5V10h1V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm4 7.5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h5a2 2 0 002-2v-4a2 2 0 00-2-2h-5zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5zm0-3c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardNoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardNoteRegularIcon({}), 'ClipboardNoteRegular');

const ClipboardPasteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 001 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 000-1h-3a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5zm3 0a.5.5 0 010-1h3a.5.5 0 010 1h-3zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-5z",
    fill: primaryFill
  }));
};

export const ClipboardPasteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPasteFilledIcon({}), 'ClipboardPasteFilled');

const ClipboardPasteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 001 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 000-1h-3a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5zm3 0a.5.5 0 010-1h3a.5.5 0 010 1h-3zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-5zM10 8.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v8a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-8z",
    fill: primaryFill
  }));
};

export const ClipboardPasteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPasteRegularIcon({}), 'ClipboardPasteRegular');

const ClipboardPulseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1.57l-.59-1.17a1.5 1.5 0 00-2.68 0l-.33.65-.9-2.92a1.5 1.5 0 00-2.8-.17L5.53 10H4V4.5C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm5 10H16v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5V13h2.5c.6 0 1.13-.35 1.37-.9l.37-.83.83 2.67a1.5 1.5 0 002.77.23l.74-1.48c.26.2.58.31.92.31zM8.98 6.85a.5.5 0 00-.94-.05L6.18 11H2.5a.5.5 0 000 1h4a.5.5 0 00.46-.3L8.4 8.42l1.61 5.23a.5.5 0 00.93.07l1.55-3.1.55 1.1a.5.5 0 00.45.28h4a.5.5 0 000-1h-3.7l-.85-1.72a.5.5 0 00-.9 0l-1.44 2.88-1.63-5.3z",
    fill: primaryFill
  }));
};

export const ClipboardPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPulseFilledIcon({}), 'ClipboardPulseFilled');

const ClipboardPulseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5V10H4V4.5C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM15 13h1v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5V13h1v3.5c0 .28.22.5.5.5h9a.5.5 0 00.5-.5V13zM8.98 6.85a.5.5 0 00-.94-.05L6.18 11H2.5a.5.5 0 000 1h4a.5.5 0 00.46-.3L8.4 8.42l1.61 5.23a.5.5 0 00.93.07l1.55-3.1.55 1.1a.5.5 0 00.45.28h4a.5.5 0 000-1h-3.7l-.85-1.72a.5.5 0 00-.9 0l-1.44 2.88-1.63-5.3z",
    fill: primaryFill
  }));
};

export const ClipboardPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPulseRegularIcon({}), 'ClipboardPulseRegular');

const ClipboardSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76a4.5 4.5 0 015.56 6.18l2 2c.42.42.54 1.03.35 1.56h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zm3 1a.5.5 0 010 1h-3a.5.5 0 010-1h3zM8.3 14.6a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 00.7-.7L8.3 14.6zm-2.8.4a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const ClipboardSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSearchFilledIcon({}), 'ClipboardSearchFilled');

const ClipboardSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76c.32-.12.65-.2 1-.23V4.5c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 01-.5.5h-2.59c.12.32.12.68 0 1h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zm3 1a.5.5 0 010 1h-3a.5.5 0 010-1h3zM8.3 14.6a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 00.7-.7L8.3 14.6zm-2.8.4a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const ClipboardSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSearchRegularIcon({}), 'ClipboardSearchRegular');

const ClipboardSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 00-5.74 8.8H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm3.57 8.44a2 2 0 01-1.44 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const ClipboardSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSettingsFilledIcon({}), 'ClipboardSettingsFilled');

const ClipboardSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7c-.32-.08-.66-.15-1-.18V4.5a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm3.57 8.44a2 2 0 01-1.44 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const ClipboardSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSettingsRegularIcon({}), 'ClipboardSettingsRegular');

const ClipboardTaskFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm4.85 6.35l-3.5 3.5a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7L9 12.29l3.15-3.14a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const ClipboardTaskFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskFilledIcon({}), 'ClipboardTaskFilled');

const ClipboardTaskRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 9.85a.5.5 0 00-.7-.7L9 12.29l-1.15-1.14a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l3.5-3.5zM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardTaskRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskRegularIcon({}), 'ClipboardTaskRegular');

const ClipboardTaskAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76A5.5 5.5 0 0114 9.02V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm4.85 6.35l-3.5 3.5a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7L7 12.29l3.15-3.14a.5.5 0 01.7.7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ClipboardTaskAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskAddFilledIcon({}), 'ClipboardTaskAddFilled');

const ClipboardTaskAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76a5.5 5.5 0 01-.66-1H3.5a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v4.7c.32-.08.66-.15 1-.18V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm4.85 6.35a.5.5 0 00-.7-.7L7 12.29l-1.15-1.14a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l3.5-3.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ClipboardTaskAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskAddRegularIcon({}), 'ClipboardTaskAddRegular');

const ClipboardTaskListLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm1.35 4.35L7.6 9.6a.5.5 0 01-.69.02l-.75-.69a.5.5 0 11.68-.73l.4.36 1.4-1.41a.5.5 0 11.71.7zm0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zm1.65.6h2.5a.5.5 0 010 1H11a.5.5 0 010-1zm-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1H11a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListLtrFilledIcon({}), 'ClipboardTaskListLtrFilled');

const ClipboardTaskListLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.35 7.85a.5.5 0 00-.7-.7l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75zm0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zm1.65.6a.5.5 0 000 1h2.5a.5.5 0 000-1H11zm-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1H11a.5.5 0 01-.5-.5zM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListLtrRegularIcon({}), 'ClipboardTaskListLtrRegular');

const ClipboardTaskListRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zm5.35 4.15a.5.5 0 00-.7 0l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75a.5.5 0 000-.7zm0 5.7a.5.5 0 00-.7-.7l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75zM6.5 8a.5.5 0 000 1H9a.5.5 0 000-1H6.5zM6 13.5c0 .28.22.5.5.5H9a.5.5 0 000-1H6.5a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListRtlFilledIcon({}), 'ClipboardTaskListRtlFilled');

const ClipboardTaskListRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 7.15c.2.2.2.5 0 .7L12.1 9.6a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zm0 5.7a.5.5 0 00-.7-.7l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75zM6.5 8a.5.5 0 000 1H9a.5.5 0 000-1H6.5zM6 13.5c0-.28.22-.5.5-.5H9a.5.5 0 010 1H6.5a.5.5 0 01-.5-.5zM7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zM8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM7.09 4H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListRtlRegularIcon({}), 'ClipboardTaskListRtlRegular');

const ClipboardTextLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zm3 1a.5.5 0 010 1h-3a.5.5 0 010-1h3zm-5 5h7a.5.5 0 010 1h-7a.5.5 0 010-1zm0 3h3a.5.5 0 010 1h-3a.5.5 0 010-1zM6 14.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardTextLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLtrFilledIcon({}), 'ClipboardTextLtrFilled');

const ClipboardTextLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 8a.5.5 0 000 1h7a.5.5 0 000-1h-7zM6 11.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zm2-12c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3zm3 1a.5.5 0 010 1h-3a.5.5 0 010-1h3zm-6 1h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ClipboardTextLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLtrRegularIcon({}), 'ClipboardTextLtrRegular');

const ClipboardTextRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zm4.91.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zM10.5 11a.5.5 0 000 1h3a.5.5 0 000-1h-3zM6 8.5c0 .28.22.5.5.5h7a.5.5 0 000-1h-7a.5.5 0 00-.5.5zM8.5 14a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const ClipboardTextRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextRtlFilledIcon({}), 'ClipboardTextRtlFilled');

const ClipboardTextRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.5 11a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.5 14a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zm4.91.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zM7.09 4H5.5a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 01-1.41-1z",
    fill: primaryFill
  }));
};

export const ClipboardTextRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextRtlRegularIcon({}), 'ClipboardTextRtlRegular');

const ClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm-.5 3a.5.5 0 00-.5.5v5.09a.5.5 0 00.5.41h3.09a.5.5 0 00-.09-1H10V5.41A.5.5 0 009.5 5z",
    fill: primaryFill
  }));
};

export const ClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockFilledIcon({}), 'ClockFilled');

const ClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm-.5 2a.5.5 0 01.5.41V10h2.5a.5.5 0 01.09 1H9.5a.5.5 0 01-.5-.41V5.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockRegularIcon({}), 'ClockRegular');

const ClockAlarmFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.76 3.37A3.16 3.16 0 002 5.19c0 1.08.53 2.03 1.35 2.61a7 7 0 001.36 6.78l-1.56 1.57a.5.5 0 00.7.7l1.57-1.56a6.97 6.97 0 009.16 0l1.57 1.56a.5.5 0 00.7-.7l-1.56-1.57a6.97 6.97 0 001.35-6.8 3.17 3.17 0 10-4.41-4.42 7 7 0 00-4.47 0zM5.16 3c.66 0 1.25.3 1.65.77a7.03 7.03 0 00-3.06 3.07A2.2 2.2 0 015.17 3zm8.02.76A2.16 2.16 0 0117 5.18c0 .66-.3 1.25-.76 1.65a7.03 7.03 0 00-3.06-3.07zM9.5 6c.28 0 .5.22.5.5V10h2.5a.5.5 0 010 1h-3a.5.5 0 01-.5-.5v-4c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ClockAlarmFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockAlarmFilledIcon({}), 'ClockAlarmFilled');

const ClockAlarmRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5a.5.5 0 00-1 0v4c0 .28.22.5.5.5h3a.5.5 0 100-1H10V6.5zM3.35 7.8A3.19 3.19 0 015.17 2c1.07 0 2.02.54 2.6 1.37a7 7 0 014.46 0A3.16 3.16 0 0118 5.16c0 1.08-.54 2.04-1.36 2.61a7 7 0 01-1.35 6.8l1.56 1.57a.5.5 0 01-.7.7l-1.57-1.56a6.97 6.97 0 01-9.16 0l-1.57 1.56a.5.5 0 11-.7-.7l1.56-1.57A6.97 6.97 0 013.35 7.8zM3 5.19c0 .66.3 1.25.75 1.65a7.03 7.03 0 013.06-3.07C6.41 3.3 5.82 3 5.17 3 3.97 3 3 3.98 3 5.19zm13.24 1.64a2.17 2.17 0 10-3.06-3.07 7.03 7.03 0 013.06 3.07zM4 10a6 6 0 1012 0 6 6 0 00-12 0z",
    fill: primaryFill
  }));
};

export const ClockAlarmRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockAlarmRegularIcon({}), 'ClockAlarmRegular');

const ClockArrowDownloadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 17A7.5 7.5 0 103 9.6a5.5 5.5 0 017.4 7.4h.1zM11 5.5V9h2.5a.5.5 0 010 1h-3a.5.5 0 01-.5-.5v-4a.5.5 0 011 0zm-10 9a4.5 4.5 0 014-4.47v3.76l-.65-.64a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 00-.7-.7l-.65.64v-3.76a4.5 4.5 0 11-5 4.47zm2 2c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const ClockArrowDownloadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockArrowDownloadFilledIcon({}), 'ClockArrowDownloadFilled');

const ClockArrowDownloadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 9.5a7.5 7.5 0 117.4 7.5c.16-.32.3-.66.4-1A6.5 6.5 0 104 9.2c-.34.1-.68.24-1 .4v-.1zM10.5 5c.28 0 .5.22.5.5V9h2.5a.5.5 0 010 1h-3a.5.5 0 01-.5-.5v-4c0-.28.22-.5.5-.5zM5 10.03a4.5 4.5 0 101 0v3.76l.65-.64a.5.5 0 01.7.7l-1.5 1.5a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7l.65.64v-3.76zM3.5 16h4a.5.5 0 010 1h-4a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const ClockArrowDownloadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockArrowDownloadRegularIcon({}), 'ClockArrowDownloadRegular');

const ClockDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 1a8 8 0 11-.59 15.98 5.5 5.5 0 00-7.39-7.39L3 9a8 8 0 018-8zm-.5 3a.5.5 0 00-.5.5v5.09a.5.5 0 00.5.41h3.09a.5.5 0 00-.09-1H11V4.41a.5.5 0 00-.5-.41zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L5.5 13.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L6.21 14.5l1.14-1.15z",
    fill: primaryFill
  }));
};

export const ClockDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockDismissFilledIcon({}), 'ClockDismissFilled');

const ClockDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 1a8 8 0 11-.59 15.98c.16-.31.29-.64.38-.98H11a7 7 0 10-7-6.8c-.34.1-.67.23-.98.39L3 9a8 8 0 018-8zm-.5 3a.5.5 0 01.5.41V9h2.5a.5.5 0 01.09 1H10.5a.5.5 0 01-.5-.41V4.5c0-.28.22-.5.5-.5zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L5.5 13.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L6.21 14.5l1.14-1.15z",
    fill: primaryFill
  }));
};

export const ClockDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockDismissRegularIcon({}), 'ClockDismissRegular');

const ClockPauseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 17A7.5 7.5 0 103 9.6a5.5 5.5 0 017.4 7.4h.1zM11 5.41V9h2.5a.5.5 0 01.09 1H10.5a.5.5 0 01-.5-.41V5.5a.5.5 0 011-.09zm-1 9.09a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM4 12a.5.5 0 00-.5.5v4a.5.5 0 001 0v-4A.5.5 0 004 12zm3 0a.5.5 0 00-.5.5v4a.5.5 0 001 0v-4A.5.5 0 007 12z",
    fill: primaryFill
  }));
};

export const ClockPauseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockPauseFilledIcon({}), 'ClockPauseFilled');

const ClockPauseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.8 16A6.5 6.5 0 104 9.2c-.34.1-.68.24-1 .4v-.1a7.5 7.5 0 117.4 7.5c.16-.32.3-.66.4-1zm-5.3 3a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1-6.5v4a.5.5 0 01-1 0v-4a.5.5 0 011 0zm3 0v4a.5.5 0 01-1 0v-4a.5.5 0 011 0zm3-7.5a.5.5 0 01.5.41V9h2.5a.5.5 0 01.09 1H10.5a.5.5 0 01-.5-.41V5.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ClockPauseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockPauseRegularIcon({}), 'ClockPauseRegular');

const ClockToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 9c-.56 0-1.08.19-1.5.5a7.5 7.5 0 118 7.48V13.5a2.5 2.5 0 00-2.04-2.46A2.5 2.5 0 006.5 9h-2zm6-4a.5.5 0 00-.5.5v4.09a.5.5 0 00.5.41h3.09a.5.5 0 00-.09-1H11V5.41a.5.5 0 00-.5-.41zM3 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15H8v-.5a.5.5 0 00-1 0v.5H4v-.5a.5.5 0 00-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H3zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zM8 16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 011 17.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const ClockToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockToolboxFilledIcon({}), 'ClockToolboxFilled');

const ClockToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15.98a6.5 6.5 0 10-6.98-6.93c-.38.07-.73.23-1.02.45a7.5 7.5 0 118 7.48v-1zm0-10.57a.5.5 0 00-1 .09v4.09a.5.5 0 00.5.41h3.09a.5.5 0 00-.09-1H11V5.41zM3 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15H8v-.5a.5.5 0 00-1 0v.5H4v-.5a.5.5 0 00-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H3zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zM8 16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 011 17.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const ClockToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockToolboxRegularIcon({}), 'ClockToolboxRegular');

const ClosedCaptionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm1.4 3.24c.82-.41 1.8-.24 2.45.4a.5.5 0 01-.7.71 1.12 1.12 0 00-1.3-.22C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 11.7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76zm7.95.4a.5.5 0 01-.7.71 1.12 1.12 0 00-1.3-.22c-.41.21-.85.76-.85 1.87s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 01.7.7c-.65.65-1.63.82-2.45.41-.84-.42-1.4-1.37-1.4-2.76 0-1.39.56-2.34 1.4-2.76.82-.41 1.8-.24 2.45.4z",
    fill: primaryFill
  }));
};

export const ClosedCaptionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionFilledIcon({}), 'ClosedCaptionFilled');

const ClosedCaptionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.4 7.24c.82-.41 1.8-.24 2.45.4a.5.5 0 01-.7.71 1.12 1.12 0 00-1.3-.22C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 01.7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76zm7.95.4a2.12 2.12 0 00-2.45-.4c-.84.42-1.4 1.37-1.4 2.76 0 1.39.56 2.34 1.4 2.76.82.41 1.8.24 2.45-.4a.5.5 0 00-.7-.71c-.35.35-.87.43-1.3.22-.41-.21-.85-.76-.85-1.87s.44-1.66.85-1.87c.43-.21.95-.13 1.3.22a.5.5 0 00.7-.7zM2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7zm3-2a2 2 0 00-2 2v6c0 1.1.9 2 2 2h10a2 2 0 002-2V7a2 2 0 00-2-2H5z",
    fill: primaryFill
  }));
};

export const ClosedCaptionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionRegularIcon({}), 'ClosedCaptionRegular');

const ClosedCaptionOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l1.48 1.48A3 3 0 002 7v6a3 3 0 003 3h10l.28-.01 1.87 1.86a.5.5 0 00.7-.7l-1.48-1.48-3.7-3.7-1.05-1.05L10.5 9.8 8.94 8.23 7.77 7.06 4.72 4.01 2.85 2.15zm4.46 5.87c-.16 0-.31.04-.46.11C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 11.7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76l.1-.04.81.82zm3.42.59L6.13 4H15a3 3 0 013 3v6c0 .8-.31 1.52-.82 2.06l-5.64-5.64c.13-.73.48-1.12.8-1.29.44-.21.96-.13 1.3.22a.5.5 0 00.71-.7 2.12 2.12 0 00-2.45-.41c-.52.26-.93.72-1.17 1.37z",
    fill: primaryFill
  }));
};

export const ClosedCaptionOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionOffFilledIcon({}), 'ClosedCaptionOffFilled');

const ClosedCaptionOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l1.48 1.48A3 3 0 002 7v6a3 3 0 003 3h10l.28-.01 1.87 1.86a.5.5 0 00.7-.7l-1.48-1.48-.76-.77-2.93-2.93-1.06-1.05L10.5 9.8 8.94 8.23 7.77 7.06 4.72 4.01 2.85 2.15zM14.3 15H5a2 2 0 01-2-2V7a2 2 0 011.39-1.9l2.1 2.1-.09.04C5.56 7.66 5 8.61 5 10c0 1.39.56 2.34 1.4 2.76.82.41 1.8.24 2.45-.4a.5.5 0 10-.7-.71c-.35.35-.87.43-1.3.22C6.44 11.66 6 11.1 6 10s.44-1.66.85-1.87c.15-.07.3-.1.46-.11L14.3 15zm2.9.06l-.72-.7A2 2 0 0017 13V7a2 2 0 00-2-2H7.12l-1-1H15a3 3 0 013 3v6c0 .8-.31 1.52-.82 2.06zm-5.65-5.64l-.81-.81c.24-.65.65-1.11 1.17-1.37.82-.41 1.8-.24 2.45.4a.5.5 0 01-.7.71 1.12 1.12 0 00-1.3-.22c-.33.17-.68.56-.8 1.3z",
    fill: primaryFill
  }));
};

export const ClosedCaptionOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionOffRegularIcon({}), 'ClosedCaptionOffRegular');

const CloudFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0118 11.62 3.33 3.33 0 0114.72 15H5.28A3.33 3.33 0 012 11.62a3.33 3.33 0 013.28-3.37h.07C5.6 5.9 7.18 4 10 4z",
    fill: primaryFill
  }));
};

export const CloudFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudFilledIcon({}), 'CloudFilled');

const CloudRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0118 11.62 3.33 3.33 0 0114.72 15H5.28A3.33 3.33 0 012 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4zm0 1C7.89 5 6.55 6.32 6.35 8.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 11.62 2.33 2.33 0 005.28 14h9.44A2.33 2.33 0 0017 11.62a2.33 2.33 0 00-2.28-2.37h-.07a1 1 0 01-1-.9C13.45 6.32 12.11 5 10 5z",
    fill: primaryFill
  }));
};

export const CloudRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudRegularIcon({}), 'CloudRegular');

const CloudAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66A5.74 5.74 0 007.77 13H5.28A3.33 3.33 0 012 9.62a3.33 3.33 0 013.28-3.37h.07C5.6 3.9 7.18 2 10 2zm3.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V13h1.5a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0V14h-1.5a.5.5 0 010-1H13v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CloudAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudAddFilledIcon({}), 'CloudAddFilled');

const CloudAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 00-2.15-1.6h-.07a1 1 0 01-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 9.62 2.33 2.33 0 005.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 012 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2zm3.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V13h1.5a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0V14h-1.5a.5.5 0 010-1H13v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CloudAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudAddRegularIcon({}), 'CloudAddRegular');

const CloudArchiveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07c1.24 0 2.32.7 2.88 1.75H11a2 2 0 00-1 3.73V15H5.28A3.33 3.33 0 012 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4zm0 8a1 1 0 011-1h7a1 1 0 110 2h-7a1 1 0 01-1-1zm8 2h-7v3c0 1.1.9 2 2 2h3a2 2 0 002-2v-3zm-4.5 1h2a.5.5 0 010 1h-2a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const CloudArchiveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArchiveFilledIcon({}), 'CloudArchiveFilled');

const CloudArchiveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07c1.24 0 2.32.7 2.88 1.75h-1.21a2.24 2.24 0 00-1.67-.75h-.07a1 1 0 01-1-.9C13.45 6.32 12.11 5 10 5S6.55 6.32 6.35 8.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 11.62 2.33 2.33 0 005.28 14H10v1H5.28A3.33 3.33 0 012 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4zm0 8a1 1 0 011-1h7a1 1 0 110 2h-7a1 1 0 01-1-1zm8 2h-7v3c0 1.1.9 2 2 2h3a2 2 0 002-2v-3zm-4.5 1h2a.5.5 0 010 1h-2a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const CloudArchiveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArchiveRegularIcon({}), 'CloudArchiveRegular');

const CloudArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66A5.74 5.74 0 007.77 13H5.28A3.33 3.33 0 012 9.62a3.33 3.33 0 013.28-3.37h.07C5.6 3.9 7.18 2 10 2zm3.5 16a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.6-4.9L14 14.2v-2.7a.5.5 0 00-1 0v2.7l-1.1-1.1a.56.56 0 10-.8.8l2 2c.22.22.58.22.8 0l2-2a.56.56 0 10-.8-.8z",
    fill: primaryFill
  }));
};

export const CloudArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowDownFilledIcon({}), 'CloudArrowDownFilled');

const CloudArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 00-2.15-1.6h-.07a1 1 0 01-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 9.62 2.33 2.33 0 005.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 012 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2zm3.5 16a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.6-4.9L14 14.2v-2.7a.5.5 0 00-1 0v2.7l-1.1-1.1a.56.56 0 10-.8.8l2 2c.22.22.58.22.8 0l2-2a.56.56 0 10-.8-.8z",
    fill: primaryFill
  }));
};

export const CloudArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowDownRegularIcon({}), 'CloudArrowDownRegular');

const CloudArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66A5.74 5.74 0 007.77 13H5.28A3.33 3.33 0 012 9.62a3.33 3.33 0 013.28-3.37h.07C5.6 3.9 7.18 2 10 2zm3.5 7a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm1.6 4.9a.56.56 0 10.8-.8l-2-2a.56.56 0 00-.8 0l-2 2a.56.56 0 10.8.8l1.1-1.1v2.7a.5.5 0 001 0v-2.7l1.1 1.1z",
    fill: primaryFill
  }));
};

export const CloudArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowUpFilledIcon({}), 'CloudArrowUpFilled');

const CloudArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 00-2.15-1.6h-.07a1 1 0 01-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 9.62 2.33 2.33 0 005.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 012 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2zm3.5 7a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm1.6 4.9a.56.56 0 10.8-.8l-2-2a.56.56 0 00-.8 0l-2 2a.56.56 0 10.8.8l1.1-1.1v2.7a.5.5 0 001 0v-2.7l1.1 1.1z",
    fill: primaryFill
  }));
};

export const CloudArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowUpRegularIcon({}), 'CloudArrowUpRegular');

const CloudCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66A5.74 5.74 0 007.77 13H5.28A3.33 3.33 0 012 9.62a3.33 3.33 0 013.28-3.37h.07C5.6 3.9 7.18 2 10 2zm8 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CloudCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudCheckmarkFilledIcon({}), 'CloudCheckmarkFilled');

const CloudCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 00-2.15-1.6h-.07a1 1 0 01-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 9.62 2.33 2.33 0 005.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 012 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2zm8 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const CloudCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudCheckmarkRegularIcon({}), 'CloudCheckmarkRegular');

const CloudDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66A5.74 5.74 0 007.77 13H5.28A3.33 3.33 0 012 9.62a3.33 3.33 0 013.28-3.37h.07C5.6 3.9 7.18 2 10 2zm8 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const CloudDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudDismissFilledIcon({}), 'CloudDismissFilled');

const CloudDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 00-2.15-1.6h-.07a1 1 0 01-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 9.62 2.33 2.33 0 005.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 012 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2zm8 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const CloudDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudDismissRegularIcon({}), 'CloudDismissRegular');

const CloudEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25h-.07A3.33 3.33 0 002 11.62 3.33 3.33 0 005.28 15h3.2c.15-.5.42-.96.8-1.33l4.82-4.83c.25-.25.54-.45.85-.59H14.65zm.16 1.3l-4.83 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const CloudEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudEditFilledIcon({}), 'CloudEditFilled');

const CloudEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 002 11.62 3.33 3.33 0 005.28 15h3.2c.1-.36.28-.7.5-1h-3.7A2.33 2.33 0 013 11.62a2.33 2.33 0 012.28-2.37h.07a1 1 0 001-.9C6.55 6.32 7.89 5 10 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 00.32.63l.13-.14c.25-.25.54-.45.85-.59H14.65zm.16 1.3l-4.83 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const CloudEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudEditRegularIcon({}), 'CloudEditRegular');

const CloudFlowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0118 9.76 2.99 2.99 0 0013.17 11a2.5 2.5 0 00-2.32 1.7l-.1.3H5.28A3.33 3.33 0 012 9.62a3.33 3.33 0 013.28-3.37h.07C5.6 3.9 7.18 2 10 2zm6 12a2 2 0 10-2-2h-.78a1.5 1.5 0 00-1.42 1.03l-.55 1.63a.5.5 0 01-.47.34H9.73a2 2 0 10.27 1h.78a1.5 1.5 0 001.42-1.03l.55-1.63a.5.5 0 01.47-.34h1.05c.34.6.99 1 1.73 1zm0-1a1 1 0 110-2 1 1 0 010 2zm-7 3a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const CloudFlowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudFlowFilledIcon({}), 'CloudFlowFilled');

const CloudFlowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0118 9.76a3 3 0 00-1.04-.6 2.3 2.3 0 00-2.24-1.91h-.07a1 1 0 01-1-.9C13.45 4.32 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 9.62 2.33 2.33 0 005.28 12h5.94a2.5 2.5 0 00-.37.7l-.1.3H5.28A3.33 3.33 0 012 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2zm6.93 8.23A2.01 2.01 0 0118 12a2 2 0 01-3.73 1h-1.05a.5.5 0 00-.47.34l-.55 1.63A1.5 1.5 0 0110.78 16H10a2 2 0 11-.27-1h1.05a.5.5 0 00.47-.34l.55-1.63a1.94 1.94 0 01.1-.22c.25-.5.76-.81 1.32-.81H14a2 2 0 012.93-1.77zm-.44.9a1 1 0 00-1.49.86V12a1 1 0 002 .01V12a1 1 0 00-.51-.87zM9 16a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const CloudFlowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudFlowRegularIcon({}), 'CloudFlowRegular');

const CloudLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25h-.07A3.33 3.33 0 002 11.62 3.33 3.33 0 005.28 15h3.76a3.5 3.5 0 013.46-4h4c.53 0 1.04.12 1.49.33a3.32 3.32 0 00-3.27-3.08h-.07zM12.5 12a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-3.5 2a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const CloudLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudLinkFilledIcon({}), 'CloudLinkFilled');

const CloudLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 002 11.62 3.33 3.33 0 005.28 15h4.06a3.48 3.48 0 01-.3-1H5.28A2.33 2.33 0 013 11.62a2.33 2.33 0 012.28-2.37h.07a1 1 0 001-.9C6.55 6.32 7.89 5 10 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 001 .9h.07c.65 0 1.25.29 1.67.75h.11c.42 0 .83.07 1.2.21a3.28 3.28 0 00-2.98-1.96h-.07zM12.5 11a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-3.5 2a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const CloudLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudLinkRegularIcon({}), 'CloudLinkRegular');

const CloudOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l3.67 3.67c-.25.53-.4 1.11-.47 1.73h-.07A3.33 3.33 0 002 11.62 3.33 3.33 0 005.28 15h9.01l2.86 2.85a.5.5 0 00.7-.7l-15-15zM18 11.62a3.4 3.4 0 01-1.45 2.8l-9.5-9.48A4.66 4.66 0 0110 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0118 11.62z",
    fill: primaryFill
  }));
};

export const CloudOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudOffFilledIcon({}), 'CloudOffFilled');

const CloudOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l3.67 3.67c-.25.53-.4 1.11-.47 1.73H5.1A3.34 3.34 0 002 11.62 3.33 3.33 0 005.28 15h9.01l2.86 2.85a.5.5 0 00.7-.7l-15-15zM13.3 14h-8A2.33 2.33 0 013 11.62a2.33 2.33 0 012.28-2.37h.07a1 1 0 001-.9c.04-.38.11-.74.23-1.06L13.29 14zM17 11.62c0 .9-.48 1.68-1.18 2.08l.73.73a3.4 3.4 0 001.45-2.8 3.33 3.33 0 00-3.28-3.38h-.07C14.4 5.92 12.82 4 10 4c-1.2 0-2.2.35-2.94.94l.71.71A3.76 3.76 0 0110 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 001 .9h.07A2.33 2.33 0 0117 11.62z",
    fill: primaryFill
  }));
};

export const CloudOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudOffRegularIcon({}), 'CloudOffRegular');

const CloudSwapFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 002 11.62 3.33 3.33 0 005.28 15h2.8a1.5 1.5 0 01.36-1.56l2-2A1.5 1.5 0 0112.9 13h1.18a1.5 1.5 0 012.47-1.56l1.27 1.27c.1-.34.17-.7.17-1.09a3.33 3.33 0 00-3.28-3.37h-.07zm-2.8 4.6a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L10.71 15h5.58l-1.14 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7L16.29 14h-5.58l1.14-1.15z",
    fill: primaryFill
  }));
};

export const CloudSwapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSwapFilledIcon({}), 'CloudSwapFilled');

const CloudSwapRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0118 11.62c0 .38-.06.75-.17 1.09l-.84-.84.01-.25a2.33 2.33 0 00-2.28-2.37h-.07a1 1 0 01-1-.9C13.45 6.32 12.11 5 10 5S6.55 6.32 6.35 8.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 11.62 2.33 2.33 0 005.28 14h2.8a1.5 1.5 0 000 1h-2.8A3.33 3.33 0 012 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4zm1.85 8.85a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L10.71 15h5.58l-1.14 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7L16.29 14h-5.58l1.14-1.15z",
    fill: primaryFill
  }));
};

export const CloudSwapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSwapRegularIcon({}), 'CloudSwapRegular');

const CloudSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66A5.74 5.74 0 007.77 13H5.28A3.33 3.33 0 012 9.62a3.33 3.33 0 013.28-3.37h.07C5.6 3.9 7.18 2 10 2zM9 13.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H14a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V11c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V16a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H13a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CloudSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSyncFilledIcon({}), 'CloudSyncFilled');

const CloudSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 013.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 00-2.15-1.6h-.07a1 1 0 01-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 01-1 .9h-.07A2.33 2.33 0 003 9.62 2.33 2.33 0 005.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 012 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2zM9 13.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H14a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V11c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V16a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H13a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CloudSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSyncRegularIcon({}), 'CloudSyncRegular');

const CloudWordsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 002 11.62 3.33 3.33 0 005.28 15h9.44A3.33 3.33 0 0018 11.62a3.33 3.33 0 00-3.28-3.37h-.07zM8.5 7h3a.5.5 0 010 1h-3a.5.5 0 010-1zM4 11.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm7.5-.5h4a.5.5 0 010 1h-4a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const CloudWordsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudWordsFilledIcon({}), 'CloudWordsFilled');

const CloudWordsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 7a.5.5 0 000 1h3a.5.5 0 000-1h-3zM4 11.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm7.5-.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm3.15-2.75C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 002 11.62 3.33 3.33 0 005.28 15h9.44A3.33 3.33 0 0018 11.62a3.33 3.33 0 00-3.28-3.37h-.07zm-8.3.1C6.55 6.32 7.89 5 10 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 001 .9h.07A2.33 2.33 0 0117 11.62 2.33 2.33 0 0114.72 14H5.28A2.33 2.33 0 013 11.62a2.33 2.33 0 012.28-2.37h.07a1 1 0 001-.9z",
    fill: primaryFill
  }));
};

export const CloudWordsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudWordsRegularIcon({}), 'CloudWordsRegular');

const CodeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.94 4.05a.75.75 0 00-1.38-.6l-5.5 12.5a.75.75 0 101.38.6l5.5-12.5zm1.35 9.8a.75.75 0 01-.13-1.06L16.3 10l-2.14-2.8a.75.75 0 011.18-.9l2.5 3.24c.21.27.21.65 0 .92l-2.5 3.25a.75.75 0 01-1.05.13zm-8.58-7.7c.33.26.39.73.13 1.06L3.7 10l2.14 2.8a.75.75 0 11-1.18.9l-2.5-3.24a.75.75 0 010-.92l2.5-3.25a.75.75 0 011.05-.13z",
    fill: primaryFill
  }));
};

export const CodeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeFilledIcon({}), 'CodeFilled');

const CodeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.97 3.68a.5.5 0 00-.94-.36l-5 13a.5.5 0 10.94.36l5-13zM5.83 6.12c.2.18.23.5.05.7L3.16 10l2.72 3.17a.5.5 0 01-.76.66l-3-3.5a.5.5 0 010-.66l3-3.5a.5.5 0 01.7-.05zm8.34 8.26a.5.5 0 01-.05-.7l2.72-3.18-2.72-3.17a.5.5 0 11.76-.66l3 3.5a.5.5 0 010 .66l-3 3.5a.5.5 0 01-.7.05z",
    fill: primaryFill
  }));
};

export const CodeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeRegularIcon({}), 'CodeRegular');

const CodeCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm9.96-3.8a.5.5 0 10-.92-.4l-3.5 8a.5.5 0 10.92.4l3.5-8zm-5.1 1.45a.5.5 0 00-.71 0l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L5.21 10l1.64-1.65a.5.5 0 000-.7zm6.29.7L14.79 10l-1.64 1.65a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7z",
    fill: primaryFill
  }));
};

export const CodeCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeCircleFilledIcon({}), 'CodeCircleFilled');

const CodeCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.96 6.2a.5.5 0 10-.92-.4l-3.5 8a.5.5 0 10.92.4l3.5-8zm-5.1 1.45c.19.2.19.5 0 .7L5.2 10l1.64 1.65a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2c.2-.2.5-.2.7 0zm6.29.7a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L14.79 10l-1.64-1.65zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const CodeCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeCircleRegularIcon({}), 'CodeCircleRegular');

const CodeTextFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 4.5a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5zm3 3a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM4 11.25c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5a.75.75 0 01-.75-.75zM2.75 13.5a.75.75 0 000 1.5h8a.75.75 0 000-1.5h-8zm9.75-5.25c0-.41.34-.75.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zM10.75 4.5a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z",
    fill: primaryFill
  }));
};

export const CodeTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextFilledIcon({}), 'CodeTextFilled');

const CodeTextRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1H8a.5.5 0 000-1H2.5zm3 3a.5.5 0 000 1h5a.5.5 0 000-1h-5zM4 11.5c0-.28.22-.5.5-.5h10a.5.5 0 010 1h-10a.5.5 0 01-.5-.5zM2.5 14a.5.5 0 000 1H11a.5.5 0 000-1H2.5zm10-5.5c0-.28.22-.5.5-.5h3.5a.5.5 0 010 1H13a.5.5 0 01-.5-.5zm-2-3.5a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const CodeTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextRegularIcon({}), 'CodeTextRegular');

const CodeTextEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 4.5a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5zm3 3a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM4 11.25c0-.41.34-.75.75-.75h9.5c.06 0 .12 0 .17.02L12.94 12H4.75a.75.75 0 01-.75-.75zm6.27 3.42l.98-.98a.75.75 0 00-.5-.19h-8a.75.75 0 000 1.5h7.24c.08-.12.18-.23.28-.33zm2.23-6.42c0-.41.34-.75.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zM10.75 4.5a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5zm.23 10.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const CodeTextEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextEditFilledIcon({}), 'CodeTextEditFilled');

const CodeTextEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1H8a.5.5 0 000-1H2.5zm3 3a.5.5 0 000 1h5a.5.5 0 000-1h-5zM4 11.5c0-.28.22-.5.5-.5h9.44l-1 1H4.5a.5.5 0 01-.5-.5zm6.27 3.17l.67-.67H2.5a.5.5 0 000 1h7.49c.08-.12.18-.23.28-.33zM12.5 8.5c0-.28.22-.5.5-.5h3.5a.5.5 0 010 1H13a.5.5 0 01-.5-.5zm-2-3.5a.5.5 0 000 1H17a.5.5 0 000-1h-6.5zm.48 10.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const CodeTextEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextEditRegularIcon({}), 'CodeTextEditRegular');

const CollectionsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0118 9.33v6.17a2.5 2.5 0 01-2.33 2.5H9.5A2.5 2.5 0 017 15.66V9.5A2.5 2.5 0 019.34 7h6.16zm-3 2a.5.5 0 00-.5.4V12H9.41a.5.5 0 000 1H12v2.59a.5.5 0 001 0v-2.6h2.6a.5.5 0 000-.98l-.1-.01H13V9.4a.5.5 0 00-.5-.4zm.16-5.3l.05.15L13.3 6H9a3 3 0 00-3 2.82V14.35a2.5 2.5 0 01-2.3-1.69l-.06-.17-1.55-5.8a2.5 2.5 0 011.6-3l.16-.05 5.8-1.56a2.5 2.5 0 012.96 1.46l.05.15z",
    fill: primaryFill
  }));
};

export const CollectionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsFilledIcon({}), 'CollectionsFilled');

const CollectionsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0118 9.33v6.17a2.5 2.5 0 01-2.33 2.5H9.5A2.5 2.5 0 017 15.66V9.5A2.5 2.5 0 019.34 7h6.16zm0 1h-6c-.78 0-1.42.6-1.5 1.35v6.15c0 .78.6 1.42 1.36 1.5h6.14c.78 0 1.42-.6 1.5-1.36V9.5c0-.78-.6-1.42-1.35-1.5h-.15zm-3 1a.5.5 0 01.5.4V12h2.5a.5.5 0 01.1 1H13v2.5a.5.5 0 01-1 .09v-2.6H9.5a.5.5 0 01-.09-.98l.1-.01H12V9.5c0-.28.22-.5.5-.5zm.16-5.3l.05.15L13.3 6h-1.04l-.5-1.89a1.5 1.5 0 00-1.7-1.1l-.14.04L4.1 4.6a1.5 1.5 0 00-1.09 1.7l.03.14 1.55 5.8a1.5 1.5 0 001.4 1.1v1a2.5 2.5 0 01-2.3-1.68l-.06-.17-1.55-5.8a2.5 2.5 0 011.6-3l.16-.05 5.8-1.56a2.5 2.5 0 012.96 1.46l.05.15z",
    fill: primaryFill
  }));
};

export const CollectionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsRegularIcon({}), 'CollectionsRegular');

const CollectionsAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0118 9.33v.93A5.5 5.5 0 0010.26 18H9.5A2.5 2.5 0 017 15.66V9.5A2.5 2.5 0 019.33 7h6.17zm-2.84-3.3l.05.15.57 2.15H9a3 3 0 00-3 2.82V14.35a2.5 2.5 0 01-2.31-1.69l-.05-.17-1.56-5.8a2.5 2.5 0 011.61-3l.16-.05 5.8-1.56a2.5 2.5 0 012.95 1.46l.06.15zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 100 1H14v1.5a.5.5 0 101 0V15h1.5a.5.5 0 100-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CollectionsAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsAddFilledIcon({}), 'CollectionsAddFilled');

const CollectionsAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0118 9.33v.93c-.3-.26-.64-.48-1-.66v-.1c0-.78-.6-1.42-1.36-1.5H9.5c-.78 0-1.42.6-1.5 1.35v6.15c0 .78.6 1.42 1.35 1.5h.25c.18.36.4.7.66 1H9.5A2.5 2.5 0 017 15.66V9.5A2.5 2.5 0 019.33 7h6.17zm-2.84-3.3l.05.15.57 2.15h-1.03l-.5-1.89a1.5 1.5 0 00-1.7-1.1l-.14.04L4.1 4.6a1.5 1.5 0 00-1.1 1.7l.04.14 1.55 5.8a1.5 1.5 0 001.4 1.1v1a2.5 2.5 0 01-2.31-1.68l-.05-.17-1.56-5.8a2.5 2.5 0 011.61-3l.16-.05 5.8-1.56a2.5 2.5 0 012.95 1.46l.06.15zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 100 1H14v1.5a.5.5 0 101 0V15h1.5a.5.5 0 100-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CollectionsAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsAddRegularIcon({}), 'CollectionsAddRegular');

const ColorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.77 3.17a7.82 7.82 0 017.93-.18c3.97 2.04 5.5 6.16 4.18 10.44a7.46 7.46 0 01-2.37 3.59 4.32 4.32 0 01-4.2.8 3.84 3.84 0 01-2.2-1.68c-.41-.7-.53-1.47-.58-2.14l-.04-.58-.02-.37c-.02-.3-.05-.55-.1-.76a1.16 1.16 0 00-.2-.47.75.75 0 00-.4-.24 1.86 1.86 0 00-1.15-.04c-.25.08-.45.2-.69.35l-.2.12c-.31.18-.72.4-1.23.37a2.91 2.91 0 01-1.66-.77 2.63 2.63 0 01-.94-2.12c0-.79.25-1.63.62-2.43a9.6 9.6 0 013.25-3.9zm3.98 3.58a1 1 0 100-2 1 1 0 000 2zm3 1a1 1 0 100-2 1 1 0 000 2zM15.5 9a1 1 0 10-2 0 1 1 0 002 0zm-1 4a1 1 0 100-2 1 1 0 000 2zm-1 1a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const ColorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFilledIcon({}), 'ColorFilled');

const ColorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.75 6.5a.75.75 0 100-1.5.75.75 0 000 1.5zm3 1a.75.75 0 100-1.5.75.75 0 000 1.5zm2.5 1.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zM13.25 14a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm.45-11a7.82 7.82 0 00-7.93.17 9.6 9.6 0 00-3.25 3.89 5.9 5.9 0 00-.62 2.43c0 .8.27 1.57.94 2.12.61.5 1.14.74 1.66.77.51.02.92-.19 1.23-.37l.2-.12c.24-.15.44-.27.69-.35.28-.09.64-.12 1.16.04.19.06.3.14.38.24.09.1.16.26.2.47.06.21.09.46.1.76.02.1.02.24.03.37l.04.58c.05.67.17 1.44.57 2.14.42.7 1.1 1.3 2.2 1.68 1.6.54 3.07.1 4.21-.8a7.46 7.46 0 002.37-3.6C19.2 9.16 17.68 5.04 13.7 3zM6.3 4.01a6.82 6.82 0 016.94-.14c3.5 1.8 4.87 5.4 3.69 9.25a6.46 6.46 0 01-2.04 3.1 3.33 3.33 0 01-3.26.64c-.9-.3-1.38-.76-1.66-1.24a4 4 0 01-.44-1.7l-.04-.54-.02-.41c-.03-.31-.06-.63-.13-.93-.07-.3-.2-.6-.4-.86-.22-.26-.5-.46-.87-.57a2.85 2.85 0 00-1.75-.03c-.38.12-.7.32-.95.47l-.14.09c-.29.16-.48.24-.68.23-.22-.01-.55-.12-1.08-.55-.38-.31-.57-.76-.57-1.34 0-.6.19-1.29.52-2.01A8.63 8.63 0 016.3 4.02z",
    fill: primaryFill
  }));
};

export const ColorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorRegularIcon({}), 'ColorRegular');

const ColorBackgroundFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10.66l1.08 1.08a3 3 0 004.24 0l.68-.68c.03 1.34.96 2.94 2.75 2.94 1.82 0 2.75-1.65 2.75-3 0-1.01-.53-1.96-.86-2.47-.2-.3-.38-.55-.52-.72l-.01-.02-.22-.26-.02-.03a1.5 1.5 0 00-.85-.48 3 3 0 00-.87-2.35L9.48 4h6.02A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5v-2.84zM5 1.5a.5.5 0 011 0v1.17a2 2 0 011.32.59l2.12 2.12a2 2 0 010 2.83l-2.83 2.83a2 2 0 01-2.82 0L1.66 8.9a2 2 0 010-2.82L4.5 3.26A2 2 0 015 2.89V1.5zm0 4V4.16L2.66 6.5h6.32a1 1 0 00-.25-.41L6.61 3.96A1 1 0 006 3.68V5.5a.5.5 0 01-1 0zm-2.92 2c0 .26.1.51.3.7l2.11 2.13a1 1 0 001.42 0L8.73 7.5H2.08zm8.3.67l-.22.26c-.12.15-.29.38-.46.64C9.4 9.57 9 10.3 9 11c0 1 .67 2 1.75 2s1.75-1 1.75-2c0-.7-.39-1.44-.7-1.93a8.13 8.13 0 00-.46-.64l-.22-.26a.5.5 0 00-.74 0zm.17 1.44c.06-.11.13-.21.2-.3l.2.3c.31.47.55 1 .55 1.39 0 .3-.1.57-.25.75a.62.62 0 01-.5.25.62.62 0 01-.5-.25A1.21 1.21 0 0110 11c0-.4.24-.92.55-1.4z",
    fill: primaryFill
  }));
};

export const ColorBackgroundFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorBackgroundFilledIcon({}), 'ColorBackgroundFilled');

const ColorBackgroundRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10.66v2.84A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4H9.48l.67.67c.1.1.2.22.28.33h5.07c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 13.5v-1.84l-1-1zM5 1.5a.5.5 0 011 0v1.17a2 2 0 011.32.59l2.12 2.12a2 2 0 010 2.83l-2.83 2.83a2 2 0 01-2.82 0L1.66 8.9a2 2 0 010-2.82L4.5 3.26A2 2 0 015 2.89V1.5zm0 4V4.16L2.66 6.5h6.32a1 1 0 00-.25-.41L6.61 3.96A1 1 0 006 3.68V5.5a.5.5 0 01-1 0zm-2.92 2c0 .26.1.51.3.7l2.11 2.13a1 1 0 001.42 0L8.73 7.5H2.08zm8.08.93l.22-.26a.5.5 0 01.74 0l.22.26c.12.15.29.38.46.64.31.5.7 1.23.7 1.93 0 1-.67 2-1.75 2S9 12 9 11c0-.7.39-1.44.7-1.93.17-.26.34-.49.46-.64zm.59.88c-.07.09-.14.19-.2.3-.31.47-.55 1-.55 1.39 0 .3.1.57.25.75.13.17.3.25.5.25s.37-.08.5-.25c.15-.18.25-.46.25-.75 0-.4-.24-.92-.55-1.4l-.2-.3z",
    fill: primaryFill
  }));
};

export const ColorBackgroundRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorBackgroundRegularIcon({}), 'ColorBackgroundRegular');

const ColorBackgroundAccentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 11.41l.33.33a3 3 0 004.24 0l.68-.68c.03 1.34.96 2.94 2.75 2.94 1.82 0 2.75-1.65 2.75-3 0-1.01-.53-1.96-.86-2.47-.2-.3-.38-.55-.52-.72V7.8l-.24-.29h-.01a1.5 1.5 0 00-.85-.49 3 3 0 00-.8-2.27h5.28c.97 0 1.75.78 1.75 1.75v7c0 .97-.78 1.75-1.75 1.75h-11c-.97 0-1.75-.78-1.75-1.75v-2.09z",
    fill: primaryFill
  }));
};

export const ColorBackgroundAccentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorBackgroundAccentRegularIcon({}), 'ColorBackgroundAccentRegular');

const ColorFillFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 12c0 1.35.93 3 2.75 3 1.55 0 2.46-1.2 2.69-2.39A2 2 0 0118 14v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2c0-1.1.9-2 2-2h.34l1.45 1.45a3 3 0 004.24 0L11.48 12H12zm2.38-2.83l-.22.26c-.12.15-.29.38-.46.64-.31.5-.7 1.23-.7 1.93 0 1 .67 2 1.75 2s1.75-1 1.75-2c0-.7-.39-1.44-.7-1.93a8.13 8.13 0 00-.46-.64l-.21-.25-.02-.02a.47.47 0 00-.36-.16.5.5 0 00-.37.17zm.37 1.14l.2.3c.31.47.55 1 .55 1.39 0 .3-.1.57-.25.75a.62.62 0 01-.5.25.62.62 0 01-.5-.25A1.21 1.21 0 0114 12c0-.4.24-.92.55-1.4l.2-.3zM8.5 1a.5.5 0 00-.5.5v1.56a2 2 0 00-.8.49L3.66 7.09a2 2 0 000 2.82l2.83 2.83a2 2 0 002.83 0l3.54-3.53a2 2 0 000-2.83l-2.83-2.83A2 2 0 009 3V1.5a.5.5 0 00-.5-.5zM8 4.17V5.5a.5.5 0 001 0V4.04a1 1 0 01.32.22l2.83 2.83a1 1 0 01.25.41H4.66l3.25-3.24.09-.08zM4.37 9.21a1 1 0 01-.3-.71h8.08l-3.54 3.54a1 1 0 01-1.41 0L4.37 9.2zm10-.04z",
    fill: primaryFill
  }));
};

export const ColorFillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFillFilledIcon({}), 'ColorFillFilled');

const ColorFillRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.34 12H4a2 2 0 00-2 2v2c0 1.1.9 2 2 2h12a2 2 0 002-2v-2a2 2 0 00-.56-1.39c-.08.4-.23.8-.47 1.16A1 1 0 0117 14v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h1.34l-1-1zm10.04-2.83l-.22.26c-.12.15-.29.38-.46.64-.31.5-.7 1.23-.7 1.93 0 1 .67 2 1.75 2s1.75-1 1.75-2c0-.7-.39-1.44-.7-1.93a8.13 8.13 0 00-.46-.64l-.21-.25-.02-.02a.47.47 0 00-.36-.16.5.5 0 00-.37.17zm.37 1.14l.2.3c.31.47.55 1 .55 1.39 0 .3-.1.57-.25.75a.62.62 0 01-.5.25.62.62 0 01-.5-.25A1.21 1.21 0 0114 12c0-.4.24-.92.55-1.4l.2-.3zM8.5 1a.5.5 0 00-.5.5v1.56a2 2 0 00-.8.49L3.66 7.09a2 2 0 000 2.82l2.83 2.83a2 2 0 002.83 0l3.54-3.53a2 2 0 000-2.83l-2.83-2.83A2 2 0 009 3V1.5a.5.5 0 00-.5-.5zM8 4.17V5.5a.5.5 0 001 0V4.04a1 1 0 01.32.22l2.83 2.83a1 1 0 01.25.41H4.66l3.25-3.24.09-.08zM4.37 9.21a1 1 0 01-.3-.71h8.08l-3.54 3.54a1 1 0 01-1.41 0L4.37 9.2zm10-.04z",
    fill: primaryFill
  }));
};

export const ColorFillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFillRegularIcon({}), 'ColorFillRegular');

const ColorFillAccentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.84 12.5H4c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5v-2c0-.3-.09-.57-.23-.8a2.67 2.67 0 01-2.52 1.8c-1.6 0-2.51-1.27-2.7-2.5h-1.07l-.95.95a3 3 0 01-4.24 0l-.95-.95z",
    fill: primaryFill
  }));
};

export const ColorFillAccentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFillAccentRegularIcon({}), 'ColorFillAccentRegular');

const ColorLineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.24 2.54a2.26 2.26 0 00-3.07.13L6.21 8.66l-.11.12a1.5 1.5 0 00-.28.56l-.8 3.08-.01.08a.5.5 0 00.62.53l3.08-.76.16-.05c.2-.08.4-.2.55-.35l5.96-6 .12-.12c.72-.85.72-2.1 0-2.95l-.13-.14-.13-.12zM4.1 12H4a2 2 0 00-2 2v2c0 1.1.9 2 2 2h12a2 2 0 002-2v-2a2 2 0 00-2-2h-5.3l-.57.57a2.5 2.5 0 01-.92.59H9.2l-.21.07-3.11.77A1.5 1.5 0 014 12.4v-.04l.04-.16.05-.21z",
    fill: primaryFill
  }));
};

export const ColorLineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorLineFilledIcon({}), 'ColorLineFilled');

const ColorLineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.1 12H4a2 2 0 00-2 2v2c0 1.1.9 2 2 2h12a2 2 0 002-2v-2a2 2 0 00-2-2h-5.3l-.57.57a2.5 2.5 0 01-.57.43H16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h.08A1.48 1.48 0 014 12.4v-.04l.04-.17.05-.2zm8.07-9.38a2.26 2.26 0 013.07-.13l.13.12.13.14c.72.85.72 2.1 0 2.95l-.12.13-5.96 6a1.5 1.5 0 01-.55.34l-.16.05-3.08.76a.5.5 0 01-.62-.53l.01-.08.8-3.07c.05-.2.15-.4.28-.57l.1-.11 5.97-6zm2.5.7a1.26 1.26 0 00-1.69-.09l-.1.1-5.97 6a.5.5 0 00-.1.14l-.03.08-.58 2.26 2.27-.56a.5.5 0 00.12-.04l.05-.03.07-.06 5.96-6c.5-.49.5-1.3 0-1.8z",
    fill: primaryFill
  }));
};

export const ColorLineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorLineRegularIcon({}), 'ColorLineRegular');

const ColorLineAccentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.1 13a1.5 1.5 0 001.77.95l3.1-.76.22-.07h.02l.26-.12H16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h.1z",
    fill: primaryFill
  }));
};

export const ColorLineAccentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorLineAccentRegularIcon({}), 'ColorLineAccentRegular');

const ColumnFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 17a.5.5 0 100-1H16a1 1 0 01-1-1V5a1 1 0 011-1h.5a.5.5 0 000-1H16a2 2 0 00-2 2v10c0 1.1.9 2 2 2h.5zM7 5c0-1.1.9-2 2-2h2a2 2 0 012 2v10a2 2 0 01-2 2H9a2 2 0 01-2-2V5zM4 17a2 2 0 002-2V5a2 2 0 00-2-2h-.5a.5.5 0 000 1H4a1 1 0 011 1v10.1a1 1 0 01-1 .9h-.5a.5.5 0 100 1H4z",
    fill: primaryFill
  }));
};

export const ColumnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnFilledIcon({}), 'ColumnFilled');

const ColumnRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 17a.5.5 0 100-1H16a1 1 0 01-1-1V5a1 1 0 011-1h.5a.5.5 0 000-1H16a2 2 0 00-2 2v10c0 1.1.9 2 2 2h.5zM7 5c0-1.1.9-2 2-2h2a2 2 0 012 2v10a2 2 0 01-2 2H9a2 2 0 01-2-2V5zm5 10V5a1 1 0 00-1-1H9a1 1 0 00-1 1v10a1 1 0 001 1h2a1 1 0 001-1zm-8 2a2 2 0 002-2V5a2 2 0 00-2-2h-.5a.5.5 0 000 1H4a1 1 0 011 1v10.1a1 1 0 01-1 .9h-.5a.5.5 0 100 1H4z",
    fill: primaryFill
  }));
};

export const ColumnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnRegularIcon({}), 'ColumnRegular');

const ColumnArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h1a2 2 0 012 2v3.75H5.75a1.75 1.75 0 100 3.5H7V15a2 2 0 01-2 2H4a2 2 0 01-2-2V4zm13-2a2 2 0 00-2 2v11c0 1.1.9 2 2 2h1a2 2 0 002-2V4a2 2 0 00-2-2h-1zM8.97 6.97c.3-.3.77-.3 1.06 0l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 11-1.06-1.06l.72-.72H5.5a.75.75 0 010-1.5h4.19l-.72-.72a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const ColumnArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnArrowRightFilledIcon({}), 'ColumnArrowRightFilled');

const ColumnArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3h1a1 1 0 011 1v4h1V4a2 2 0 00-2-2H4a2 2 0 00-2 2v11c0 1.1.9 2 2 2h1a2 2 0 002-2v-4H6v4a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm11-1a2 2 0 00-2 2v11c0 1.1.9 2 2 2h1a2 2 0 002-2V4a2 2 0 00-2-2h-1zm1 1a1 1 0 011 1v11a1 1 0 01-1 1h-1a1 1 0 01-1-1V4a1 1 0 011-1h1zM9.15 7.15c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L10.29 10H5.5a.5.5 0 010-1h4.8L9.14 7.85a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const ColumnArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnArrowRightRegularIcon({}), 'ColumnArrowRightRegular');

const ColumnEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5H4a2 2 0 012 2v10a2 2 0 01-2 2h-.5a.5.5 0 010-1H4a1 1 0 001-1V5a1 1 0 00-1-1h-.5a.5.5 0 01-.5-.5zM9 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h.22l.21-.84a3.2 3.2 0 01.84-1.49L13 11.94V5a2 2 0 00-2-2H9zm6 2v4.94l-1 1V5c0-1.1.9-2 2-2h.5a.5.5 0 010 1H16a1 1 0 00-1 1zm-4.02 10.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const ColumnEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnEditFilledIcon({}), 'ColumnEditFilled');